var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/builder/helper/join.ts
function join(...args) {
  const [table, first, operator, second, joinType] = args;
  const formattedTable = typeof table === "string" ? { type: "table", name: table } : __spreadValues({ type: "table" }, table);
  return {
    type: "join",
    joinType: joinType || "JOIN",
    table: formattedTable,
    on: {
      type: "expression",
      left: { type: "expression", left: first },
      operator: operator || "=",
      right: { type: "expression", left: second }
    }
  };
}
function leftJoin(...args) {
  const [table, first, operator, second] = args;
  return join(table, first, operator, second, "LEFT");
}
function rightJoin(...args) {
  const [table, first, operator, second] = args;
  return join(table, first, operator, second, "RIGHT");
}
function fullJoin(...args) {
  const [table, first, operator, second] = args;
  return join(table, first, operator, second, "FULL");
}
function crossJoin(...args) {
  const [table, first, operator, second] = args;
  return join(table, first, operator, second, "CROSS");
}
function innerJoin(...args) {
  const [table, first, operator, second] = args;
  return join(table, first, operator, second, "INNER");
}
function joinWhere(...args) {
  const [table, first, operator, second, joinType] = args;
  return join(table, first, operator, second, joinType, true);
}

// src/builder/helper/select.ts
function select(...args) {
  return args.map((arg) => {
    if (isSelectNode(arg)) return arg;
    const val = typeof arg === "string" ? arg : arg.name;
    const alias = typeof arg === "string" ? void 0 : arg.alias;
    return {
      type: "select",
      expression: { type: "expression", left: val },
      alias
    };
  });
}
function isSelectNode(arg) {
  return arg.type === "select";
}

// src/builder/helper/where.ts
function valueWrapper(value) {
  if (Array.isArray(value)) {
    return `(${value.map(valueWrapper).join(",")})`;
  }
  if (typeof value === "string") {
    return `'${value}'`;
  }
  return value;
}
function conditions(conditions2, booleanOperator = "AND") {
  if (conditions2.length === 1) {
    const { column, operator, value } = conditions2[0];
    return {
      type: "expression",
      left: { type: "expression", left: column },
      operator,
      right: { type: "expression", left: valueWrapper(value) }
    };
  }
  return conditions2.slice(1).reduce(
    (acc, condition) => {
      const { column, operator, value } = condition;
      const newCondition = {
        type: "expression",
        left: { type: "expression", left: column },
        operator,
        right: {
          type: "expression",
          left: valueWrapper(value)
        }
      };
      return {
        type: "expression",
        left: acc,
        operator: booleanOperator,
        right: newCondition
      };
    },
    {
      type: "expression",
      left: { type: "expression", left: conditions2[0].column },
      operator: conditions2[0].operator,
      right: {
        type: "expression",
        left: valueWrapper(conditions2[0].value)
      }
    }
  );
}
function validConditions(conditions2) {
  return conditions2.filter(
    (condition) => typeof condition.right == "object" && condition.right.type == "expression" ? condition.right.left != "()" : true
  );
}
function where(conditions2, operator = "AND") {
  conditions2 = Array.isArray(conditions2) ? conditions2 : [conditions2];
  return {
    type: "filter",
    operator,
    conditions: validConditions(conditions2)
  };
}
function updateOrAddCondition(filter, newCondition, operator = "AND") {
  let updated = false;
  const updatedConditions = filter.conditions.map((condition) => {
    if (condition.type === "filter") {
      const updatedFilter = updateOrAddCondition(
        condition,
        newCondition,
        operator
      );
      if (updatedFilter !== condition) {
        updated = true;
      }
      return updatedFilter;
    } else if (condition.type === "expression") {
      const result = updateCondition(condition, newCondition);
      if (result) {
        updated = true;
        return result;
      }
    }
    return condition;
  });
  if (updated) {
    return __spreadProps(__spreadValues({}, filter), { conditions: updatedConditions });
  }
  return __spreadProps(__spreadValues({}, filter), {
    conditions: [...filter.conditions, newCondition]
  });
}
function updateCondition(node, newCondition) {
  let matchFound = false;
  function traverseAndUpdate(node2) {
    if (node2.type === "expression" && node2.left && typeof node2.left === "object" && node2.left.type === "expression" && typeof newCondition.left === "object" && newCondition.left && newCondition.left.type === "expression" && isConditionEqual(node2.left, newCondition.left)) {
      matchFound = true;
      return newCondition;
    }
    const updatedLeft = typeof node2.left === "object" && node2.left && node2.left.type === "expression" ? traverseAndUpdate(node2.left) : node2.left;
    const updatedRight = typeof node2.right === "object" && node2.right.type === "expression" ? traverseAndUpdate(node2.right) : node2.right;
    return __spreadProps(__spreadValues({}, node2), {
      left: updatedLeft,
      right: updatedRight
    });
  }
  const updatedNode = traverseAndUpdate(node);
  return matchFound ? updatedNode : null;
}
function isConditionEqual(cond1, cond2) {
  return cond1.type === cond2.type && cond1.operator === cond2.operator && JSON.stringify(cond1.left) === JSON.stringify(cond2.left) && JSON.stringify(cond1.right) === JSON.stringify(cond2.right);
}

// src/builder/helper/table.ts
function getPrimaryTableName(fromNode) {
  if (typeof fromNode === "string") {
    const parts = fromNode.split(/\s+as\s+/i);
    return parts.length > 1 ? parts[1] : parts[0];
  }
  if (fromNode.alias) {
    return fromNode.alias;
  }
  return fromNode.type === "table" ? fromNode.name : getPrimaryTableName(fromNode.query.from);
}
function updateTableNameWithQualifyingDataset(queryNode, dataset) {
  function qualifyTableName(name) {
    const parts = name.split(".");
    const baseName = parts[parts.length - 1];
    return `${dataset}.${baseName}`;
  }
  function processQuery(query) {
    var _a, _b, _c, _d;
    let from2;
    if (typeof query.from === "string") {
      from2 = qualifyTableName(query.from);
    } else if (query.from.type === "table") {
      from2 = processTable(query.from);
    } else if (query.from.type === "subquery") {
      from2 = processSubQuery(query.from);
    } else {
      from2 = query.from;
    }
    const selects = query.selects.map((sel) => {
      if (typeof sel === "string") {
        return sel;
      } else {
        return __spreadProps(__spreadValues({}, sel), {
          expression: processExpression(sel.expression)
        });
      }
    });
    const joins = (_a = query.joins) == null ? void 0 : _a.map((j) => processJoin(j));
    const where2 = query.where ? processFilter(query.where) : void 0;
    const having = query.having ? processFilter(query.having) : void 0;
    const qualifyFilter = query.qualify ? processFilter(query.qualify) : void 0;
    let groupBy2 = query.groupBy;
    if (typeof groupBy2 === "object" && "type" in groupBy2 && groupBy2.type === "groupby") {
      groupBy2 = __spreadValues({}, groupBy2);
    }
    const orderBy2 = (_b = query.orderBy) == null ? void 0 : _b.map((ob) => __spreadValues({}, ob));
    const withNodes = (_c = query.with) == null ? void 0 : _c.map((withNode) => __spreadProps(__spreadValues({}, withNode), {
      query: processQuery(withNode.query)
    }));
    const unions = (_d = query.unions) == null ? void 0 : _d.map((union) => __spreadProps(__spreadValues({}, union), {
      query: processQuery(union.query)
    }));
    return __spreadProps(__spreadValues({}, query), {
      from: from2,
      selects,
      joins,
      where: where2,
      having,
      groupBy: groupBy2,
      orderBy: orderBy2,
      with: withNodes,
      unions,
      qualify: qualifyFilter
    });
  }
  function processTable(table) {
    return __spreadProps(__spreadValues({}, table), {
      name: qualifyTableName(table.name)
    });
  }
  function processSubQuery(subquery) {
    return __spreadProps(__spreadValues({}, subquery), {
      query: processQuery(subquery.query)
    });
  }
  function processJoin(join2) {
    let table;
    if (join2.table.type === "table") {
      table = processTable(join2.table);
    } else if (join2.table.type === "subquery") {
      table = processSubQuery(join2.table);
    } else {
      table = join2.table;
    }
    return __spreadProps(__spreadValues({}, join2), {
      table,
      on: processExpression(join2.on)
    });
  }
  function processFilter(filter) {
    return __spreadProps(__spreadValues({}, filter), {
      conditions: filter.conditions.map((condition) => {
        if (typeof condition === "object" && condition !== null && "type" in condition) {
          if (condition.type === "filter") {
            return processFilter(condition);
          }
          if (condition.type === "expression") {
            return processExpression(condition);
          }
        }
        return condition;
      })
    });
  }
  function processExpression(expr) {
    let left = expr.left;
    let right = expr.right;
    if (left && typeof left === "object" && "type" in left) {
      if (left.type === "query") {
        left = processQuery(left);
      } else if (left.type === "expression") {
        left = processExpression(left);
      }
    }
    if (right && typeof right === "object" && "type" in right) {
      if (right.type === "query") {
        right = processQuery(right);
      } else if (right.type === "expression") {
        right = processExpression(right);
      }
    }
    return __spreadProps(__spreadValues({}, expr), { left, right });
  }
  return processQuery(queryNode);
}

// src/builder/helper/index.ts
function from(fromNode) {
  return typeof fromNode === "string" ? { type: "table", name: fromNode } : fromNode;
}
function groupBy(columns) {
  if (typeof columns === "string")
    return { type: "groupby", columns: [columns] };
  if (Array.isArray(columns)) return { type: "groupby", columns };
  return columns;
}
function orderBy(column, direction = "DESC") {
  return { type: "orderby", column, direction };
}

// src/builder/util.ts
var checkIsFromTable = (value) => {
  return Object.hasOwn(value, "name");
};
function traverseExpression(expression, callback) {
  if (expression === null) return;
  if (typeof expression.left === "string" || typeof expression.left === "number" || typeof expression.left === "boolean" || expression.left === null) {
    callback(expression.left, expression.operator);
  } else if (typeof expression.left === "object" && expression.left && expression.left.type === "expression") {
    traverseExpression(expression.left, callback);
  }
  if (expression.right && typeof expression.right === "object" && !Array.isArray(expression.right) && expression.right.type === "expression") {
    traverseExpression(expression.right, callback);
  } else if (expression.right) {
    callback(expression.right, expression.operator);
  }
}
function applyMaybeClause(value, builder) {
  if (Array.isArray(value) && !value.length || typeof value == "undefined")
    return "";
  if (value === null) return builder();
  return builder(value);
}

// src/builder/validation/validation.error.ts
var ValidationError = class {
  constructor(message, location, suggestion) {
    this.message = message;
    this.location = location;
    this.suggestion = suggestion;
  }
};

// src/builder/validation/lexical-analyzer.ts
var LexicalAnalyzer = class {
  constructor() {
    /**
     * List of valid SQL operators. Focusing on the most common operators.
     * @link https://cloud.google.com/bigquery/docs/reference/standard-sql/operators
     */
    this.validOperators = [
      "=",
      "!=",
      "<",
      "<=",
      ">",
      ">=",
      "<>",
      "IS",
      "IS NOT",
      "IN",
      "NOT IN",
      "BETWEEN",
      "NOT BETWEEN",
      "LIKE",
      "NOT LIKE",
      "AND",
      "OR",
      "NOT",
      "+",
      "-",
      "*",
      "/",
      "UNION ALL",
      "UNION DISTINCT",
      "EXCEPT DISTINCT",
      "EXCEPT ALL",
      "INTERSECT DISTINCT",
      "INTERSECT ALL",
      "||",
      "~",
      "&",
      "|",
      "^"
    ];
    /**
     * List of reserved SQL keywords that cannot be used as column names.
     * @link https://cloud.google.com/bigquery/docs/reference/standard-sql/lexical#reserved_keywords
     */
    this.reservedKeywords = [
      "ALL",
      "AND",
      "ANY",
      "ARRAY",
      "AS",
      "ASC",
      "ASSERT_ROWS_MODIFIED",
      "AT",
      "BETWEEN",
      "BY",
      "CASE",
      "CAST",
      "COLLATE",
      "CONTAINS",
      "CREATE",
      "CROSS",
      "CUBE",
      "CURRENT",
      "DEFAULT",
      "DEFINE",
      "DESC",
      "DISTINCT",
      "ELSE",
      "END",
      "ENUM",
      "ESCAPE",
      "EXCEPT",
      "EXCLUDE",
      "EXISTS",
      "EXTRACT",
      "FALSE",
      "FETCH",
      "FOLLOWING",
      "FOR",
      "FROM",
      "FULL",
      "GROUP",
      "GROUPING",
      "GROUPS",
      "HASH",
      "HAVING",
      "IF",
      "IGNORE",
      "IN",
      "INNER",
      "INTERSECT",
      "INTERVAL",
      "INTO",
      "IS",
      "JOIN",
      "LATERAL",
      "LEFT",
      "LIKE",
      "LIMIT",
      "LOOKUP",
      "MERGE",
      "NATURAL",
      "NEW",
      "NO",
      "NOT",
      "NULL",
      "NULLS",
      "OF",
      "ON",
      "OR",
      "ORDER",
      "OUTER",
      "OVER",
      "PARTITION",
      "PRECEDING",
      "PROTO",
      "QUALIFY",
      "RANGE",
      "RECURSIVE",
      "RESPECT",
      "RIGHT",
      "ROLLUP",
      "ROWS",
      "SELECT",
      "SET",
      "SOME",
      "STRUCT",
      "TABLESAMPLE",
      "THEN",
      "TO",
      "TREAT",
      "TRUE",
      "UNBOUNDED",
      "UNION",
      "UNNEST",
      "USING",
      "WHEN",
      "WHERE",
      "WINDOW",
      "WITH",
      "WITHIN",
      "*"
    ];
  }
  validate(query) {
    return [
      ...validateReservedKeywords(query, this.reservedKeywords),
      ...validateOperators(query, this.validOperators)
    ];
  }
};
function validateReservedKeywords(query, reservedKeywords) {
  const errors = [];
  query.selects.forEach((selectNode) => {
    const normalizedSelect = select(selectNode)[0];
    if (normalizedSelect.expression == null) return;
    traverseExpression(normalizedSelect.expression, (operand) => {
      if (typeof operand === "string" && reservedKeywords.includes(operand.toUpperCase())) {
        errors.push(
          new ValidationError(
            `Column name '${operand}' is a reserved SQL keyword.`,
            "SELECT",
            "Rename the column to avoid conflicts."
          )
        );
      }
    });
  });
  return errors;
}
function validateOperators(query, validOperators) {
  var _a;
  const errors = [];
  const traverseCondition = (condition) => {
    if (condition.type === "filter") {
      condition.conditions.forEach(traverseCondition);
    } else if (condition.type === "expression") {
      const { operator } = condition;
      if (operator && !validOperators.includes(operator)) {
        errors.push(
          new ValidationError(
            `Invalid operator in condition: '${operator}'.`,
            "WHERE",
            `Use one of the valid operators: ${validOperators.join(", ")}.`
          )
        );
      }
    }
  };
  (_a = query.where) == null ? void 0 : _a.conditions.forEach(traverseCondition);
  return errors;
}

// src/builder/validation/schema-validator.ts
var SchemaValidator = class {
  validate(query, schema) {
    const fromNode = from(query.from);
    if (!schema || !checkIsFromTable(fromNode)) return [];
    const tableSchema = schema[fromNode.name];
    if (!tableSchema) {
      return [
        new ValidationError(
          `Table '${fromNode.name}' does not exist in the schema.`,
          "FROM",
          "Ensure the table exists in the database."
        )
      ];
    }
    return [
      ...validateColumnExistenceInSchema(query, tableSchema),
      ...validateColumnExistenceInWhere(query, tableSchema)
    ];
  }
};
function validateColumnExistenceInSchema(query, columns) {
  const fromNode = from(query.from);
  const errors = [];
  function validateSelectNode(select2, from2) {
    if (select2.expression.type === "expression") {
      if (typeof select2.expression.left === "string" && !columns.includes(select2.expression.left)) {
        if (!checkIsFromTable(from2)) return;
        errors.push(
          new ValidationError(
            `Column '${select2.expression.left}' does not exist in table '${from2.name}'.`,
            "SELECT",
            "Check the column name or the table schema."
          )
        );
      }
    }
  }
  query.selects.forEach((selectNode) => {
    if (fromNode.type === "table") {
      validateSelectNode(select(selectNode)[0], fromNode);
    } else if (fromNode.type === "subquery") {
      validateColumnExistenceInSchema(fromNode.query, columns);
    }
  });
  return errors;
}
function validateColumnExistenceInWhere(query, columns) {
  var _a;
  const errors = [];
  function validateExpressionNode(expression, from2) {
    if (typeof expression.left === "string") {
      if (!columns.includes(expression.left)) {
        if (from2.type !== "table") return;
        errors.push(
          new ValidationError(
            `Column '${expression.left}' does not exist in table '${from2.name}'.`,
            "WHERE",
            "Check the column name or the table schema."
          )
        );
      }
    } else if (typeof expression.left === "object" && expression.left && expression.left.type !== "query") {
      validateExpressionNode(expression.left, from2);
    }
    if (expression.right) {
      if (typeof expression.right === "object" && expression.right.type !== "query" && !Array.isArray(expression.right)) {
        validateExpressionNode(expression.right, from2);
      }
    }
  }
  function validateCondition(condition, from2) {
    if (condition.type === "filter") {
      condition.conditions.forEach(
        (nestedCondition) => validateCondition(nestedCondition, from2)
      );
    } else if (condition.type === "expression") {
      validateExpressionNode(condition, from2);
    }
  }
  const fromNode = from(query.from);
  if ((_a = query.where) == null ? void 0 : _a.conditions) {
    query.where.conditions.forEach((condition) => {
      if (fromNode.type === "table") {
        validateCondition(condition, fromNode);
      } else if (fromNode.type === "subquery") {
        validateColumnExistenceInWhere(fromNode.query, columns);
      }
    });
  }
  return errors;
}

// src/builder/validation/syntax-analyzer.ts
var SyntaxAnalyzer = class {
  validate(query) {
    return [].concat(
      validateGroupByMatchSelect(query),
      validateHavingRequiresGroupBy(query),
      validateLimitWithOrderBy(query)
    );
  }
};
function validateGroupByMatchSelect(query) {
  const errors = [];
  const selectKeyFromExpression = (left) => {
    if (typeof left === "string") {
      const parts = left.split("as");
      return parts.length > 1 ? parts[1].trim() : parts[0].trim();
    }
    return left;
  };
  const selectColumns = query.selects.map((s) => {
    if (typeof s === "string") {
      s = select(s)[0];
    }
    return s.alias || selectKeyFromExpression(s.expression.left);
  });
  const groupByColumns = groupBy(query.groupBy || []).columns;
  groupByColumns.forEach((column) => {
    if (!selectColumns.includes(column)) {
      errors.push(
        new ValidationError(
          `Column '${column}' in GROUP BY must be selected.`,
          "GROUP BY",
          "Add the column to the SELECT clause."
        )
      );
    }
  });
  return errors;
}
function validateHavingRequiresGroupBy(query) {
  var _a;
  const errors = [];
  if (query.having && !((_a = query.orderBy) == null ? void 0 : _a.some((s) => s.column === "groupBy"))) {
    errors.push(
      new ValidationError(
        "HAVING clause requires a GROUP BY clause.",
        "HAVING",
        "Add a GROUP BY clause to your query."
      )
    );
  }
  return errors;
}
function validateLimitWithOrderBy(query) {
  const errors = [];
  if ((query == null ? void 0 : query.limit) && !query.orderBy) {
    errors.push(
      new ValidationError(
        "LIMIT requires an ORDER BY clause for deterministic results.",
        "LIMIT",
        "Add an ORDER BY clause to your query."
      )
    );
  }
  return errors;
}

// src/builder/validation/validation-pipeline.ts
var ValidationPipeline = class {
  constructor(rules) {
    this.rules = rules;
  }
  validate(query, schema) {
    return this.rules.flatMap((rule) => rule.validate(query, schema));
  }
};

// src/builder/expression-builder.ts
var ExpressionBuilder = class {
  constructor(paramManager) {
    this.paramManager = paramManager;
  }
  buildExpression(expr, customParamManager) {
    const currentParamManager = customParamManager || this.paramManager;
    if (expr.type === "expression" && typeof expr.left === "string") {
      return expr.left;
    }
    if (this.isSimpleLiteral(expr)) {
      return currentParamManager.addParameter(expr.left);
    }
    if (expr.operator && expr.right) {
      return this.buildBinaryExpression(expr);
    }
    if (expr.left === null) {
      return "NULL";
    }
    if (expr.type === "expression") {
      return this.buildExpressionValue(expr);
    }
    if (typeof expr.left === "object" && expr.left.type === "expression") {
      return this.buildExpression(expr.left);
    }
    throw new Error(`Unsupported expression: ${JSON.stringify(expr)}`);
  }
  isSimpleLiteral(expr) {
    return (typeof expr.left === "string" || typeof expr.left === "number") && !expr.operator && !expr.right && expr.type !== "expression";
  }
  buildBinaryExpression(expr) {
    let leftPart;
    if (typeof expr.left === "object" && expr.left && expr.left.type === "expression" && typeof expr.left.left === "string") {
      leftPart = expr.left.left;
    } else {
      leftPart = this.buildExpression(expr.left);
    }
    let rightPart;
    if (typeof expr.right === "object" && expr.right.type === "expression" && (typeof expr.right.left === "string" || typeof expr.right.left === "number")) {
      rightPart = this.paramManager.addParameter(expr.right.left);
    } else {
      rightPart = this.buildExpression(expr.right);
    }
    return `${leftPart} ${expr.operator} ${rightPart}`;
  }
  buildExpressionValue(expr) {
    if (Array.isArray(expr.left)) {
      return valueWrapper(expr.left) + "";
    }
    if (typeof expr.left === "string") {
      return expr.left;
    }
    return this.paramManager.addParameter(expr.left);
  }
};

// src/builder/parameter.manager.ts
var QueryBuilderMode = /* @__PURE__ */ ((QueryBuilderMode2) => {
  QueryBuilderMode2["SIMPLE"] = "SIMPLE";
  QueryBuilderMode2["NAMED"] = "NAMED";
  QueryBuilderMode2["POSITIONAL"] = "POSITIONAL";
  return QueryBuilderMode2;
})(QueryBuilderMode || {});
var ParameterManager = class {
  constructor(mode) {
    this.mode = mode;
    this.parameters = mode === "NAMED" /* NAMED */ ? {} : [];
    this.paramIndex = 1;
  }
  addParameter(value) {
    if (this.mode === "SIMPLE" /* SIMPLE */) {
      return `${value}`;
    }
    if (this.mode === "NAMED" /* NAMED */) {
      const paramName = `param${this.paramIndex++}`;
      this.parameters[paramName] = value;
      return `@${paramName}`;
    }
    ;
    this.parameters.push(value);
    this.paramIndex++;
    return "?";
  }
  addParameters(values) {
    return values.map((value) => this.addParameter(value));
  }
  getParameters() {
    return this.mode === "SIMPLE" /* SIMPLE */ ? void 0 : this.parameters;
  }
};

// src/builder/query-builder.ts
var QueryBuilder = class {
  constructor(mode = "NAMED" /* NAMED */) {
    this.validationPipeline = new ValidationPipeline([
      new LexicalAnalyzer(),
      new SyntaxAnalyzer(),
      new SchemaValidator()
    ]);
    this.mode = mode;
  }
  setMode(mode) {
    this.mode = mode;
  }
  validate(queryNode, schema) {
    const errors = this.validationPipeline.validate(queryNode, schema);
    if (errors.length > 0) {
      throw new Error(
        `Query validation failed:
${errors.map((e) => `- ${e.message} (Location: ${e.location})`).join("\n")}`
      );
    }
  }
  build(queryNode, schema) {
    this.validate(queryNode, schema);
    const paramManager = new ParameterManager(this.mode);
    const expressionBuilder = new ExpressionBuilder(paramManager);
    const query = this.buildQuery(queryNode, expressionBuilder);
    return {
      query,
      parameters: paramManager.getParameters()
    };
  }
  buildQuery(queryNode, expressionBuilder) {
    const queryParts = this.getQueryParts(queryNode, expressionBuilder);
    return queryParts.map(({ value, builder }) => applyMaybeClause(value, builder)).filter(Boolean).join(" ").trim();
  }
  getQueryParts(queryNode, expressionBuilder) {
    return [
      {
        value: queryNode.with,
        builder: (v) => this.buildWithClause(v)
      },
      {
        value: null,
        builder: () => `SELECT ${this.buildSelectClause(
          queryNode.selects,
          expressionBuilder.buildExpression.bind(expressionBuilder)
        )}`
      },
      {
        value: null,
        builder: () => this.buildFromClause(queryNode.from)
      },
      {
        value: queryNode.joins,
        builder: (v) => this.buildJoinClause(
          v,
          expressionBuilder.buildExpression.bind(expressionBuilder)
        )
      },
      {
        value: queryNode.where,
        builder: (v) => this.buildWhereClause(v, expressionBuilder)
      },
      {
        value: queryNode.groupBy,
        builder: (v) => this.buildGroupByClause(v)
      },
      {
        value: queryNode.having,
        builder: (v) => this.buildHavingClause(
          v,
          expressionBuilder.buildExpression.bind(expressionBuilder)
        )
      },
      {
        value: queryNode.orderBy,
        builder: (v) => this.buildOrderByClause(v)
      },
      {
        value: queryNode.limit,
        builder: (v) => this.buildLimitClause(v)
      },
      {
        value: queryNode.offset,
        builder: (v) => this.buildOffsetClause(v)
      }
    ];
  }
  buildWithClause(withNodes) {
    return `WITH ${withNodes.map((node) => `${node.name} AS (${this.build(node.query).query})`).join(", ")}`;
  }
  buildSelectClause(selects, buildExpression) {
    const normalizedSelects = selects.map(
      (s) => typeof s === "string" ? select(s)[0] : s
    );
    return normalizedSelects.map(
      (select2) => select2.alias ? `${buildExpression(select2.expression)} AS ${select2.alias}` : buildExpression(select2.expression)
    ).join(", ");
  }
  buildFromClause(fromNode) {
    const from2 = typeof fromNode === "string" ? { type: "table", name: fromNode } : fromNode;
    return checkIsFromTable(from2) ? `FROM ${from2.name}${from2.alias ? ` AS ${from2.alias}` : ""}` : `FROM (${this.build(from2.query).query})${from2.alias ? ` AS ${from2.alias}` : ""}`;
  }
  buildJoinClause(joins, buildExpression) {
    return joins.map((join2) => {
      const table = this.buildJoinTable(join2.table);
      return `${this.mapJoinType(join2.joinType)} ${table} ON ${buildExpression(
        join2.on
      )}`;
    }).join(" ");
  }
  buildJoinTable(table) {
    return checkIsFromTable(table) ? `${table.name}${table.alias ? ` AS ${table.alias}` : ""}` : `(${this.build(table.query).query})${table.alias ? ` AS ${table.alias}` : ""}`;
  }
  /**
   * Generates a SQL `WHERE` clause from a structured `FilterNode`.
   *
   * Recursively processes the `FilterNode` and its conditions to produce a
   * SQL-compliant `WHERE` clause. Ensures logical grouping with parentheses
   * only where necessary.
   *
   * @param {FilterNode} where - The root filter node containing the query conditions.
   * @param {ExpressionBuilder} expressionBuilder - Utility to convert `ExpressionNode` to SQL.
   * @returns {string}
   *
   * @example
   * const filterNode = {
   *   type: "filter",
   *   operator: "AND",
   *   conditions: [
   *     { type: "expression", operator: ">", left: { type: "expression", left: "age" }, right: { type: "expression", left: 18 } },
   *     { type: "filter", operator: "OR", conditions: [
   *       { type: "expression", operator: "=", left: { type: "expression", left: "name" }, right: { type: "expression", left: "'John'" } },
   *       { type: "expression", operator: "<", left: { type: "expression", left: "age" }, right: { type: "expression", left: 18 } }
   *     ]}
   *   ]
   * };
   *
   * buildWhereClause(filterNode, expressionBuilder);
   * // WHERE age > 18 AND (name = 'John' OR age < 18)
   */
  buildWhereClause(where2, expressionBuilder) {
    if (!where2.conditions || where2.conditions.length === 0) {
      return "";
    }
    const buildCondition = (condition, parentOperator) => {
      if (condition.type === "filter") {
        const nestedConditions = condition.conditions.map(
          (nestedCondition) => buildCondition(nestedCondition, condition.operator)
        ).join(` ${condition.operator} `);
        if (parentOperator && parentOperator !== condition.operator) {
          return `(${nestedConditions})`;
        }
        return nestedConditions;
      } else {
        return expressionBuilder.buildExpression(condition);
      }
    };
    const whereClause = where2.conditions.map((condition) => buildCondition(condition, where2.operator)).join(` ${where2.operator} `);
    return `WHERE ${whereClause}`;
  }
  buildGroupByClause(_groupBy) {
    const normalizedGroupBy = groupBy(_groupBy);
    return `GROUP BY ${normalizedGroupBy.columns.join(", ")}`;
  }
  buildHavingClause(having, buildExpression) {
    if (!having.conditions || having.conditions.length === 0) {
      return "";
    }
    const buildCondition = (condition) => {
      if (condition.type === "filter") {
        const nestedConditions = condition.conditions.map((nestedCondition) => buildCondition(nestedCondition)).join(` ${condition.operator} `);
        return `(${nestedConditions})`;
      } else {
        return buildExpression(condition);
      }
    };
    const havingClause = having.conditions.map((condition) => buildCondition(condition)).join(` ${having.operator} `);
    return `HAVING ${havingClause}`;
  }
  buildOrderByClause(orderBy2) {
    return `ORDER BY ${orderBy2.map((o) => `${o.column} ${o.direction}`).join(", ")}`;
  }
  buildLimitClause(limit) {
    return `LIMIT ${limit}`;
  }
  buildOffsetClause(offset) {
    return `OFFSET ${offset}`;
  }
  mapJoinType(joinType) {
    const joinTypes = {
      INNER: "INNER JOIN",
      LEFT: "LEFT JOIN",
      RIGHT: "RIGHT JOIN",
      FULL: "FULL JOIN",
      CROSS: "CROSS JOIN"
    };
    return joinTypes[joinType] || "JOIN";
  }
};

// src/parser/expression.handler.ts
var expressionHandlers = {
  column_ref: (expr) => ({
    type: "expression",
    left: expr.table ? `${expr.table}.${expr.column}` : expr.column
  }),
  binary_expr: (expr, mapExpression) => ({
    type: "expression",
    left: mapExpression(expr.left),
    operator: expr.operator,
    right: mapExpression(expr.right)
  }),
  function: (expr, mapExpression) => {
    var _a, _b, _c, _d, _e, _f;
    const functionName = Array.isArray((_a = expr.name) == null ? void 0 : _a.name) && ((_b = expr.name) == null ? void 0 : _b.length) > 0 ? expr.name.name.map((n) => n.value).join(".") : ((_c = expr.name) == null ? void 0 : _c.value) || ((_e = (_d = expr.name) == null ? void 0 : _d.schema) == null ? void 0 : _e.value) || "UNKNOWN_FUNCTION";
    const functionArgs = ((_f = expr.args) == null ? void 0 : _f.type) === "expr_list" && Array.isArray(expr.args.value) ? expr.args.value.map((arg) => mapExpression(arg).left).join(", ") : "";
    return {
      type: "expression",
      left: `${functionName}(${functionArgs})`
    };
  },
  case: (expr, mapExpression) => {
    const caseParts = expr.args.map((arg) => {
      if (arg.type === "when") {
        const condition = mapExpression(arg.cond);
        const result = mapExpression(arg.result).left;
        return `WHEN ${condition.left} ${condition.operator || ""} ${condition.right} THEN ${result}`;
      }
      if (arg.type === "else") {
        const elseResult = mapExpression(arg.result).left;
        return `ELSE ${elseResult}`;
      }
      return null;
    }).filter(Boolean).join(" ");
    return {
      type: "expression",
      left: `CASE ${caseParts} END`
    };
  },
  star: () => ({
    type: "expression",
    left: "*"
    // Represents the `*` in SQL
  }),
  interval: (expr, mapExpression) => ({
    type: "expression",
    left: `INTERVAL ${mapExpression(expr.expr).left} ${expr.unit}`
  }),
  is_expr: (expr, mapExpression) => ({
    type: "expression",
    left: mapExpression(expr.left).left,
    operator: expr.operator,
    // Typically "IS" or "IS NOT"
    right: expr.right ? mapExpression(expr.right).left : void 0
  }),
  aggr_func: (expr, mapExpression) => {
    var _a, _b, _c;
    const aggrFunctionName = expr.name;
    const aggrFunctionArgs = ((_b = (_a = expr.args) == null ? void 0 : _a.expr) == null ? void 0 : _b.type) === "star" ? "*" : ((_c = expr.args) == null ? void 0 : _c.expr) ? mapExpression(expr.args.expr).left : "";
    return {
      type: "expression",
      left: `${aggrFunctionName}(${aggrFunctionArgs})`
    };
  },
  single_quote_string: (expr) => ({
    type: "expression",
    left: expr.value
  }),
  null: (expr) => ({
    type: "expression",
    left: expr.value
  }),
  number: (expr) => ({
    type: "expression",
    left: expr.value
  }),
  string: (expr) => ({
    type: "expression",
    left: expr.value
  })
};

// src/parser/ast-mapper.ts
var ASTMapper = class {
  isAST(parsedAST) {
    return Array.isArray(parsedAST) || !parsedAST.tableList !== void 0;
  }
  isTableColumnAst(parsedAST) {
    return parsedAST.tableList !== void 0;
  }
  map(parsedAST) {
    var _a, _b, _c, _d, _e, _f;
    if (this.isAST(parsedAST) && Array.isArray(parsedAST)) {
      const [mainQuery] = parsedAST;
      return this.map({ ast: mainQuery });
    }
    let ast = this.isTableColumnAst(parsedAST) ? parsedAST.ast : parsedAST;
    if (!ast) {
      throw new Error("Invalid AST: Root node must be a SELECT query.");
    }
    ast = Array.isArray(ast) ? ast[0] : ast;
    const withNodes = ast.with ? this.mapWithClauses(ast.with) : [];
    const result = {
      type: "query",
      with: withNodes,
      selects: this.mapSelects(ast.columns),
      from: this.mapFrom(ast.from),
      joins: this.mapJoins(ast.from),
      where: ast.where ? this.mapFilter(ast.where) : void 0,
      groupBy: ast.groupby ? this.mapGroupBy(ast.groupby) : void 0,
      having: ast.having ? this.mapFilter(ast.having) : void 0,
      orderBy: ast.orderby ? this.mapOrderBy(ast.orderby) : [],
      limit: (_c = (_b = (_a = ast.limit) == null ? void 0 : _a.value) == null ? void 0 : _b[0]) == null ? void 0 : _c.value,
      offset: (_f = (_e = (_d = ast.limit) == null ? void 0 : _d.value) == null ? void 0 : _e[1]) == null ? void 0 : _f.value,
      unions: []
      // Extend later if UNION is supported
    };
    return JSON.parse(JSON.stringify(result));
  }
  mapWithClauses(withClauses) {
    if (!Array.isArray(withClauses)) {
      return [];
    }
    return withClauses.map((cte) => ({
      type: "with",
      name: cte.name.value,
      query: this.map(cte.stmt)
      // Recursively map the nested query
    }));
  }
  mapSelects(columns) {
    if (!Array.isArray(columns)) {
      throw new Error("Invalid AST structure: 'columns' must be an array.");
    }
    return columns.map((column) => ({
      type: "select",
      expression: this.mapExpression(column.expr),
      alias: column.as || void 0
    }));
  }
  mapFrom(from2) {
    if (from2 === null || from2 === void 0) {
      throw new Error("Invalid AST structure: 'from' must be an array.");
    }
    if (!Array.isArray(from2)) {
      return {
        type: "subquery",
        query: this.map(from2.expr.ast),
        alias: from2.as || void 0
      };
    }
    const mainTable = from2.find((v) => Object.hasOwn(v, "table"));
    if (!mainTable) {
      throw new Error(
        "Invalid AST structure: 'from' must contain a main table."
      );
    }
    return {
      type: "table",
      name: mainTable.table,
      alias: mainTable.as || void 0
    };
  }
  mapJoins(from2) {
    if (from2 === null || !Array.isArray(from2)) return [];
    const isJoin = (v) => Object.hasOwn(v, "join");
    return from2.filter((v) => isJoin(v)).map(
      (join2) => ({
        type: "join",
        joinType: join2.join,
        table: {
          type: "table",
          name: join2.table,
          alias: join2.as || void 0
        },
        on: this.mapExpression(join2.on)
      })
    );
  }
  /**
   * Converts a filter AST into a structured `FilterNode`. The top-level node is always
   * a `FilterNode` where logical conditions are grouped accurately.
   *
   * - Logical expressions (`AND`, `OR`) with `"parentheses": true` are grouped into a new `FilterNode`.
   * - Logical expressions without `"parentheses": true` are flattened into the parent `FilterNode`.
   * - Binary expressions (`>`, `<`, `=`, etc.) are mapped to `ExpressionNode` with `operator`, `left`, and `right`.
   *
   * ### Example Input SQL:
   *
   * ```sql
   * SELECT name, email FROM users WHERE age > 18 AND name = 'John' OR (age < 18 AND name = 'Doe' OR (age = 18 AND name = 'Smith'))
   * ```
   * The AST will be:
   *
   * ```json
   * OR(
   *   AND(age > 18, name = 'John'),
   *   OR(
   *     AND(age < 18, name = 'Doe'),
   *     AND(age = 18, name = 'Smith')  // with parentheses
   *   )  // with parentheses
   * )
   * ```
   *
   * Output `FilterNode`:
   * ```typescript
   * {
   *   type: "filter",
   *   operator: "AND",
   *   conditions: [
   *      ... more conditions ...
   *     { type: "expression", operator: ">", left: { type: "expression", left: "age" }, right: { type: "expression", left: 18 } },
   *     { type: "filter", operator: "OR", conditions: [
   *       { type: "expression", operator: "=", left: { type: "expression", left: "name" }, right: { type: "expression", left: "'John'" } },
   *       { type: "expression", operator: "<", left: { type: "expression", left: "age" }, right: { type: "expression", left: 18 } }
   *     ]}
   *   ]
   * }
   * ```
   *
   * Output SQL representation:
   * ```sql
   * WHERE (age > 18 AND name = 'John') OR ((age < 18 AND name = 'Doe') OR (age = 18 AND name = 'Smith'))
   * ```
   *
   * @param filter - The input AST representing the filter conditions.
   * @returns
   */
  mapFilter(filter) {
    if (!filter || typeof filter !== "object" || !filter.type) {
      throw new Error(`Invalid filter node: ${JSON.stringify(filter)}`);
    }
    return this.processNode(filter);
  }
  processNode(node) {
    if (node.type !== "binary_expr") {
      return {
        type: "filter",
        operator: "AND",
        conditions: [this.mapExpression(node)]
      };
    }
    if (!["AND", "OR"].includes(node.operator)) {
      return {
        type: "filter",
        operator: "AND",
        conditions: [this.mapExpression(node)]
      };
    }
    if (node.parentheses) {
      return {
        type: "filter",
        operator: node.operator,
        conditions: [
          ...this.buildConditions(node.left),
          ...this.buildConditions(node.right)
        ]
      };
    }
    const leftConditions = node.left.operator === node.operator && !node.left.parentheses ? this.buildConditions(node.left) : [this.processNode(node.left)];
    const rightConditions = node.right.operator === node.operator && !node.right.parentheses ? this.buildConditions(node.right) : [this.processNode(node.right)];
    return {
      type: "filter",
      operator: node.operator,
      conditions: [...leftConditions, ...rightConditions]
    };
  }
  buildConditions(node) {
    if (!node) return [];
    if (node.type !== "binary_expr") {
      return [this.mapExpression(node)];
    }
    if (node.operator === "AND" || node.operator === "OR") {
      return [this.processNode(node)];
    }
    return [this.mapExpression(node)];
  }
  mapGroupBy(groupby) {
    return {
      type: "groupby",
      columns: groupby.columns.map((col) => this.mapExpression(col).left)
    };
  }
  mapOrderBy(orderby) {
    return orderby.map((order) => ({
      type: "orderby",
      column: this.mapExpression(order.expr).left,
      direction: order.type.toUpperCase()
    }));
  }
  mapExpression(expr) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    if (!expr || typeof expr !== "object") {
      throw new Error(`Invalid expression: ${JSON.stringify(expr)}`);
    }
    if (expr.ast) {
      const queryNode = this.map(expr);
      return {
        type: "expression",
        left: queryNode
      };
    }
    switch (expr.type) {
      case "column_ref":
        return {
          type: "expression",
          left: expr.table ? `${expr.table}.${expr.column}` : expr.column
        };
      case "binary_expr":
        return {
          type: "expression",
          left: this.mapExpression(expr.left),
          operator: expr.operator,
          right: this.mapExpression(expr.right)
        };
      case "function":
        const functionName = Array.isArray((_a = expr.name) == null ? void 0 : _a.name) && ((_b = expr.name) == null ? void 0 : _b.length) > 0 ? expr.name.name.map((n) => n.value).join(".") : ((_c = expr.name) == null ? void 0 : _c.value) || ((_e = (_d = expr.name) == null ? void 0 : _d.schema) == null ? void 0 : _e.value) || "UNKNOWN_FUNCTION";
        const functionArgs = ((_f = expr.args) == null ? void 0 : _f.type) === "expr_list" && Array.isArray(expr.args.value) ? expr.args.value.map((arg) => {
          if (arg.ast) {
            const queryNode = this.map(arg.ast);
            const queryBuilder = new QueryBuilder(
              "SIMPLE" /* SIMPLE */
            );
            const queryObject = queryBuilder.build(queryNode);
            return `(${queryObject.query})`;
          } else if (typeof arg === "object") {
            return this.mapExpression(arg).left;
          } else {
            return String(arg);
          }
        }).join(", ") : "";
        return {
          type: "expression",
          left: `${functionName}(${functionArgs})`
        };
      case "case":
        const caseParts = expr.args.map((arg) => {
          if (arg.type === "when") {
            const condition = this.mapExpression(arg.cond);
            const result = this.mapExpression(arg.result).left;
            if (typeof condition.left === "object" && typeof condition.right === "object" && condition.left && condition.left.type != "query" && condition.right.type != "query" && !Array.isArray(condition.right)) {
              return `WHEN ${condition.left.left} ${condition.operator} ${condition.right.left} THEN ${result}`;
            }
            return `WHEN ${condition.left} ${condition.operator} ${condition.right} THEN ${result}`;
          }
          if (arg.type === "else") {
            const elseResult = this.mapExpression(arg.result).left;
            return `ELSE ${elseResult}`;
          }
          return null;
        }).filter(Boolean).join(" ");
        return {
          type: "expression",
          left: `CASE ${caseParts} END`
        };
      case "star":
        return {
          type: "expression",
          left: "*"
          // Represents the `*` in SQL
        };
      case "interval":
        return {
          type: "expression",
          left: `INTERVAL ${this.mapExpression(expr.expr).left} ${expr.unit}`
        };
      case "is_expr":
        return {
          type: "expression",
          left: this.mapExpression(expr.left).left,
          operator: expr.operator,
          // Typically "IS" or "IS NOT"
          right: expr.right ? this.mapExpression(expr.right).left : void 0
        };
      case "aggr_func":
        const aggrFunctionName = expr.name;
        const aggrFunctionArgs = ((_h = (_g = expr.args) == null ? void 0 : _g.expr) == null ? void 0 : _h.type) === "star" ? "*" : ((_i = expr.args) == null ? void 0 : _i.expr) ? this.mapExpression(expr.args.expr).left : "";
        return {
          type: "expression",
          left: `${aggrFunctionName}(${aggrFunctionArgs})`
        };
      case "expr_list":
        return {
          type: "expression",
          left: `(${expr.value.map((arg) => this.mapExpression(arg).left).join(", ")})`
        };
      case "single_quote_string":
        return {
          type: "expression",
          left: `'${expr.value}'`
        };
      case "null":
      case "number":
      case "string":
        return {
          type: "expression",
          left: expr.value
        };
      default:
        throw new Error(`Unsupported expression type: ${JSON.stringify(expr)}`);
    }
  }
  mapExpressionFunctional(expr) {
    if (!expr || typeof expr !== "object" || !expr.type) {
      throw new Error(`Invalid expression: ${JSON.stringify(expr)}`);
    }
    const handler = expressionHandlers[expr.type];
    if (!handler) {
      throw new Error(`Unsupported expression type: ${JSON.stringify(expr)}`);
    }
    return handler(expr, this.mapExpressionFunctional);
  }
  mapWindowSpec(windowSpec) {
    const partitionBy = windowSpec.partition_clause ? `PARTITION BY ${windowSpec.partition_clause.map((col) => this.mapExpression(col).left).join(", ")}` : "";
    const orderBy2 = windowSpec.order_by_clause ? `ORDER BY ${windowSpec.order_by_clause.map((col) => this.mapExpression(col.expr).left + " " + col.type).join(", ")}` : "";
    return `${partitionBy} ${orderBy2}`.trim();
  }
};

// src/grammar/bigquery.pegjs
function peg$subclass(child, parent) {
  function C() {
    this.constructor = child;
  }
  C.prototype = parent.prototype;
  child.prototype = new C();
}
function peg$SyntaxError(message, expected, found, location) {
  var self = Error.call(this, message);
  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(self, peg$SyntaxError.prototype);
  }
  self.expected = expected;
  self.found = found;
  self.location = location;
  self.name = "SyntaxError";
  return self;
}
peg$subclass(peg$SyntaxError, Error);
function peg$padEnd(str, targetLength, padString) {
  padString = padString || " ";
  if (str.length > targetLength) {
    return str;
  }
  targetLength -= str.length;
  padString += padString.repeat(targetLength);
  return str + padString.slice(0, targetLength);
}
peg$SyntaxError.prototype.format = function(sources) {
  var str = "Error: " + this.message;
  if (this.location) {
    var src = null;
    var k;
    for (k = 0; k < sources.length; k++) {
      if (sources[k].source === this.location.source) {
        src = sources[k].text.split(/\r\n|\n|\r/g);
        break;
      }
    }
    var s = this.location.start;
    var offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s) : s;
    var loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
    if (src) {
      var e = this.location.end;
      var filler = peg$padEnd("", offset_s.line.toString().length, " ");
      var line = src[s.line - 1];
      var last = s.line === e.line ? e.column : line.length + 1;
      var hatLen = last - s.column || 1;
      str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line + "\n" + filler + " | " + peg$padEnd("", s.column - 1, " ") + peg$padEnd("", hatLen, "^");
    } else {
      str += "\n at " + loc;
    }
  }
  return str;
};
peg$SyntaxError.buildMessage = function(expected, found) {
  var DESCRIBE_EXPECTATION_FNS = {
    literal: function(expectation) {
      return '"' + literalEscape(expectation.text) + '"';
    },
    class: function(expectation) {
      var escapedParts = expectation.parts.map(function(part) {
        return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
      });
      return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]";
    },
    any: function() {
      return "any character";
    },
    end: function() {
      return "end of input";
    },
    other: function(expectation) {
      return expectation.description;
    }
  };
  function hex(ch) {
    return ch.charCodeAt(0).toString(16).toUpperCase();
  }
  function literalEscape(s) {
    return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
      return "\\x0" + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
      return "\\x" + hex(ch);
    });
  }
  function classEscape(s) {
    return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
      return "\\x0" + hex(ch);
    }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
      return "\\x" + hex(ch);
    });
  }
  function describeExpectation(expectation) {
    return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
  }
  function describeExpected(expected2) {
    var descriptions = expected2.map(describeExpectation);
    var i, j;
    descriptions.sort();
    if (descriptions.length > 0) {
      for (i = 1, j = 1; i < descriptions.length; i++) {
        if (descriptions[i - 1] !== descriptions[i]) {
          descriptions[j] = descriptions[i];
          j++;
        }
      }
      descriptions.length = j;
    }
    switch (descriptions.length) {
      case 1:
        return descriptions[0];
      case 2:
        return descriptions[0] + " or " + descriptions[1];
      default:
        return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
    }
  }
  function describeFound(found2) {
    return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
  }
  return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
};
function peg$parse(input, options) {
  options = options !== void 0 ? options : {};
  var peg$FAILED = {};
  var peg$source = options.grammarSource;
  var peg$startRuleFunctions = { start: peg$parsestart };
  var peg$startRuleFunction = peg$parsestart;
  var peg$c0 = "=";
  var peg$c1 = "duplicate";
  var peg$c2 = "binary";
  var peg$c3 = "master";
  var peg$c4 = "logs";
  var peg$c5 = "binlog";
  var peg$c6 = "events";
  var peg$c7 = "character";
  var peg$c8 = "set";
  var peg$c9 = "collation";
  var peg$c10 = "if";
  var peg$c11 = "cascaded";
  var peg$c12 = "local";
  var peg$c13 = "check";
  var peg$c14 = "OPTION";
  var peg$c15 = "check_option";
  var peg$c16 = "security_barrier";
  var peg$c17 = "security_invoker";
  var peg$c18 = "grants";
  var peg$c19 = ".";
  var peg$c20 = "algorithm";
  var peg$c21 = "default";
  var peg$c22 = "instant";
  var peg$c23 = "inplace";
  var peg$c24 = "copy";
  var peg$c25 = "lock";
  var peg$c26 = "none";
  var peg$c27 = "shared";
  var peg$c28 = "exclusive";
  var peg$c29 = "auto_increment";
  var peg$c30 = "unique";
  var peg$c31 = "key";
  var peg$c32 = "primary";
  var peg$c33 = "for";
  var peg$c34 = "column_format";
  var peg$c35 = "fixed";
  var peg$c36 = "dynamic";
  var peg$c37 = "storage";
  var peg$c38 = "disk";
  var peg$c39 = "memory";
  var peg$c40 = "match full";
  var peg$c41 = "match partial";
  var peg$c42 = "match simple";
  var peg$c43 = "expiration_timestamp";
  var peg$c44 = "partition_expiration_days";
  var peg$c45 = "require_partition_filter";
  var peg$c46 = "kms_key_name";
  var peg$c47 = "friendly_name";
  var peg$c48 = "description";
  var peg$c49 = "labels";
  var peg$c50 = "default_rounding_mode";
  var peg$c51 = "avg_row_length";
  var peg$c52 = "key_block_size";
  var peg$c53 = "max_rows";
  var peg$c54 = "min_rows";
  var peg$c55 = "stats_sample_pages";
  var peg$c56 = "connection";
  var peg$c57 = "compression";
  var peg$c58 = "'";
  var peg$c59 = "zlib";
  var peg$c60 = "lz4";
  var peg$c61 = "engine";
  var peg$c62 = "cluster";
  var peg$c63 = "by";
  var peg$c64 = "options";
  var peg$c65 = "charset";
  var peg$c66 = "collate";
  var peg$c67 = "read";
  var peg$c68 = "low_priority";
  var peg$c69 = "write";
  var peg$c70 = "foreign key";
  var peg$c71 = "not";
  var peg$c72 = "replication";
  var peg$c73 = "btree";
  var peg$c74 = "hash";
  var peg$c75 = "with";
  var peg$c76 = "parser";
  var peg$c77 = "visible";
  var peg$c78 = "invisible";
  var peg$c79 = "restrict";
  var peg$c80 = "cascade";
  var peg$c81 = "set null";
  var peg$c82 = "no action";
  var peg$c83 = "set default";
  var peg$c84 = "update";
  var peg$c85 = "create";
  var peg$c86 = "delete";
  var peg$c87 = "insert";
  var peg$c88 = ":=";
  var peg$c89 = "return";
  var peg$c90 = "replace";
  var peg$c91 = "analyze";
  var peg$c92 = "attach";
  var peg$c93 = "database";
  var peg$c94 = "rename";
  var peg$c95 = "show";
  var peg$c96 = "describe";
  var peg$c97 = "@";
  var peg$c98 = "@@";
  var peg$c99 = "$";
  var peg$c100 = "temporary";
  var peg$c101 = "temp";
  var peg$c102 = "schema";
  var peg$c103 = "alter";
  var peg$c104 = "spatial";
  var peg$c105 = "(";
  var peg$c106 = ")";
  var peg$c107 = "intersect";
  var peg$c108 = "except";
  var peg$c109 = "system_time";
  var peg$c110 = "as";
  var peg$c111 = "of";
  var peg$c112 = "unnest";
  var peg$c113 = "tablesample";
  var peg$c114 = "bernoulli";
  var peg$c115 = "reservoir";
  var peg$c116 = "percent";
  var peg$c117 = "rows";
  var peg$c118 = "range";
  var peg$c119 = "unbounded";
  var peg$c120 = "preceding";
  var peg$c121 = "current";
  var peg$c122 = "ROW";
  var peg$c123 = "following";
  var peg$c124 = "row";
  var peg$c125 = "!";
  var peg$c126 = ">=";
  var peg$c127 = ">";
  var peg$c128 = "<=";
  var peg$c129 = "<>";
  var peg$c130 = "!=";
  var peg$c131 = '"';
  var peg$c132 = "`";
  var peg$c133 = "string_agg";
  var peg$c134 = "*";
  var peg$c135 = "any_value";
  var peg$c136 = "year_month";
  var peg$c137 = "day_hour";
  var peg$c138 = "day_minute";
  var peg$c139 = "day_second";
  var peg$c140 = "day_microsecond";
  var peg$c141 = "hour_minute";
  var peg$c142 = "hour_second";
  var peg$c143 = "hour_microsecond";
  var peg$c144 = "minute_second";
  var peg$c145 = "minute_microsecond";
  var peg$c146 = "second_microsecond";
  var peg$c147 = "timezone_hour";
  var peg$c148 = "timezone_minute";
  var peg$c149 = "century";
  var peg$c150 = "dayofweek";
  var peg$c151 = "day";
  var peg$c152 = "date";
  var peg$c153 = "decade";
  var peg$c154 = "dow";
  var peg$c155 = "doy";
  var peg$c156 = "epoch";
  var peg$c157 = "hour";
  var peg$c158 = "isodow";
  var peg$c159 = "isoweek";
  var peg$c160 = "isoyear";
  var peg$c161 = "microseconds";
  var peg$c162 = "millennium";
  var peg$c163 = "milliseconds";
  var peg$c164 = "minute";
  var peg$c165 = "month";
  var peg$c166 = "quarter";
  var peg$c167 = "second";
  var peg$c168 = "time";
  var peg$c169 = "timezone";
  var peg$c170 = "week";
  var peg$c171 = "year";
  var peg$c172 = "date_trunc";
  var peg$c173 = "r";
  var peg$c174 = "\\'";
  var peg$c175 = '\\"';
  var peg$c176 = "\\\\";
  var peg$c177 = "\\/";
  var peg$c178 = "\\b";
  var peg$c179 = "\\f";
  var peg$c180 = "\\n";
  var peg$c181 = "\\r";
  var peg$c182 = "\\t";
  var peg$c183 = "\\u";
  var peg$c184 = "\\";
  var peg$c185 = "''";
  var peg$c186 = '""';
  var peg$c187 = "``";
  var peg$c188 = "null";
  var peg$c189 = "not null";
  var peg$c190 = "true";
  var peg$c191 = "to";
  var peg$c192 = "false";
  var peg$c193 = "drop";
  var peg$c194 = "use";
  var peg$c195 = "select";
  var peg$c196 = "recursive";
  var peg$c197 = "ignore";
  var peg$c198 = "explain";
  var peg$c199 = "partition";
  var peg$c200 = "into";
  var peg$c201 = "from";
  var peg$c202 = "unlock";
  var peg$c203 = "table";
  var peg$c204 = "tables";
  var peg$c205 = "on";
  var peg$c206 = "left";
  var peg$c207 = "right";
  var peg$c208 = "full";
  var peg$c209 = "inner";
  var peg$c210 = "cross";
  var peg$c211 = "join";
  var peg$c212 = "outer";
  var peg$c213 = "over";
  var peg$c214 = "union";
  var peg$c215 = "value";
  var peg$c216 = "values";
  var peg$c217 = "using";
  var peg$c218 = "where";
  var peg$c219 = "group";
  var peg$c220 = "order";
  var peg$c221 = "having";
  var peg$c222 = "qualify";
  var peg$c223 = "window";
  var peg$c224 = "ordinal";
  var peg$c225 = "safe_ordinal";
  var peg$c226 = "limit";
  var peg$c227 = "offset";
  var peg$c228 = "safe_offset";
  var peg$c229 = "asc";
  var peg$c230 = "desc";
  var peg$c231 = "all";
  var peg$c232 = "distinct";
  var peg$c233 = "between";
  var peg$c234 = "in";
  var peg$c235 = "is";
  var peg$c236 = "like";
  var peg$c237 = "exists";
  var peg$c238 = "and";
  var peg$c239 = "or";
  var peg$c240 = "count";
  var peg$c241 = "max";
  var peg$c242 = "min";
  var peg$c243 = "sum";
  var peg$c244 = "avg";
  var peg$c245 = "extract";
  var peg$c246 = "call";
  var peg$c247 = "case";
  var peg$c248 = "when";
  var peg$c249 = "then";
  var peg$c250 = "else";
  var peg$c251 = "end";
  var peg$c252 = "cast";
  var peg$c253 = "safe_cast";
  var peg$c254 = "array";
  var peg$c255 = "bytes";
  var peg$c256 = "bool";
  var peg$c257 = "char";
  var peg$c258 = "geography";
  var peg$c259 = "varchar";
  var peg$c260 = "numeric";
  var peg$c261 = "decimal";
  var peg$c262 = "signed";
  var peg$c263 = "unsigned";
  var peg$c264 = "int64";
  var peg$c265 = "zerofill";
  var peg$c266 = "integer";
  var peg$c267 = "json";
  var peg$c268 = "smallint";
  var peg$c269 = "string";
  var peg$c270 = "struct";
  var peg$c271 = "tinyint";
  var peg$c272 = "tinytext";
  var peg$c273 = "text";
  var peg$c274 = "mediumtext";
  var peg$c275 = "longtext";
  var peg$c276 = "bigint";
  var peg$c277 = "float64";
  var peg$c278 = "double";
  var peg$c279 = "datetime";
  var peg$c280 = "timestamp";
  var peg$c281 = "truncate";
  var peg$c282 = "user";
  var peg$c283 = "current_date";
  var peg$c284 = "adddate";
  var peg$c285 = "interval";
  var peg$c286 = "current_time";
  var peg$c287 = "current_timestamp";
  var peg$c288 = "session_user";
  var peg$c289 = "global";
  var peg$c290 = "session";
  var peg$c291 = "pivot";
  var peg$c292 = "persist";
  var peg$c293 = "persist_only";
  var peg$c294 = "view";
  var peg$c295 = "add";
  var peg$c296 = "column";
  var peg$c297 = "index";
  var peg$c298 = "fulltext";
  var peg$c299 = "comment";
  var peg$c300 = "constraint";
  var peg$c301 = "references";
  var peg$c302 = ",";
  var peg$c303 = "<";
  var peg$c304 = "[";
  var peg$c305 = "]";
  var peg$c306 = ";";
  var peg$c307 = "||";
  var peg$c308 = "&&";
  var peg$c309 = "/*";
  var peg$c310 = "*/";
  var peg$c311 = "--";
  var peg$c312 = "#";
  var peg$c313 = "MAX";
  var peg$c314 = "NULL";
  var peg$c315 = "TRUE";
  var peg$c316 = "FALSE";
  var peg$c317 = "JSON_EXTRACT";
  var peg$c318 = "JSON_EXTRACT_SCALAR";
  var peg$c319 = "ARRAY";
  var peg$c320 = "STRING";
  var peg$c321 = "INTEGER";
  var peg$c322 = "FLOAT";
  var peg$c323 = "BOOLEAN";
  var peg$c324 = "DATE";
  var peg$c325 = "DATETIME";
  var peg$c326 = "TIMESTAMP";
  var peg$c327 = "UNNEST";
  var peg$r0 = /^[$@]/;
  var peg$r1 = /^[@]/;
  var peg$r2 = /^[{]/;
  var peg$r3 = /^[=]/;
  var peg$r4 = /^[}]/;
  var peg$r5 = /^[<-=]/;
  var peg$r6 = /^[+\-]/;
  var peg$r7 = /^[%*\/]/;
  var peg$r8 = /^[!+\-~]/;
  var peg$r9 = /^[^"]/;
  var peg$r10 = /^[^']/;
  var peg$r11 = /^[^`]/;
  var peg$r12 = /^[A-Za-z_]/;
  var peg$r13 = /^[A-Za-z0-9_\-]/;
  var peg$r14 = /^[A-Za-z0-9_:]/;
  var peg$r15 = /^[:@]/;
  var peg$r16 = /^[^"\\\0-\x1F\x7F]/;
  var peg$r17 = /^[^'\\]/;
  var peg$r18 = /^[\n\r]/;
  var peg$r19 = /^[0-9]/;
  var peg$r20 = /^[0-9a-fA-F]/;
  var peg$r21 = /^[eE]/;
  var peg$r22 = /^[ \t\n\r]/;
  var peg$r23 = /^[a-zA-Z_]/;
  var peg$r24 = /^[a-zA-Z0-9_]/;
  var peg$e0 = peg$literalExpectation("=", false);
  var peg$e1 = peg$literalExpectation("DUPLICATE", true);
  var peg$e2 = peg$literalExpectation("BINARY", true);
  var peg$e3 = peg$literalExpectation("MASTER", true);
  var peg$e4 = peg$literalExpectation("LOGS", true);
  var peg$e5 = peg$literalExpectation("BINLOG", true);
  var peg$e6 = peg$literalExpectation("EVENTS", true);
  var peg$e7 = peg$literalExpectation("CHARACTER", true);
  var peg$e8 = peg$literalExpectation("SET", true);
  var peg$e9 = peg$literalExpectation("COLLATION", true);
  var peg$e10 = peg$literalExpectation("IF", true);
  var peg$e11 = peg$literalExpectation("CASCADED", true);
  var peg$e12 = peg$literalExpectation("LOCAL", true);
  var peg$e13 = peg$literalExpectation("CHECK", true);
  var peg$e14 = peg$literalExpectation("OPTION", false);
  var peg$e15 = peg$literalExpectation("check_option", true);
  var peg$e16 = peg$literalExpectation("security_barrier", true);
  var peg$e17 = peg$literalExpectation("security_invoker", true);
  var peg$e18 = peg$literalExpectation("GRANTS", true);
  var peg$e19 = peg$literalExpectation(".", false);
  var peg$e20 = peg$literalExpectation("ALGORITHM", true);
  var peg$e21 = peg$literalExpectation("DEFAULT", true);
  var peg$e22 = peg$literalExpectation("INSTANT", true);
  var peg$e23 = peg$literalExpectation("INPLACE", true);
  var peg$e24 = peg$literalExpectation("COPY", true);
  var peg$e25 = peg$literalExpectation("LOCK", true);
  var peg$e26 = peg$literalExpectation("NONE", true);
  var peg$e27 = peg$literalExpectation("SHARED", true);
  var peg$e28 = peg$literalExpectation("EXCLUSIVE", true);
  var peg$e29 = peg$literalExpectation("AUTO_INCREMENT", true);
  var peg$e30 = peg$literalExpectation("UNIQUE", true);
  var peg$e31 = peg$literalExpectation("KEY", true);
  var peg$e32 = peg$literalExpectation("PRIMARY", true);
  var peg$e33 = peg$literalExpectation("FOR", true);
  var peg$e34 = peg$literalExpectation("COLUMN_FORMAT", true);
  var peg$e35 = peg$literalExpectation("FIXED", true);
  var peg$e36 = peg$literalExpectation("DYNAMIC", true);
  var peg$e37 = peg$literalExpectation("STORAGE", true);
  var peg$e38 = peg$literalExpectation("DISK", true);
  var peg$e39 = peg$literalExpectation("MEMORY", true);
  var peg$e40 = peg$literalExpectation("MATCH FULL", true);
  var peg$e41 = peg$literalExpectation("MATCH PARTIAL", true);
  var peg$e42 = peg$literalExpectation("MATCH SIMPLE", true);
  var peg$e43 = peg$literalExpectation("expiration_timestamp", true);
  var peg$e44 = peg$literalExpectation("partition_expiration_days", true);
  var peg$e45 = peg$literalExpectation("require_partition_filter", true);
  var peg$e46 = peg$literalExpectation("kms_key_name", true);
  var peg$e47 = peg$literalExpectation("friendly_name", true);
  var peg$e48 = peg$literalExpectation("description", true);
  var peg$e49 = peg$literalExpectation("labels", true);
  var peg$e50 = peg$literalExpectation("default_rounding_mode", true);
  var peg$e51 = peg$literalExpectation("AVG_ROW_LENGTH", true);
  var peg$e52 = peg$literalExpectation("KEY_BLOCK_SIZE", true);
  var peg$e53 = peg$literalExpectation("MAX_ROWS", true);
  var peg$e54 = peg$literalExpectation("MIN_ROWS", true);
  var peg$e55 = peg$literalExpectation("STATS_SAMPLE_PAGES", true);
  var peg$e56 = peg$literalExpectation("CONNECTION", true);
  var peg$e57 = peg$literalExpectation("COMPRESSION", true);
  var peg$e58 = peg$literalExpectation("'", false);
  var peg$e59 = peg$literalExpectation("ZLIB", true);
  var peg$e60 = peg$literalExpectation("LZ4", true);
  var peg$e61 = peg$literalExpectation("ENGINE", true);
  var peg$e62 = peg$literalExpectation("CLUSTER", true);
  var peg$e63 = peg$literalExpectation("BY", true);
  var peg$e64 = peg$literalExpectation("OPTIONS", true);
  var peg$e65 = peg$literalExpectation("CHARSET", true);
  var peg$e66 = peg$literalExpectation("COLLATE", true);
  var peg$e67 = peg$literalExpectation("READ", true);
  var peg$e68 = peg$literalExpectation("LOW_PRIORITY", true);
  var peg$e69 = peg$literalExpectation("WRITE", true);
  var peg$e70 = peg$literalExpectation("FOREIGN KEY", true);
  var peg$e71 = peg$literalExpectation("NOT", true);
  var peg$e72 = peg$literalExpectation("REPLICATION", true);
  var peg$e73 = peg$literalExpectation("BTREE", true);
  var peg$e74 = peg$literalExpectation("HASH", true);
  var peg$e75 = peg$literalExpectation("WITH", true);
  var peg$e76 = peg$literalExpectation("PARSER", true);
  var peg$e77 = peg$literalExpectation("VISIBLE", true);
  var peg$e78 = peg$literalExpectation("INVISIBLE", true);
  var peg$e79 = peg$literalExpectation("RESTRICT", true);
  var peg$e80 = peg$literalExpectation("CASCADE", true);
  var peg$e81 = peg$literalExpectation("SET NULL", true);
  var peg$e82 = peg$literalExpectation("NO ACTION", true);
  var peg$e83 = peg$literalExpectation("SET DEFAULT", true);
  var peg$e84 = peg$literalExpectation("UPDATE", true);
  var peg$e85 = peg$literalExpectation("CREATE", true);
  var peg$e86 = peg$literalExpectation("DELETE", true);
  var peg$e87 = peg$literalExpectation("INSERT", true);
  var peg$e88 = peg$literalExpectation(":=", false);
  var peg$e89 = peg$literalExpectation("return", true);
  var peg$e90 = peg$literalExpectation("REPLACE", true);
  var peg$e91 = peg$literalExpectation("ANALYZE", true);
  var peg$e92 = peg$literalExpectation("ATTACH", true);
  var peg$e93 = peg$literalExpectation("DATABASE", true);
  var peg$e94 = peg$literalExpectation("RENAME", true);
  var peg$e95 = peg$literalExpectation("SHOW", true);
  var peg$e96 = peg$literalExpectation("DESCRIBE", true);
  var peg$e97 = peg$literalExpectation("@", false);
  var peg$e98 = peg$literalExpectation("@@", false);
  var peg$e99 = peg$literalExpectation("$", false);
  var peg$e100 = peg$classExpectation(["$", "@"], false, false);
  var peg$e101 = peg$literalExpectation("TEMPORARY", true);
  var peg$e102 = peg$literalExpectation("TEMP", true);
  var peg$e103 = peg$literalExpectation("SCHEMA", true);
  var peg$e104 = peg$literalExpectation("ALTER", true);
  var peg$e105 = peg$literalExpectation("SPATIAL", true);
  var peg$e106 = peg$literalExpectation("(", false);
  var peg$e107 = peg$literalExpectation(")", false);
  var peg$e108 = peg$literalExpectation("INTERSECT", true);
  var peg$e109 = peg$literalExpectation("EXCEPT", true);
  var peg$e110 = peg$literalExpectation("SYSTEM_TIME", true);
  var peg$e111 = peg$literalExpectation("AS", true);
  var peg$e112 = peg$literalExpectation("OF", true);
  var peg$e113 = peg$literalExpectation("UNNEST", true);
  var peg$e114 = peg$classExpectation(["@"], false, false);
  var peg$e115 = peg$classExpectation(["{"], false, false);
  var peg$e116 = peg$classExpectation(["="], false, false);
  var peg$e117 = peg$classExpectation(["}"], false, false);
  var peg$e118 = peg$literalExpectation("TABLESAMPLE", true);
  var peg$e119 = peg$literalExpectation("BERNOULLI", true);
  var peg$e120 = peg$literalExpectation("RESERVOIR", true);
  var peg$e121 = peg$literalExpectation("PERCENT", true);
  var peg$e122 = peg$literalExpectation("ROWS", true);
  var peg$e123 = peg$literalExpectation("RANGE", true);
  var peg$e124 = peg$literalExpectation("UNBOUNDED", true);
  var peg$e125 = peg$literalExpectation("PRECEDING", true);
  var peg$e126 = peg$literalExpectation("CURRENT", true);
  var peg$e127 = peg$literalExpectation("ROW", false);
  var peg$e128 = peg$literalExpectation("FOLLOWING", true);
  var peg$e129 = peg$literalExpectation("ROW", true);
  var peg$e130 = peg$literalExpectation("!", false);
  var peg$e131 = peg$literalExpectation(">=", false);
  var peg$e132 = peg$literalExpectation(">", false);
  var peg$e133 = peg$literalExpectation("<=", false);
  var peg$e134 = peg$literalExpectation("<>", false);
  var peg$e135 = peg$classExpectation([["<", "="]], false, false);
  var peg$e136 = peg$literalExpectation("!=", false);
  var peg$e137 = peg$classExpectation(["+", "-"], false, false);
  var peg$e138 = peg$classExpectation(["%", "*", "/"], false, false);
  var peg$e139 = peg$classExpectation(["!", "+", "-", "~"], false, false);
  var peg$e140 = peg$literalExpectation('"', false);
  var peg$e141 = peg$classExpectation(['"'], true, false);
  var peg$e142 = peg$classExpectation(["'"], true, false);
  var peg$e143 = peg$literalExpectation("`", false);
  var peg$e144 = peg$classExpectation(["`"], true, false);
  var peg$e145 = peg$classExpectation([["A", "Z"], ["a", "z"], "_"], false, false);
  var peg$e146 = peg$classExpectation([["A", "Z"], ["a", "z"], ["0", "9"], "_", "-"], false, false);
  var peg$e147 = peg$classExpectation([["A", "Z"], ["a", "z"], ["0", "9"], "_", ":"], false, false);
  var peg$e148 = peg$classExpectation([":", "@"], false, false);
  var peg$e149 = peg$literalExpectation("string_agg", true);
  var peg$e150 = peg$literalExpectation("*", false);
  var peg$e151 = peg$literalExpectation("ANY_VALUE", true);
  var peg$e152 = peg$literalExpectation("YEAR_MONTH", true);
  var peg$e153 = peg$literalExpectation("DAY_HOUR", true);
  var peg$e154 = peg$literalExpectation("DAY_MINUTE", true);
  var peg$e155 = peg$literalExpectation("DAY_SECOND", true);
  var peg$e156 = peg$literalExpectation("DAY_MICROSECOND", true);
  var peg$e157 = peg$literalExpectation("HOUR_MINUTE", true);
  var peg$e158 = peg$literalExpectation("HOUR_SECOND", true);
  var peg$e159 = peg$literalExpectation("HOUR_MICROSECOND", true);
  var peg$e160 = peg$literalExpectation("MINUTE_SECOND", true);
  var peg$e161 = peg$literalExpectation("MINUTE_MICROSECOND", true);
  var peg$e162 = peg$literalExpectation("SECOND_MICROSECOND", true);
  var peg$e163 = peg$literalExpectation("TIMEZONE_HOUR", true);
  var peg$e164 = peg$literalExpectation("TIMEZONE_MINUTE", true);
  var peg$e165 = peg$literalExpectation("CENTURY", true);
  var peg$e166 = peg$literalExpectation("DAYOFWEEK", true);
  var peg$e167 = peg$literalExpectation("DAY", true);
  var peg$e168 = peg$literalExpectation("DATE", true);
  var peg$e169 = peg$literalExpectation("DECADE", true);
  var peg$e170 = peg$literalExpectation("DOW", true);
  var peg$e171 = peg$literalExpectation("DOY", true);
  var peg$e172 = peg$literalExpectation("EPOCH", true);
  var peg$e173 = peg$literalExpectation("HOUR", true);
  var peg$e174 = peg$literalExpectation("ISODOW", true);
  var peg$e175 = peg$literalExpectation("ISOWEEK", true);
  var peg$e176 = peg$literalExpectation("ISOYEAR", true);
  var peg$e177 = peg$literalExpectation("MICROSECONDS", true);
  var peg$e178 = peg$literalExpectation("MILLENNIUM", true);
  var peg$e179 = peg$literalExpectation("MILLISECONDS", true);
  var peg$e180 = peg$literalExpectation("MINUTE", true);
  var peg$e181 = peg$literalExpectation("MONTH", true);
  var peg$e182 = peg$literalExpectation("QUARTER", true);
  var peg$e183 = peg$literalExpectation("SECOND", true);
  var peg$e184 = peg$literalExpectation("TIME", true);
  var peg$e185 = peg$literalExpectation("TIMEZONE", true);
  var peg$e186 = peg$literalExpectation("WEEK", true);
  var peg$e187 = peg$literalExpectation("YEAR", true);
  var peg$e188 = peg$literalExpectation("DATE_TRUNC", true);
  var peg$e189 = peg$literalExpectation("R", true);
  var peg$e190 = peg$classExpectation(['"', "\\", ["\0", ""], "\x7F"], true, false);
  var peg$e191 = peg$classExpectation(["'", "\\"], true, false);
  var peg$e192 = peg$literalExpectation("\\'", false);
  var peg$e193 = peg$literalExpectation('\\"', false);
  var peg$e194 = peg$literalExpectation("\\\\", false);
  var peg$e195 = peg$literalExpectation("\\/", false);
  var peg$e196 = peg$literalExpectation("\\b", false);
  var peg$e197 = peg$literalExpectation("\\f", false);
  var peg$e198 = peg$literalExpectation("\\n", false);
  var peg$e199 = peg$literalExpectation("\\r", false);
  var peg$e200 = peg$literalExpectation("\\t", false);
  var peg$e201 = peg$literalExpectation("\\u", false);
  var peg$e202 = peg$literalExpectation("\\", false);
  var peg$e203 = peg$literalExpectation("''", false);
  var peg$e204 = peg$literalExpectation('""', false);
  var peg$e205 = peg$literalExpectation("``", false);
  var peg$e206 = peg$classExpectation(["\n", "\r"], false, false);
  var peg$e207 = peg$classExpectation([["0", "9"]], false, false);
  var peg$e208 = peg$classExpectation([["0", "9"], ["a", "f"], ["A", "F"]], false, false);
  var peg$e209 = peg$classExpectation(["e", "E"], false, false);
  var peg$e210 = peg$literalExpectation("NULL", true);
  var peg$e211 = peg$literalExpectation("NOT NULL", true);
  var peg$e212 = peg$literalExpectation("TRUE", true);
  var peg$e213 = peg$literalExpectation("TO", true);
  var peg$e214 = peg$literalExpectation("FALSE", true);
  var peg$e215 = peg$literalExpectation("DROP", true);
  var peg$e216 = peg$literalExpectation("USE", true);
  var peg$e217 = peg$literalExpectation("SELECT", true);
  var peg$e218 = peg$literalExpectation("RECURSIVE", true);
  var peg$e219 = peg$literalExpectation("IGNORE", true);
  var peg$e220 = peg$literalExpectation("EXPLAIN", true);
  var peg$e221 = peg$literalExpectation("PARTITION", true);
  var peg$e222 = peg$literalExpectation("INTO", true);
  var peg$e223 = peg$literalExpectation("FROM", true);
  var peg$e224 = peg$literalExpectation("UNLOCK", true);
  var peg$e225 = peg$literalExpectation("TABLE", true);
  var peg$e226 = peg$literalExpectation("TABLES", true);
  var peg$e227 = peg$literalExpectation("ON", true);
  var peg$e228 = peg$literalExpectation("LEFT", true);
  var peg$e229 = peg$literalExpectation("RIGHT", true);
  var peg$e230 = peg$literalExpectation("FULL", true);
  var peg$e231 = peg$literalExpectation("INNER", true);
  var peg$e232 = peg$literalExpectation("CROSS", true);
  var peg$e233 = peg$literalExpectation("JOIN", true);
  var peg$e234 = peg$literalExpectation("OUTER", true);
  var peg$e235 = peg$literalExpectation("OVER", true);
  var peg$e236 = peg$literalExpectation("UNION", true);
  var peg$e237 = peg$literalExpectation("VALUE", true);
  var peg$e238 = peg$literalExpectation("VALUES", true);
  var peg$e239 = peg$literalExpectation("USING", true);
  var peg$e240 = peg$literalExpectation("WHERE", true);
  var peg$e241 = peg$literalExpectation("GROUP", true);
  var peg$e242 = peg$literalExpectation("ORDER", true);
  var peg$e243 = peg$literalExpectation("HAVING", true);
  var peg$e244 = peg$literalExpectation("QUALIFY", true);
  var peg$e245 = peg$literalExpectation("WINDOW", true);
  var peg$e246 = peg$literalExpectation("ORDINAL", true);
  var peg$e247 = peg$literalExpectation("SAFE_ORDINAL", true);
  var peg$e248 = peg$literalExpectation("LIMIT", true);
  var peg$e249 = peg$literalExpectation("OFFSET", true);
  var peg$e250 = peg$literalExpectation("SAFE_OFFSET", true);
  var peg$e251 = peg$literalExpectation("ASC", true);
  var peg$e252 = peg$literalExpectation("DESC", true);
  var peg$e253 = peg$literalExpectation("ALL", true);
  var peg$e254 = peg$literalExpectation("DISTINCT", true);
  var peg$e255 = peg$literalExpectation("BETWEEN", true);
  var peg$e256 = peg$literalExpectation("IN", true);
  var peg$e257 = peg$literalExpectation("IS", true);
  var peg$e258 = peg$literalExpectation("LIKE", true);
  var peg$e259 = peg$literalExpectation("EXISTS", true);
  var peg$e260 = peg$literalExpectation("AND", true);
  var peg$e261 = peg$literalExpectation("OR", true);
  var peg$e262 = peg$literalExpectation("COUNT", true);
  var peg$e263 = peg$literalExpectation("MAX", true);
  var peg$e264 = peg$literalExpectation("MIN", true);
  var peg$e265 = peg$literalExpectation("SUM", true);
  var peg$e266 = peg$literalExpectation("AVG", true);
  var peg$e267 = peg$literalExpectation("EXTRACT", true);
  var peg$e268 = peg$literalExpectation("CALL", true);
  var peg$e269 = peg$literalExpectation("CASE", true);
  var peg$e270 = peg$literalExpectation("WHEN", true);
  var peg$e271 = peg$literalExpectation("THEN", true);
  var peg$e272 = peg$literalExpectation("ELSE", true);
  var peg$e273 = peg$literalExpectation("END", true);
  var peg$e274 = peg$literalExpectation("CAST", true);
  var peg$e275 = peg$literalExpectation("SAFE_CAST", true);
  var peg$e276 = peg$literalExpectation("ARRAY", true);
  var peg$e277 = peg$literalExpectation("BYTES", true);
  var peg$e278 = peg$literalExpectation("BOOL", true);
  var peg$e279 = peg$literalExpectation("CHAR", true);
  var peg$e280 = peg$literalExpectation("GEOGRAPHY", true);
  var peg$e281 = peg$literalExpectation("VARCHAR", true);
  var peg$e282 = peg$literalExpectation("NUMERIC", true);
  var peg$e283 = peg$literalExpectation("DECIMAL", true);
  var peg$e284 = peg$literalExpectation("SIGNED", true);
  var peg$e285 = peg$literalExpectation("UNSIGNED", true);
  var peg$e286 = peg$literalExpectation("INT64", true);
  var peg$e287 = peg$literalExpectation("ZEROFILL", true);
  var peg$e288 = peg$literalExpectation("INTEGER", true);
  var peg$e289 = peg$literalExpectation("JSON", true);
  var peg$e290 = peg$literalExpectation("SMALLINT", true);
  var peg$e291 = peg$literalExpectation("STRING", true);
  var peg$e292 = peg$literalExpectation("STRUCT", true);
  var peg$e293 = peg$literalExpectation("TINYINT", true);
  var peg$e294 = peg$literalExpectation("TINYTEXT", true);
  var peg$e295 = peg$literalExpectation("TEXT", true);
  var peg$e296 = peg$literalExpectation("MEDIUMTEXT", true);
  var peg$e297 = peg$literalExpectation("LONGTEXT", true);
  var peg$e298 = peg$literalExpectation("BIGINT", true);
  var peg$e299 = peg$literalExpectation("FLOAT64", true);
  var peg$e300 = peg$literalExpectation("DOUBLE", true);
  var peg$e301 = peg$literalExpectation("DATETIME", true);
  var peg$e302 = peg$literalExpectation("TIMESTAMP", true);
  var peg$e303 = peg$literalExpectation("TRUNCATE", true);
  var peg$e304 = peg$literalExpectation("USER", true);
  var peg$e305 = peg$literalExpectation("CURRENT_DATE", true);
  var peg$e306 = peg$literalExpectation("ADDDATE", true);
  var peg$e307 = peg$literalExpectation("INTERVAL", true);
  var peg$e308 = peg$literalExpectation("CURRENT_TIME", true);
  var peg$e309 = peg$literalExpectation("CURRENT_TIMESTAMP", true);
  var peg$e310 = peg$literalExpectation("SESSION_USER", true);
  var peg$e311 = peg$literalExpectation("GLOBAL", true);
  var peg$e312 = peg$literalExpectation("SESSION", true);
  var peg$e313 = peg$literalExpectation("PIVOT", true);
  var peg$e314 = peg$literalExpectation("PERSIST", true);
  var peg$e315 = peg$literalExpectation("PERSIST_ONLY", true);
  var peg$e316 = peg$literalExpectation("VIEW", true);
  var peg$e317 = peg$literalExpectation("ADD", true);
  var peg$e318 = peg$literalExpectation("COLUMN", true);
  var peg$e319 = peg$literalExpectation("INDEX", true);
  var peg$e320 = peg$literalExpectation("FULLTEXT", true);
  var peg$e321 = peg$literalExpectation("COMMENT", true);
  var peg$e322 = peg$literalExpectation("CONSTRAINT", true);
  var peg$e323 = peg$literalExpectation("REFERENCES", true);
  var peg$e324 = peg$literalExpectation(",", false);
  var peg$e325 = peg$literalExpectation("<", false);
  var peg$e326 = peg$literalExpectation("[", false);
  var peg$e327 = peg$literalExpectation("]", false);
  var peg$e328 = peg$literalExpectation(";", false);
  var peg$e329 = peg$literalExpectation("||", false);
  var peg$e330 = peg$literalExpectation("&&", false);
  var peg$e331 = peg$literalExpectation("/*", false);
  var peg$e332 = peg$literalExpectation("*/", false);
  var peg$e333 = peg$literalExpectation("--", false);
  var peg$e334 = peg$literalExpectation("#", false);
  var peg$e335 = peg$anyExpectation();
  var peg$e336 = peg$classExpectation([" ", "	", "\n", "\r"], false, false);
  var peg$e337 = peg$literalExpectation("MAX", false);
  var peg$e338 = peg$literalExpectation("max", false);
  var peg$e339 = peg$literalExpectation("NULL", false);
  var peg$e340 = peg$literalExpectation("TRUE", false);
  var peg$e341 = peg$literalExpectation("FALSE", false);
  var peg$e342 = peg$literalExpectation("JSON_EXTRACT", false);
  var peg$e343 = peg$literalExpectation("JSON_EXTRACT_SCALAR", false);
  var peg$e344 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false);
  var peg$e345 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false);
  var peg$e346 = peg$literalExpectation("ARRAY", false);
  var peg$e347 = peg$literalExpectation("STRING", false);
  var peg$e348 = peg$literalExpectation("INTEGER", false);
  var peg$e349 = peg$literalExpectation("FLOAT", false);
  var peg$e350 = peg$literalExpectation("BOOLEAN", false);
  var peg$e351 = peg$literalExpectation("DATE", false);
  var peg$e352 = peg$literalExpectation("DATETIME", false);
  var peg$e353 = peg$literalExpectation("TIMESTAMP", false);
  var peg$e354 = peg$literalExpectation("UNNEST", false);
  var peg$f0 = function(n) {
    return n;
  };
  var peg$f1 = function(head, tail) {
    const headAst = head && head.ast || head;
    const cur = tail && tail.length && tail[0].length >= 4 ? [headAst] : headAst;
    for (let i = 0; i < tail.length; i++) {
      if (!tail[i][3] || tail[i][3].length === 0) continue;
      cur.push(tail[i][3] && tail[i][3].ast || tail[i][3]);
    }
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: cur
    };
  };
  var peg$f2 = function(t, l, f, w, or, lc) {
    if (t) t.forEach((tableInfo) => {
      const { db, as, table, join: join2 } = tableInfo;
      const action = join2 ? "select" : "update";
      tableList.add(`${action}::${db}::${table}`);
    });
    if (f) f.forEach((info) => {
      info.table && tableList.add(`update::${info.db}::${info.table}`);
    });
    if (l) {
      l.forEach((col) => columnList.add(`update::${col.table}::${col.column}`));
    }
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "update",
        table: t,
        set: l,
        where: w,
        orderby: or,
        limit: lc
      }
    };
  };
  var peg$f3 = function(t, f, w, or, l) {
    if (t) t.forEach((tt) => tableList.add(`delete::${tt.db}::${tt.table}`));
    if (f) f.forEach((tableInfo) => {
      const { db, as, table, join: join2 } = tableInfo;
      const action = join2 ? "select" : "delete";
      if (table) tableList.add(`${action}::${db}::${table}`);
      if (!join2) columnList.add(`delete::${table}::(.*)`);
    });
    if (t === null && f.length === 1) {
      const tableInfo = f[0];
      t = [{
        db: tableInfo.db,
        table: tableInfo.table,
        as: tableInfo.as,
        addition: true
      }];
    }
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "delete",
        table: t,
        from: f,
        where: w,
        orderby: or,
        limit: l
      }
    };
  };
  var peg$f4 = function(ri, t, p, c, v, odp) {
    if (t) {
      tableList.add(`insert::${t.db}::${t.table}`);
      t.as = null;
    }
    if (c) {
      let table = t && t.table || null;
      if (Array.isArray(v)) {
        v.forEach((row, idx) => {
          if (row.value.length != c.length) {
            throw new Error(`Error: column count doesn't match value count at row ${idx + 1}`);
          }
        });
      }
      c.forEach((c2) => columnList.add(`insert::${table}::${c2}`));
    }
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: ri,
        table: [t],
        columns: c,
        values: v,
        partition: p,
        on_duplicate_update: odp
      }
    };
  };
  var peg$f5 = function(ri, ig, it, t, p, v, odp) {
    if (t) {
      tableList.add(`insert::${t.db}::${t.table}`);
      columnList.add(`insert::${t.table}::(.*)`);
      t.as = null;
    }
    const prefix = [ig, it].filter((v2) => v2).map((v2) => v2[0] && v2[0].toLowerCase()).join(" ");
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: ri,
        table: [t],
        columns: null,
        values: v,
        partition: p,
        prefix,
        on_duplicate_update: odp
      }
    };
  };
  var peg$f6 = function(ri, t, p, l, odp) {
    if (t) {
      tableList.add(`insert::${t.db}::${t.table}`);
      columnList.add(`insert::${t.table}::(.*)`);
      t.as = null;
    }
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: ri,
        table: [t],
        columns: null,
        partition: p,
        set: l,
        on_duplicate_update: odp
      }
    };
  };
  var peg$f7 = function() {
    varList = [];
    return true;
  };
  var peg$f8 = function(s) {
    return { stmt: s, vars: varList };
  };
  var peg$f9 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f10 = function(va, s, e) {
    return {
      type: "assign",
      left: va,
      symbol: s,
      right: e
    };
  };
  var peg$f11 = function(e) {
    return { type: "return", expr: e };
  };
  var peg$f12 = function(head, tail) {
    return createBinaryExprChain(head, tail);
  };
  var peg$f13 = function(head, tail) {
    return createBinaryExprChain(head, tail);
  };
  var peg$f14 = function(lt, op, rt, expr) {
    return {
      type: "join",
      ltable: lt,
      rtable: rt,
      op,
      on: expr
    };
  };
  var peg$f15 = function(e) {
    e.parentheses = true;
    return e;
  };
  var peg$f16 = function(name, l) {
    return __spreadValues({
      type: "function",
      name,
      args: {
        type: "expr_list",
        value: l
      }
    }, getLocationObject());
  };
  var peg$f17 = function(name) {
    return __spreadValues({
      type: "function",
      name,
      args: null
    }, getLocationObject());
  };
  var peg$f18 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f19 = function(l) {
    return { type: "array", value: l, brackets: true };
  };
  var peg$f20 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f21 = function(tbl, c, v) {
    return { column: c, value: v, table: tbl && tbl[0] };
  };
  var peg$f22 = function(tbl, c, v) {
    return { column: c, value: v, table: tbl && tbl[0], keyword: "values" };
  };
  var peg$f23 = function() {
    return "insert";
  };
  var peg$f24 = function() {
    return "replace";
  };
  var peg$f25 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f26 = function(v) {
    return v;
  };
  var peg$f27 = function(s) {
    return {
      keyword: "on duplicate key update",
      set: s
    };
  };
  var peg$f28 = function(a, t) {
    tableList.add(`${a}::${t.db}::${t.table}`);
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a.toLowerCase(),
        table: t
      }
    };
  };
  var peg$f29 = function(a, db, e, as, schema) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a.toLowerCase(),
        database: db,
        expr: e,
        as: as && as[0].toLowerCase(),
        schema
      }
    };
  };
  var peg$f30 = function(a, r, t) {
    if (t) t.forEach((tt) => tableList.add(`${a}::${tt.db}::${tt.table}`));
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a.toLowerCase(),
        keyword: r.toLowerCase(),
        name: t
      }
    };
  };
  var peg$f31 = function(a, r, i, t, op) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a.toLowerCase(),
        keyword: r.toLowerCase(),
        name: i,
        table: t,
        options: op
      }
    };
  };
  var peg$f32 = function(a, kw, t) {
    if (t) t.forEach((tt) => tableList.add(`${a}::${tt.db}::${tt.table}`));
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a.toLowerCase(),
        keyword: kw && kw.toLowerCase() || "table",
        name: t
      }
    };
  };
  var peg$f33 = function(t) {
    t.forEach((tg) => tg.forEach((dt) => dt.table && tableList.add(`rename::${dt.db}::${dt.table}`)));
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "rename",
        table: t
      }
    };
  };
  var peg$f34 = function(e) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "call",
        expr: e
      }
    };
  };
  var peg$f35 = function(d) {
    tableList.add(`use::${d}::null`);
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "use",
        db: d
      }
    };
  };
  var peg$f36 = function(kw, a) {
    a.keyword = kw;
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "set",
        keyword: kw,
        expr: a
      }
    };
  };
  var peg$f37 = function(ltl) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "lock",
        keyword: "tables",
        tables: ltl
      }
    };
  };
  var peg$f38 = function() {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "unlock",
        keyword: "tables"
      }
    };
  };
  var peg$f39 = function(t) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "show",
        suffix: "logs",
        keyword: t.toLowerCase()
      }
    };
  };
  var peg$f40 = function(ins, from2, limit) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "show",
        suffix: "events",
        keyword: "binlog",
        in: ins,
        from: from2,
        limit
      }
    };
  };
  var peg$f41 = function(k, e) {
    let keyword = Array.isArray(k) && k || [k];
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "show",
        suffix: keyword[2] && keyword[2].toLowerCase(),
        keyword: keyword[0].toLowerCase(),
        expr: e
      }
    };
  };
  var peg$f42 = function(t) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "desc",
        table: t
      }
    };
  };
  var peg$f43 = function(p, d) {
    return __spreadProps(__spreadValues({
      type: "var"
    }, d), {
      prefix: p
    });
  };
  var peg$f44 = function(name, m) {
    varList.push(name);
    return {
      type: "var",
      name,
      members: m,
      prefix: null
    };
  };
  var peg$f45 = function(n) {
    return {
      type: "var",
      name: n.value,
      members: [],
      quoted: null,
      prefix: null
    };
  };
  var peg$f46 = function(l) {
    return l;
  };
  var peg$f47 = function(l) {
    return l;
  };
  var peg$f48 = function(head, tail) {
    return createList(head, tail, 1);
  };
  var peg$f49 = function() {
    return "IF NOT EXISTS";
  };
  var peg$f50 = function(a, or, tp, ife, t, c, to, as, qe) {
    if (t) tableList.add(`create::${t.db}::${t.table}`);
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a[0].toLowerCase(),
        keyword: "table",
        temporary: tp && tp[0].toLowerCase(),
        if_not_exists: ife,
        table: [t],
        replace: or && "or replace",
        as: as && as[0].toLowerCase(),
        query_expr: qe && qe.ast,
        create_definitions: c,
        table_options: to
      }
    };
  };
  var peg$f51 = function(a, tp, ife, t, lt) {
    if (t) t.forEach((tt) => tableList.add(`create::${tt.db}::${tt.table}`));
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a[0].toLowerCase(),
        keyword: "table",
        temporary: tp && tp[0].toLowerCase(),
        if_not_exists: ife,
        table: t,
        like: lt
      }
    };
  };
  var peg$f52 = function(a, k, ife, t, c) {
    const keyword = k.toLowerCase();
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a[0].toLowerCase(),
        keyword,
        if_not_exists: ife,
        [keyword]: { db: t.schema, schema: t.name },
        create_definitions: c
      }
    };
  };
  var peg$f53 = function(c) {
    return `with ${c.toLowerCase()} check option`;
  };
  var peg$f54 = function() {
    return "with check option";
  };
  var peg$f55 = function(t) {
    return { type: "check_option", value: t, symbol: "=" };
  };
  var peg$f56 = function(k, t) {
    return { type: k.toLowerCase(), value: t.value ? "true" : "false", symbol: "=" };
  };
  var peg$f57 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f58 = function(a, or, tp, r, v, c, wo, s, w) {
    v.view = v.table;
    delete v.table;
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: a[0].toLowerCase(),
        keyword: "view",
        replace: or && "or replace",
        temporary: tp && tp[0].toLowerCase(),
        recursive: r && r.toLowerCase(),
        columns: c && c[2],
        select: s,
        view: v,
        with_options: wo && wo[4],
        with: w
      }
    };
  };
  var peg$f59 = function(t, e) {
    if (t && t.length > 0) t.forEach((table) => tableList.add(`alter::${table.db}::${table.table}`));
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "alter",
        table: t,
        expr: e
      }
    };
  };
  var peg$f60 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f61 = function(f) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: {
        type: "show",
        keyword: "grants",
        for: f
      }
    };
  };
  var peg$f62 = function(l) {
    const s = [];
    for (let i = 0; i < l.length; i++) {
      s.push(l[i][1]);
    }
    return s;
  };
  var peg$f63 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f64 = function(s, val) {
    return {
      type: "alter",
      keyword: "algorithm",
      resource: "algorithm",
      symbol: s,
      algorithm: val
    };
  };
  var peg$f65 = function(s, val) {
    return {
      type: "alter",
      keyword: "lock",
      resource: "lock",
      symbol: s,
      lock: val
    };
  };
  var peg$f66 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f67 = function(n) {
    if (n && !n.value) n.value = "null";
    return { nullable: n };
  };
  var peg$f68 = function(d) {
    return { default_val: d };
  };
  var peg$f69 = function(a) {
    return { auto_increment: a.toLowerCase() };
  };
  var peg$f70 = function(k) {
    const sql = ["unique"];
    if (k) sql.push(k);
    return { unique: sql.join(" ").toLowerCase("") };
  };
  var peg$f71 = function(p) {
    const sql = [];
    if (p) sql.push("primary");
    sql.push("key");
    return { primary_key: sql.join(" ").toLowerCase("") };
  };
  var peg$f72 = function(co) {
    return { comment: co };
  };
  var peg$f73 = function(ca) {
    return { collate: ca };
  };
  var peg$f74 = function(cf) {
    return { column_format: cf };
  };
  var peg$f75 = function(s) {
    return { storage: s };
  };
  var peg$f76 = function(re) {
    return { reference_definition: re };
  };
  var peg$f77 = function(head, tail) {
    let opt = head;
    for (let i = 0; i < tail.length; i++) {
      opt = __spreadValues(__spreadValues({}, opt), tail[i][1]);
    }
    return opt;
  };
  var peg$f78 = function(c, d, cdo) {
    columnList.add(`create::${c.table}::${c.column}`);
    return __spreadValues({
      column: c,
      definition: d,
      resource: "column"
    }, cdo || {});
  };
  var peg$f79 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f80 = function(e) {
    e.parentheses = true;
    return e;
  };
  var peg$f81 = function(head, tail) {
    return createList(head, tail, 1);
  };
  var peg$f82 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f83 = function(t, lt) {
    tableList.add(`lock::${t.db}::${t.table}`);
    return {
      table: t,
      lock_type: lt
    };
  };
  var peg$f84 = function(n, h, u) {
    return {
      user: n,
      host: h && h[2],
      role_list: u
    };
  };
  var peg$f85 = function(kc, c, t, de, id) {
    return {
      index: c,
      definition: de,
      keyword: kc.toLowerCase(),
      index_type: t,
      resource: "index",
      index_options: id
    };
  };
  var peg$f86 = function(p, kc, c, de, id) {
    return {
      index: c,
      definition: de,
      keyword: kc && `${p.toLowerCase()} ${kc.toLowerCase()}` || p.toLowerCase(),
      index_options: id,
      resource: "index"
    };
  };
  var peg$f87 = function(ce) {
    return {
      type: "default",
      value: ce
    };
  };
  var peg$f88 = function(k, s, c) {
    return {
      type: k.toLowerCase(),
      keyword: k.toLowerCase(),
      symbol: s,
      value: c
    };
  };
  var peg$f89 = function(ca, s, t) {
    return {
      type: "collate",
      keyword: "collate",
      collate: {
        name: ca,
        symbol: s,
        value: t
      }
    };
  };
  var peg$f90 = function(s, ca) {
    return {
      type: "collate",
      keyword: "collate",
      collate: {
        name: ca,
        symbol: s
      }
    };
  };
  var peg$f91 = function(k, f) {
    return {
      type: "column_format",
      value: f.toLowerCase()
    };
  };
  var peg$f92 = function(k, s) {
    return {
      type: "storage",
      value: s.toLowerCase()
    };
  };
  var peg$f93 = function(kc, t, de, m, od, ou) {
    const on_action = [];
    return {
      definition: de,
      table: t,
      keyword: kc.toLowerCase(),
      match: m && m.toLowerCase(),
      on_action: [od, ou].filter((v) => v)
    };
  };
  var peg$f94 = function(oa) {
    return {
      on_action: [oa]
    };
  };
  var peg$f95 = function(k, s, v) {
    return {
      keyword: k,
      symbol: "=",
      value: v
    };
  };
  var peg$f96 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f97 = function(kw, s, v) {
    return {
      keyword: kw.toLowerCase(),
      symbol: s,
      value: v.value
    };
  };
  var peg$f98 = function(kw, s, c) {
    return {
      keyword: kw.toLowerCase(),
      symbol: s,
      value: `'${c.value}'`
    };
  };
  var peg$f99 = function(kw, s, v) {
    return {
      keyword: kw.toLowerCase(),
      symbol: s,
      value: v.join("").toUpperCase()
    };
  };
  var peg$f100 = function(kw, s, c) {
    return {
      keyword: kw.toLowerCase(),
      symbol: s,
      value: c.toUpperCase()
    };
  };
  var peg$f101 = function(v) {
    return {
      keyword: "partition by",
      value: v
    };
  };
  var peg$f102 = function(c) {
    return {
      keyword: "cluster by",
      value: c
    };
  };
  var peg$f103 = function(v) {
    return {
      keyword: "options",
      parentheses: true,
      value: v
    };
  };
  var peg$f104 = function(t) {
    return {
      type: "like",
      table: t
    };
  };
  var peg$f105 = function(kw, t, s, v) {
    return {
      keyword: kw && `${kw[0].toLowerCase()} ${t.toLowerCase()}` || t.toLowerCase(),
      symbol: s,
      value: v
    };
  };
  var peg$f106 = function(s) {
    return {
      type: "read",
      suffix: s && "local"
    };
  };
  var peg$f107 = function(p) {
    return {
      type: "write",
      prefix: p && "low_priority"
    };
  };
  var peg$f108 = function(l) {
    return l;
  };
  var peg$f109 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f110 = function(kc, p, t, de, id) {
    return {
      constraint: kc && kc.constraint,
      definition: de,
      constraint_type: `${p[0].toLowerCase()} ${p[2].toLowerCase()}`,
      keyword: kc && kc.keyword,
      index_type: t,
      resource: "constraint",
      index_options: id
    };
  };
  var peg$f111 = function(kc, u, p, i, t, de, id) {
    return {
      constraint: kc && kc.constraint,
      definition: de,
      constraint_type: p && `${u.toLowerCase()} ${p.toLowerCase()}` || u.toLowerCase(),
      keyword: kc && kc.keyword,
      index_type: t,
      index: i,
      resource: "constraint",
      index_options: id
    };
  };
  var peg$f112 = function(kc, p, i, de, id) {
    return {
      constraint: kc && kc.constraint,
      definition: de,
      constraint_type: p,
      keyword: kc && kc.keyword,
      index: i,
      resource: "constraint",
      reference_definition: id
    };
  };
  var peg$f113 = function(kc, u, nfr, c) {
    return {
      constraint_type: u.toLowerCase(),
      keyword: kc && kc.keyword,
      constraint: kc && kc.constraint,
      index_type: nfr && { keyword: "not for replication" },
      definition: [c],
      resource: "constraint"
    };
  };
  var peg$f114 = function(t) {
    return {
      keyword: "using",
      type: t.toLowerCase()
    };
  };
  var peg$f115 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f116 = function(head, tail) {
    const result = [head];
    for (let i = 0; i < tail.length; i++) {
      result.push(tail[i][1]);
    }
    return result;
  };
  var peg$f117 = function(k, e, kbs) {
    return {
      type: k.toLowerCase(),
      symbol: e,
      expr: kbs
    };
  };
  var peg$f118 = function(pn) {
    return {
      type: "with parser",
      expr: pn
    };
  };
  var peg$f119 = function(k) {
    return {
      type: k.toLowerCase(),
      expr: k.toLowerCase()
    };
  };
  var peg$f120 = function(kw, ro) {
    return {
      type: `on ${kw[0].toLowerCase()}`,
      value: ro
    };
  };
  var peg$f121 = function() {
    return "CHARACTER SET";
  };
  var peg$f122 = function(kc, cd) {
    return __spreadProps(__spreadValues({
      action: "add"
    }, cd), {
      keyword: kc,
      resource: "column",
      type: "alter"
    });
  };
  var peg$f123 = function(kc, c) {
    return {
      action: "drop",
      column: c,
      keyword: kc,
      resource: "column",
      type: "alter"
    };
  };
  var peg$f124 = function(kw, tn) {
    return {
      action: "rename",
      type: "alter",
      resource: "table",
      keyword: kw && kw[0].toLowerCase(),
      table: tn
    };
  };
  var peg$f125 = function(kc, c) {
    return {
      keyword: kc.toLowerCase(),
      constraint: c
    };
  };
  var peg$f126 = function(kw, l) {
    return {
      type: "function",
      name: { name: [{ type: "origin", value: kw }] },
      args: l
    };
  };
  var peg$f127 = function(kc) {
    return {
      type: "origin",
      value: kc.toLowerCase()
    };
  };
  var peg$f128 = function(s) {
    return __spreadProps(__spreadValues({}, s[2]), {
      parentheses_symbol: true
    });
  };
  var peg$f129 = function(s, o, l) {
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: __spreadProps(__spreadValues({}, s.ast), {
        _orderby: o,
        _limit: l,
        _parentheses: s._parentheses
      })
    };
  };
  var peg$f130 = function(u, s) {
    return s ? `union ${s.toLowerCase()}` : "union";
  };
  var peg$f131 = function(u, s) {
    return `${u.toLowerCase()} ${s.toLowerCase()}`;
  };
  var peg$f132 = function(s) {
    return __spreadProps(__spreadValues({}, s[2]), {
      _parentheses: true
    });
  };
  var peg$f133 = function(head, tail, ob, l) {
    let cur = head;
    for (let i = 0; i < tail.length; i++) {
      cur._next = tail[i][3];
      cur.set_op = tail[i][1];
      cur = cur._next;
    }
    return {
      tableList: Array.from(tableList),
      columnList: columnListTableAlias(columnList),
      ast: head
    };
  };
  var peg$f134 = function(s) {
    return __spreadProps(__spreadValues({}, s[2]), {
      parentheses_symbol: true
    });
  };
  var peg$f135 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f136 = function(name, stmt) {
    if (typeof name === "string") name = { type: "default", value: name };
    return { name, stmt };
  };
  var peg$f137 = function(cte, sv, d, c, f, fs, w, g, h, q, o, l, win) {
    if (Array.isArray(f)) f.forEach((info) => info.table && tableList.add(`select::${info.db}::${info.table}`));
    return __spreadValues({
      type: "select",
      as_struct_val: sv,
      distinct: d,
      columns: c,
      from: f,
      for_sys_time_as_of: fs,
      where: w,
      with: cte,
      groupby: g,
      having: h,
      qualify: q,
      orderby: o,
      limit: l,
      window: win
    }, getLocationObject());
  };
  var peg$f138 = function(e) {
    return {
      keyword: "for system_time as of",
      expr: e
    };
  };
  var peg$f139 = function(a, k) {
    return `${a[0].toLowerCase()} ${k.toLowerCase()}`;
  };
  var peg$f140 = function(e, alias) {
    return __spreadValues({ expr: e, as: alias }, getLocationObject());
  };
  var peg$f141 = function(c) {
    return c;
  };
  var peg$f142 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f143 = function(l) {
    return l.map((item) => ({ value: item[2] }));
  };
  var peg$f144 = function(l) {
    return l.map((item) => ({ name: item[2], value: item[6] }));
  };
  var peg$f145 = function(n, l) {
    return {
      expr: n,
      offset: l
    };
  };
  var peg$f146 = function(p, k, c) {
    const tbl = p && p[0];
    columnList.add(`select::${tbl}::(.*)`);
    return __spreadValues({
      expr_list: c,
      parentheses: true,
      expr: {
        type: "column_ref",
        table: tbl,
        column: "*"
      },
      type: k.toLowerCase()
    }, getLocationObject());
  };
  var peg$f147 = function(head) {
    columnList.add("select::null::(.*)");
    const item = __spreadValues({
      expr: {
        type: "column_ref",
        table: null,
        column: "*"
      },
      as: null
    }, getLocationObject());
    return item;
  };
  var peg$f148 = function(tbl, pro) {
    columnList.add(`select::${tbl}::(.*)`);
    let column = "*";
    const mid = pro && pro[0];
    if (typeof mid === "string") column = `${mid}.*`;
    if (mid && mid.expr && mid.offset) column = __spreadProps(__spreadValues({}, mid), { suffix: ".*" });
    return __spreadValues({
      expr: {
        type: "column_ref",
        table: tbl,
        column
      },
      as: null
    }, getLocationObject());
  };
  var peg$f149 = function(c, s, as) {
    if (s) c.suffix = `.${s[2]}`;
    return __spreadValues({
      expr: {
        type: "column_ref",
        table: null,
        column: c
      },
      as
    }, getLocationObject());
  };
  var peg$f150 = function(i) {
    return i;
  };
  var peg$f151 = function(i) {
    return i;
  };
  var peg$f152 = function(a, alias, wf) {
    return {
      type: "unnest",
      expr: a,
      parentheses: true,
      as: alias,
      with_offset: wf
    };
  };
  var peg$f153 = function(l, op) {
    if (l[0]) l[0].operator = op;
    return l;
  };
  var peg$f154 = function(a, c, i, as) {
    i.operator = "=";
    return {
      "type": "pivot",
      "expr": a,
      column: c,
      in_expr: i,
      as
    };
  };
  var peg$f155 = function(alias) {
    return {
      keyword: "with offset as",
      as: alias
    };
  };
  var peg$f156 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f157 = function(head, tail) {
    return [head, tail];
  };
  var peg$f158 = function(head, tail) {
    tail.unshift(head);
    tail.forEach((tableInfo) => {
      const { table, as } = tableInfo;
      tableAlias[table] = table;
      if (as) tableAlias[as] = table;
      refreshColumnList(columnList);
    });
    return tail;
  };
  var peg$f159 = function(t) {
    return t;
  };
  var peg$f160 = function(t) {
    return t;
  };
  var peg$f161 = function(op, t, head, tail) {
    t.join = op;
    t.using = createList(head, tail);
    return t;
  };
  var peg$f162 = function(op, t, expr) {
    t.join = op;
    t.on = expr;
    return t;
  };
  var peg$f163 = function(op, stmt, alias, expr) {
    stmt.parentheses = true;
    return {
      expr: stmt,
      as: alias,
      join: op,
      on: expr
    };
  };
  var peg$f164 = function(t, ht, ts, alias) {
    if (t.type === "var") {
      t.as = alias;
      return t;
    }
    return __spreadValues(__spreadProps(__spreadValues({}, t), {
      as: alias
    }), getLocationObject());
  };
  var peg$f165 = function(stmt, ts, alias) {
    stmt.parentheses = true;
    return __spreadValues({
      expr: stmt,
      as: alias
    }, getLocationObject());
  };
  var peg$f166 = function() {
    return "LEFT JOIN";
  };
  var peg$f167 = function() {
    return "RIGHT JOIN";
  };
  var peg$f168 = function() {
    return "FULL JOIN";
  };
  var peg$f169 = function(k) {
    return `${k[0].toUpperCase()} JOIN`;
  };
  var peg$f170 = function(k) {
    return k ? `${k[0].toUpperCase()} JOIN` : "JOIN";
  };
  var peg$f171 = function(db, schema, tail) {
    const obj = { db: null, table: db };
    if (tail !== null) {
      obj.db = db;
      obj.catalog = db;
      obj.schema = schema[3];
      obj.table = tail[3];
    }
    return obj;
  };
  var peg$f172 = function(dt, tail) {
    const obj = { db: null, table: dt };
    if (tail !== null) {
      obj.db = dt;
      obj.table = tail[3];
    }
    return obj;
  };
  var peg$f173 = function(head, tail) {
    const len = tail.length;
    let result = head;
    for (let i = 0; i < len; ++i) {
      result = createBinaryExpr(tail[i][1], result, tail[i][3]);
    }
    return result;
  };
  var peg$f174 = function(e) {
    return e;
  };
  var peg$f175 = function(e) {
    return e;
  };
  var peg$f176 = function(e) {
    return {
      columns: e.value
    };
  };
  var peg$f177 = function(e) {
    return e;
  };
  var peg$f178 = function(e) {
    return e;
  };
  var peg$f179 = function(l) {
    return {
      keyword: "window",
      type: "window",
      expr: l
    };
  };
  var peg$f180 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f181 = function(nw, anw) {
    return {
      name: nw,
      as_window_specification: anw
    };
  };
  var peg$f182 = function(n) {
    return n;
  };
  var peg$f183 = function(ws) {
    return {
      window_specification: ws,
      parentheses: true
    };
  };
  var peg$f184 = function(n, bc, l, w) {
    return {
      name: n,
      partitionby: bc,
      orderby: l,
      window_frame_clause: w
    };
  };
  var peg$f185 = function() {
    return "range between unbounded preceding and current row";
  };
  var peg$f186 = function(kw, s) {
    return `rows ${s.value}`;
  };
  var peg$f187 = function(p, f) {
    return `rows between ${p.value} and ${f.value}`;
  };
  var peg$f188 = function(s, c) {
    s.value += ` ${c.toUpperCase()}`;
    return s;
  };
  var peg$f189 = function(s) {
    s.value += " PRECEDING";
    return s;
  };
  var peg$f190 = function() {
    return __spreadValues({ type: "single_quote_string", value: "current row" }, getLocationObject());
  };
  var peg$f191 = function(s) {
    return __spreadValues({ type: "single_quote_string", value: s.toUpperCase() }, getLocationObject());
  };
  var peg$f192 = function(bc) {
    return bc;
  };
  var peg$f193 = function(l) {
    return l;
  };
  var peg$f194 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f195 = function(e, c, d) {
    const obj = { expr: e, type: d };
    return obj;
  };
  var peg$f196 = function(i1, tail) {
    const res = [i1];
    if (tail) res.push(tail[2]);
    return __spreadValues({
      seperator: tail && tail[0] && tail[0].toLowerCase() || "",
      value: res
    }, getLocationObject());
  };
  var peg$f197 = function(head, tail) {
    const el = { type: "expr_list" };
    el.value = createList(head, tail);
    return el;
  };
  var peg$f198 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f199 = function(c) {
    return c;
  };
  var peg$f200 = function(c) {
    return {
      array_path: c,
      type: "array",
      brackets: true,
      keyword: ""
    };
  };
  var peg$f201 = function(s, c) {
    return {
      definition: s,
      array_path: c.map((l) => ({ expr: l, as: null })),
      type: "array",
      keyword: s && "array",
      brackets: true
    };
  };
  var peg$f202 = function(s, l, c, r) {
    return {
      definition: s,
      expr_list: c,
      type: "array",
      keyword: s && "array",
      brackets: true,
      parentheses: false
    };
  };
  var peg$f203 = function(s, l, c, r) {
    return {
      definition: s,
      expr_list: c,
      type: "array",
      keyword: s && "array",
      brackets: false,
      parentheses: true
    };
  };
  var peg$f204 = function(l) {
    return {
      type: "json",
      keyword: "json",
      expr_list: l
    };
  };
  var peg$f205 = function(s, c) {
    return {
      definition: s,
      expr_list: c,
      type: "struct",
      keyword: s && "struct",
      parentheses: true
    };
  };
  var peg$f206 = function(op, tail) {
    return createUnaryExpr(op, tail[0][1]);
  };
  var peg$f207 = function(head, tail) {
    const ast = head.ast;
    if (ast && ast.type === "select") {
      if (!(head.parentheses_symbol || head.parentheses || head.ast.parentheses || head.ast.parentheses_symbol) || ast.columns.length !== 1 || ast.columns[0].expr.column === "*") throw new Error("invalid column clause with select statement");
    }
    if (!tail || tail.length === 0) return head;
    const len = tail.length;
    let result = tail[len - 1][3];
    for (let i = len - 1; i >= 0; i--) {
      const left = i === 0 ? head : tail[i - 1][3];
      result = createBinaryExpr(tail[i][1], left, result);
    }
    return result;
  };
  var peg$f208 = function(head, tail) {
    const len = tail.length;
    let result = head;
    let seperator = "";
    for (let i = 0; i < len; ++i) {
      if (tail[i][1] === ",") {
        seperator = ",";
        if (!Array.isArray(result)) result = [result];
        result.push(tail[i][3]);
      } else {
        result = createBinaryExpr(tail[i][1], result, tail[i][3]);
      }
    }
    if (seperator === ",") {
      const el = { type: "expr_list" };
      el.value = result;
      return el;
    }
    return result;
  };
  var peg$f209 = function(head, tail) {
    return createBinaryExprChain(head, tail);
  };
  var peg$f210 = function(head, tail) {
    return createBinaryExprChain(head, tail);
  };
  var peg$f211 = function(expr) {
    return createUnaryExpr("NOT", expr);
  };
  var peg$f212 = function(left, rh) {
    if (rh === null) return left;
    else if (rh.type === "arithmetic") return createBinaryExprChain(left, rh.tail);
    else return createBinaryExpr(rh.op, left, rh.right);
  };
  var peg$f213 = function(op, stmt) {
    stmt.parentheses = true;
    return createUnaryExpr(op, stmt);
  };
  var peg$f214 = function(nk) {
    return nk[0] + " " + nk[2];
  };
  var peg$f215 = function(l) {
    return { type: "arithmetic", tail: l };
  };
  var peg$f216 = function(right) {
    return { op: "IS", right };
  };
  var peg$f217 = function(right) {
    return { op: "IS NOT", right };
  };
  var peg$f218 = function(op, begin, end) {
    return {
      op,
      right: {
        type: "expr_list",
        value: [begin, end]
      }
    };
  };
  var peg$f219 = function(nk) {
    return nk[0] + " " + nk[2];
  };
  var peg$f220 = function(nk) {
    return nk[0] + " " + nk[2];
  };
  var peg$f221 = function(nk) {
    return nk[0] + " " + nk[2];
  };
  var peg$f222 = function(op, right) {
    return { op, right };
  };
  var peg$f223 = function(op, l) {
    return { op, right: l };
  };
  var peg$f224 = function(op, e) {
    return { op, right: e };
  };
  var peg$f225 = function(head, tail) {
    if (tail && tail.length && head.type === "column_ref" && head.column === "*") throw new Error(JSON.stringify(__spreadValues({
      message: "args could not be star column in additive expr"
    }, getLocationObject())));
    return createBinaryExprChain(head, tail);
  };
  var peg$f226 = function(head, tail) {
    return createBinaryExprChain(head, tail);
  };
  var peg$f227 = function(list) {
    list.parentheses = true;
    return list;
  };
  var peg$f228 = function(op, tail) {
    return createUnaryExpr(op, tail[1]);
  };
  var peg$f229 = function(e, u) {
    return {
      type: "interval",
      expr: e,
      unit: u.toLowerCase()
    };
  };
  var peg$f230 = function(condition_list, otherwise) {
    if (otherwise) condition_list.push(otherwise);
    return {
      type: "case",
      expr: null,
      args: condition_list
    };
  };
  var peg$f231 = function(expr, condition_list, otherwise) {
    if (otherwise) condition_list.push(otherwise);
    return {
      type: "case",
      expr,
      args: condition_list
    };
  };
  var peg$f232 = function(head, tail) {
    return createList(head, tail, 1);
  };
  var peg$f233 = function(condition, result) {
    return {
      type: "when",
      cond: condition,
      result
    };
  };
  var peg$f234 = function(result) {
    return { type: "else", result };
  };
  var peg$f235 = function(tbl, col, cof) {
    const cols = col.map((c) => c[3]);
    columnList.add(`select::${tbl}::${cols[0]}`);
    const column = cof ? {
      column: {
        expr: {
          type: "column_ref",
          table: null,
          column: cols[0],
          subFields: cols.slice(1)
        },
        offset: cof && cof[0],
        suffix: cof && cof[2] && `.${cof[2][2]}`
      }
    } : { column: cols[0], subFields: cols.slice(1) };
    return __spreadValues(__spreadValues({
      type: "column_ref",
      table: tbl
    }, column), getLocationObject());
  };
  var peg$f236 = function(col) {
    columnList.add(`select::null::${col}`);
    return __spreadValues({
      type: "column_ref",
      table: null,
      column: col
    }, getLocationObject());
  };
  var peg$f237 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f238 = function(n) {
    return { type: "default", value: n };
  };
  var peg$f239 = function(name) {
    return reservedMap[name.toUpperCase()] === true;
  };
  var peg$f240 = function(name) {
    return { type: "default", value: name };
  };
  var peg$f241 = function(name) {
    return reservedMap[`${name}`.toUpperCase()] === true;
  };
  var peg$f242 = function(name) {
    return name;
  };
  var peg$f243 = function(name) {
    return name;
  };
  var peg$f244 = function(name) {
    if (reservedMap[name.toUpperCase()] === true) throw new Error("Error: " + JSON.stringify(name) + " is a reserved word, can not as alias clause");
    return false;
  };
  var peg$f245 = function(name) {
    return name;
  };
  var peg$f246 = function(name) {
    return name;
  };
  var peg$f247 = function(v) {
    return v.value;
  };
  var peg$f248 = function(chars) {
    return {
      type: "double_quote_string",
      value: chars.join("")
    };
  };
  var peg$f249 = function(chars) {
    return {
      type: "single_quote_string",
      value: chars.join("")
    };
  };
  var peg$f250 = function(chars) {
    return {
      type: "backticks_quote_string",
      value: chars.join("")
    };
  };
  var peg$f251 = function(name) {
    return reservedMap[name.toUpperCase()] === true;
  };
  var peg$f252 = function(name) {
    return name;
  };
  var peg$f253 = function(start, parts) {
    return start + parts.join("");
  };
  var peg$f254 = function(start, parts) {
    return start + parts.join("");
  };
  var peg$f255 = function(s, n) {
    return { type: "param", value: n, prefix: s };
  };
  var peg$f256 = function(head, as, tail) {
    const el = { type: "expr_list" };
    el.value = createList(head, tail);
    return el;
  };
  var peg$f257 = function(name, e, bc) {
    return __spreadValues({
      type: "aggr_func",
      name,
      args: {
        expr: e
      },
      over: bc
    }, getLocationObject());
  };
  var peg$f258 = function(kw, l) {
    return {
      type: "on update",
      keyword: kw,
      parentheses: true,
      expr: l
    };
  };
  var peg$f259 = function(kw) {
    return {
      type: "on update",
      keyword: kw
    };
  };
  var peg$f260 = function(aws) {
    return {
      type: "window",
      as_window_specification: aws
    };
  };
  var peg$f261 = function(bc, l) {
    return {
      partitionby: bc,
      orderby: l
    };
  };
  var peg$f262 = function(name, arg, bc) {
    return __spreadValues({
      type: "aggr_func",
      name,
      args: arg,
      over: bc
    }, getLocationObject());
  };
  var peg$f263 = function(e) {
    return __spreadValues({ expr: e }, getLocationObject());
  };
  var peg$f264 = function(d, c, tail, or) {
    const len = tail.length;
    let result = c;
    result.parentheses = true;
    for (let i = 0; i < len; ++i) {
      result = createBinaryExpr(tail[i][1], result, tail[i][3]);
    }
    return __spreadValues({
      distinct: d,
      expr: result,
      orderby: or
    }, getLocationObject());
  };
  var peg$f265 = function(d, c, or) {
    return __spreadValues({ distinct: d, expr: c, orderby: or }, getLocationObject());
  };
  var peg$f266 = function() {
    return { type: "star", value: "*" };
  };
  var peg$f267 = function(name, l, bc) {
    return __spreadValues({
      type: "function",
      name: { name: [{ type: "default", value: name }] },
      args: l ? l : { type: "expr_list", value: [] },
      over: bc
    }, getLocationObject());
  };
  var peg$f268 = function(f, up) {
    return __spreadValues({
      type: "function",
      name: { name: [{ type: "origin", value: f }] },
      over: up
    }, getLocationObject());
  };
  var peg$f269 = function(name, l, bc) {
    if (l && l.type !== "expr_list") l = { type: "expr_list", value: [l] };
    return __spreadValues({
      type: "function",
      name,
      args: l ? l : { type: "expr_list", value: [] },
      over: bc
    }, getLocationObject());
  };
  var peg$f270 = function(dt, tail) {
    const result = { name: [dt] };
    if (tail !== null) {
      result.schema = dt;
      result.name = tail.map((t) => t[3]);
    }
    return result;
  };
  var peg$f271 = function(i, e) {
    return {
      prefix: i,
      expr: e
    };
  };
  var peg$f272 = function(e, h, bc) {
    return __spreadValues({
      type: "any_value",
      args: {
        expr: e,
        having: h
      },
      over: bc
    }, getLocationObject());
  };
  var peg$f273 = function(f) {
    return f;
  };
  var peg$f274 = function(kw, f, t, s) {
    return __spreadValues({
      type: kw.toLowerCase(),
      args: {
        field: f,
        cast_type: t,
        source: s
      }
    }, getLocationObject());
  };
  var peg$f275 = function(kw, f, s) {
    return __spreadValues({
      type: kw.toLowerCase(),
      args: {
        field: f,
        source: s
      }
    }, getLocationObject());
  };
  var peg$f276 = function(e, f) {
    return __spreadValues({
      type: "function",
      name: { name: [{ type: "origin", value: "date_trunc" }] },
      args: { type: "expr_list", value: [e, { type: "origin", value: f }] },
      over: null
    }, getLocationObject());
  };
  var peg$f277 = function(c, e, t) {
    return {
      type: "cast",
      keyword: c.toLowerCase(),
      expr: e,
      symbol: "as",
      target: t
    };
  };
  var peg$f278 = function(c, e, precision) {
    return {
      type: "cast",
      keyword: c.toLowerCase(),
      expr: e,
      symbol: "as",
      target: {
        dataType: "DECIMAL(" + precision + ")"
      }
    };
  };
  var peg$f279 = function(c, e, precision, scale) {
    return {
      type: "cast",
      keyword: c.toLowerCase(),
      expr: e,
      symbol: "as",
      target: {
        dataType: "DECIMAL(" + precision + ", " + scale + ")"
      }
    };
  };
  var peg$f280 = function(c, e, s, t) {
    return {
      type: "cast",
      keyword: c.toLowerCase(),
      expr: e,
      symbol: "as",
      target: {
        dataType: s + (t ? " " + t : "")
      }
    };
  };
  var peg$f281 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f282 = function() {
    return { type: "null", value: null };
  };
  var peg$f283 = function() {
    return {
      type: "not null",
      value: "not null"
    };
  };
  var peg$f284 = function() {
    return { type: "bool", value: true };
  };
  var peg$f285 = function() {
    return { type: "bool", value: false };
  };
  var peg$f286 = function(r, ca) {
    return __spreadValues({
      type: r ? "regex_string" : "single_quote_string",
      value: ca[1].join("")
    }, getLocationObject());
  };
  var peg$f287 = function(r, ca) {
    return __spreadValues({
      type: r ? "regex_string" : "string",
      value: ca[1].join("")
    }, getLocationObject());
  };
  var peg$f288 = function(type, ca) {
    return {
      type: type.toLowerCase(),
      value: ca[1].join("")
    };
  };
  var peg$f289 = function(type, ca) {
    return {
      type: type.toLowerCase(),
      value: ca[1].join("")
    };
  };
  var peg$f290 = function() {
    return "\\'";
  };
  var peg$f291 = function() {
    return '\\"';
  };
  var peg$f292 = function() {
    return "\\\\";
  };
  var peg$f293 = function() {
    return "\\/";
  };
  var peg$f294 = function() {
    return "\b";
  };
  var peg$f295 = function() {
    return "\f";
  };
  var peg$f296 = function() {
    return "\n";
  };
  var peg$f297 = function() {
    return "\r";
  };
  var peg$f298 = function() {
    return "	";
  };
  var peg$f299 = function(h1, h2, h3, h4) {
    return String.fromCharCode(parseInt("0x" + h1 + h2 + h3 + h4));
  };
  var peg$f300 = function() {
    return "\\";
  };
  var peg$f301 = function() {
    return "''";
  };
  var peg$f302 = function() {
    return '""';
  };
  var peg$f303 = function() {
    return "``";
  };
  var peg$f304 = function(n) {
    if (n && n.type === "bigint") return n;
    return { type: "number", value: n };
  };
  var peg$f305 = function(int_, frac, exp) {
    const numStr = int_ + frac + exp;
    return {
      type: "bigint",
      value: numStr
    };
  };
  var peg$f306 = function(int_, frac) {
    const numStr = int_ + frac;
    if (isBigInt(int_)) return {
      type: "bigint",
      value: numStr
    };
    return parseFloat(numStr);
  };
  var peg$f307 = function(int_, exp) {
    const numStr = int_ + exp;
    return {
      type: "bigint",
      value: numStr
    };
  };
  var peg$f308 = function(int_) {
    if (isBigInt(int_)) return {
      type: "bigint",
      value: int_
    };
    return parseFloat(int_);
  };
  var peg$f309 = function(op, digits) {
    return op + digits;
  };
  var peg$f310 = function(op, digit) {
    return op + digit;
  };
  var peg$f311 = function(digits) {
    return "." + digits;
  };
  var peg$f312 = function(e, digits) {
    return e + digits;
  };
  var peg$f313 = function(digits) {
    return digits.join("");
  };
  var peg$f314 = function(e, sign) {
    return e + (sign !== null ? sign : "");
  };
  var peg$f315 = function() {
    return "DROP";
  };
  var peg$f316 = function() {
    return "PARTITION";
  };
  var peg$f317 = function() {
    return "SET";
  };
  var peg$f318 = function() {
    return "TABLE";
  };
  var peg$f319 = function() {
    return "TABLES";
  };
  var peg$f320 = function() {
    return "COLLATE";
  };
  var peg$f321 = function() {
    return "VALUE";
  };
  var peg$f322 = function() {
    return "ORDINAL";
  };
  var peg$f323 = function() {
    return "SAFE_ORDINAL";
  };
  var peg$f324 = function() {
    return "OFFSET";
  };
  var peg$f325 = function() {
    return "SAFE_OFFSET";
  };
  var peg$f326 = function() {
    return "ASC";
  };
  var peg$f327 = function() {
    return "DESC";
  };
  var peg$f328 = function() {
    return "ALL";
  };
  var peg$f329 = function() {
    return "DISTINCT";
  };
  var peg$f330 = function() {
    return "BETWEEN";
  };
  var peg$f331 = function() {
    return "IN";
  };
  var peg$f332 = function() {
    return "IS";
  };
  var peg$f333 = function() {
    return "LIKE";
  };
  var peg$f334 = function() {
    return "EXISTS";
  };
  var peg$f335 = function() {
    return "NOT";
  };
  var peg$f336 = function() {
    return "AND";
  };
  var peg$f337 = function() {
    return "OR";
  };
  var peg$f338 = function() {
    return "COUNT";
  };
  var peg$f339 = function() {
    return "MAX";
  };
  var peg$f340 = function() {
    return "MIN";
  };
  var peg$f341 = function() {
    return "SUM";
  };
  var peg$f342 = function() {
    return "AVG";
  };
  var peg$f343 = function() {
    return "EXTRACT";
  };
  var peg$f344 = function() {
    return "CALL";
  };
  var peg$f345 = function() {
    return "CAST";
  };
  var peg$f346 = function() {
    return "SAFE_CAST";
  };
  var peg$f347 = function() {
    return "ARRAY";
  };
  var peg$f348 = function() {
    return "BYTES";
  };
  var peg$f349 = function() {
    return "BOOL";
  };
  var peg$f350 = function() {
    return "CHAR";
  };
  var peg$f351 = function() {
    return "GEOGRAPHY";
  };
  var peg$f352 = function() {
    return "VARCHAR";
  };
  var peg$f353 = function() {
    return "NUMERIC";
  };
  var peg$f354 = function() {
    return "DECIMAL";
  };
  var peg$f355 = function() {
    return "SIGNED";
  };
  var peg$f356 = function() {
    return "UNSIGNED";
  };
  var peg$f357 = function() {
    return "INT64";
  };
  var peg$f358 = function() {
    return "ZEROFILL";
  };
  var peg$f359 = function() {
    return "INTEGER";
  };
  var peg$f360 = function() {
    return "JSON";
  };
  var peg$f361 = function() {
    return "SMALLINT";
  };
  var peg$f362 = function() {
    return "STRING";
  };
  var peg$f363 = function() {
    return "STRUCT";
  };
  var peg$f364 = function() {
    return "TINYINT";
  };
  var peg$f365 = function() {
    return "TINYTEXT";
  };
  var peg$f366 = function() {
    return "TEXT";
  };
  var peg$f367 = function() {
    return "MEDIUMTEXT";
  };
  var peg$f368 = function() {
    return "LONGTEXT";
  };
  var peg$f369 = function() {
    return "BIGINT";
  };
  var peg$f370 = function() {
    return "FLOAT64";
  };
  var peg$f371 = function() {
    return "DOUBLE";
  };
  var peg$f372 = function() {
    return "DATE";
  };
  var peg$f373 = function() {
    return "DATETIME";
  };
  var peg$f374 = function() {
    return "ROWS";
  };
  var peg$f375 = function() {
    return "TIME";
  };
  var peg$f376 = function() {
    return "TIMESTAMP";
  };
  var peg$f377 = function() {
    return "TRUNCATE";
  };
  var peg$f378 = function() {
    return "USER";
  };
  var peg$f379 = function() {
    return "CURRENT_DATE";
  };
  var peg$f380 = function() {
    return "ADDDATE";
  };
  var peg$f381 = function() {
    return "INTERVAL";
  };
  var peg$f382 = function() {
    return "YEAR";
  };
  var peg$f383 = function() {
    return "ISOYEAR";
  };
  var peg$f384 = function() {
    return "MONTH";
  };
  var peg$f385 = function() {
    return "DAY";
  };
  var peg$f386 = function() {
    return "HOUR";
  };
  var peg$f387 = function() {
    return "MINUTE";
  };
  var peg$f388 = function() {
    return "SECOND";
  };
  var peg$f389 = function() {
    return "WEEK";
  };
  var peg$f390 = function() {
    return "CURRENT_TIME";
  };
  var peg$f391 = function() {
    return "CURRENT_TIMESTAMP";
  };
  var peg$f392 = function() {
    return "SESSION_USER";
  };
  var peg$f393 = function() {
    return "GLOBAL";
  };
  var peg$f394 = function() {
    return "SESSION";
  };
  var peg$f395 = function() {
    return "LOCAL";
  };
  var peg$f396 = function() {
    return "PIVOT";
  };
  var peg$f397 = function() {
    return "PERSIST";
  };
  var peg$f398 = function() {
    return "PERSIST_ONLY";
  };
  var peg$f399 = function() {
    return "VIEW";
  };
  var peg$f400 = function() {
    return "ADD";
  };
  var peg$f401 = function() {
    return "COLUMN";
  };
  var peg$f402 = function() {
    return "INDEX";
  };
  var peg$f403 = function() {
    return "KEY";
  };
  var peg$f404 = function() {
    return "FULLTEXT";
  };
  var peg$f405 = function() {
    return "UNIQUE";
  };
  var peg$f406 = function() {
    return "COMMENT";
  };
  var peg$f407 = function() {
    return "CONSTRAINT";
  };
  var peg$f408 = function() {
    return "REFERENCES";
  };
  var peg$f409 = function(head, tail) {
    return createList(head, tail);
  };
  var peg$f410 = function(n) {
    return DATA_TYPES[n.toUpperCase()] === true;
  };
  var peg$f411 = function(n) {
    return n;
  };
  var peg$f412 = function(n, t) {
    return {
      field_name: n,
      field_type: t
    };
  };
  var peg$f413 = function(t, s) {
    const result = { dataType: t };
    if (!s || s.length === 0) return result;
    return __spreadProps(__spreadValues({}, result), { length: parseInt(s[3].join(""), 10), parentheses: true });
  };
  var peg$f414 = function(t) {
    return { dataType: t };
  };
  var peg$f415 = function(t, l) {
    return { dataType: t, length: parseInt(l.join(""), 10), parentheses: true };
  };
  var peg$f416 = function(t) {
    return { dataType: t };
  };
  var peg$f417 = function(t) {
    return { dataType: t };
  };
  var peg$f418 = function(t, a) {
    return {
      dataType: t,
      definition: a,
      anglebracket: true
    };
  };
  var peg$f419 = function(t, a) {
    return {
      dataType: t,
      definition: a,
      anglebracket: true
    };
  };
  var peg$f420 = function() {
    return null;
  };
  var peg$f421 = function() {
    return true;
  };
  var peg$f422 = function() {
    return false;
  };
  var peg$currPos = options.peg$currPos | 0;
  var peg$savedPos = peg$currPos;
  var peg$posDetailsCache = [{ line: 1, column: 1 }];
  var peg$maxFailPos = peg$currPos;
  var peg$maxFailExpected = options.peg$maxFailExpected || [];
  var peg$silentFails = options.peg$silentFails | 0;
  var peg$resultsCache = {};
  var peg$result;
  if (options.startRule) {
    if (!(options.startRule in peg$startRuleFunctions)) {
      throw new Error(`Can't start parsing from rule "` + options.startRule + '".');
    }
    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
  }
  function text() {
    return input.substring(peg$savedPos, peg$currPos);
  }
  function offset() {
    return peg$savedPos;
  }
  function range() {
    return {
      source: peg$source,
      start: peg$savedPos,
      end: peg$currPos
    };
  }
  function location() {
    return peg$computeLocation(peg$savedPos, peg$currPos);
  }
  function expected(description, location2) {
    location2 = location2 !== void 0 ? location2 : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildStructuredError(
      [peg$otherExpectation(description)],
      input.substring(peg$savedPos, peg$currPos),
      location2
    );
  }
  function error(message, location2) {
    location2 = location2 !== void 0 ? location2 : peg$computeLocation(peg$savedPos, peg$currPos);
    throw peg$buildSimpleError(message, location2);
  }
  function peg$literalExpectation(text2, ignoreCase) {
    return { type: "literal", text: text2, ignoreCase };
  }
  function peg$classExpectation(parts, inverted, ignoreCase) {
    return { type: "class", parts, inverted, ignoreCase };
  }
  function peg$anyExpectation() {
    return { type: "any" };
  }
  function peg$endExpectation() {
    return { type: "end" };
  }
  function peg$otherExpectation(description) {
    return { type: "other", description };
  }
  function peg$computePosDetails(pos) {
    var details = peg$posDetailsCache[pos];
    var p;
    if (details) {
      return details;
    } else {
      if (pos >= peg$posDetailsCache.length) {
        p = peg$posDetailsCache.length - 1;
      } else {
        p = pos;
        while (!peg$posDetailsCache[--p]) {
        }
      }
      details = peg$posDetailsCache[p];
      details = {
        line: details.line,
        column: details.column
      };
      while (p < pos) {
        if (input.charCodeAt(p) === 10) {
          details.line++;
          details.column = 1;
        } else {
          details.column++;
        }
        p++;
      }
      peg$posDetailsCache[pos] = details;
      return details;
    }
  }
  function peg$computeLocation(startPos, endPos, offset2) {
    var startPosDetails = peg$computePosDetails(startPos);
    var endPosDetails = peg$computePosDetails(endPos);
    var res = {
      source: peg$source,
      start: {
        offset: startPos,
        line: startPosDetails.line,
        column: startPosDetails.column
      },
      end: {
        offset: endPos,
        line: endPosDetails.line,
        column: endPosDetails.column
      }
    };
    if (offset2 && peg$source && typeof peg$source.offset === "function") {
      res.start = peg$source.offset(res.start);
      res.end = peg$source.offset(res.end);
    }
    return res;
  }
  function peg$fail(expected2) {
    if (peg$currPos < peg$maxFailPos) {
      return;
    }
    if (peg$currPos > peg$maxFailPos) {
      peg$maxFailPos = peg$currPos;
      peg$maxFailExpected = [];
    }
    peg$maxFailExpected.push(expected2);
  }
  function peg$buildSimpleError(message, location2) {
    return new peg$SyntaxError(message, null, null, location2);
  }
  function peg$buildStructuredError(expected2, found, location2) {
    return new peg$SyntaxError(
      peg$SyntaxError.buildMessage(expected2, found),
      expected2,
      found,
      location2
    );
  }
  function peg$parsestart() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 0;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parse__();
    s2 = peg$parsemultiple_stmt();
    if (s2 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f0(s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsemultiple_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 1;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsestmt();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseSEMICOLON();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsestmt();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseSEMICOLON();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsestmt();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f1(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestmt() {
    var s0;
    var key = peg$currPos * 463 + 2;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsequery_statement();
    if (s0 === peg$FAILED) {
      s0 = peg$parsecrud_stmt();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecrud_stmt() {
    var s0;
    var key = peg$currPos * 463 + 3;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseunion_stmt();
    if (s0 === peg$FAILED) {
      s0 = peg$parseupdate_stmt();
      if (s0 === peg$FAILED) {
        s0 = peg$parsereplace_insert_stmt();
        if (s0 === peg$FAILED) {
          s0 = peg$parseinsert_no_columns_stmt();
          if (s0 === peg$FAILED) {
            s0 = peg$parseinsert_into_set();
            if (s0 === peg$FAILED) {
              s0 = peg$parsedelete_stmt();
              if (s0 === peg$FAILED) {
                s0 = peg$parsecmd_stmt();
                if (s0 === peg$FAILED) {
                  s0 = peg$parseproc_stmts();
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseupdate_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
    var key = peg$currPos * 463 + 4;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_UPDATE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_ref_list();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_SET();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseset_list();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parsefrom_clause();
            if (s9 === peg$FAILED) {
              s9 = null;
            }
            s10 = peg$parse__();
            s11 = peg$parsewhere_clause();
            if (s11 === peg$FAILED) {
              s11 = null;
            }
            s12 = peg$parse__();
            s13 = peg$parseorder_by_clause();
            if (s13 === peg$FAILED) {
              s13 = null;
            }
            s14 = peg$parse__();
            s15 = peg$parselimit_clause();
            if (s15 === peg$FAILED) {
              s15 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f2(s3, s7, s9, s11, s13, s15);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedelete_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 5;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DELETE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_ref_list();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsefrom_clause();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsewhere_clause();
      if (s7 === peg$FAILED) {
        s7 = null;
      }
      s8 = peg$parse__();
      s9 = peg$parseorder_by_clause();
      if (s9 === peg$FAILED) {
        s9 = null;
      }
      s10 = peg$parse__();
      s11 = peg$parselimit_clause();
      if (s11 === peg$FAILED) {
        s11 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f3(s3, s5, s7, s9, s11);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsereplace_insert_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17;
    var key = peg$currPos * 463 + 6;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsereplace_insert();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_INTO();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsetable_name();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseinsert_partition();
        if (s7 === peg$FAILED) {
          s7 = null;
        }
        s8 = peg$parse__();
        s9 = peg$parseLPAREN();
        if (s9 !== peg$FAILED) {
          s10 = peg$parse__();
          s11 = peg$parsecolumn_list();
          if (s11 !== peg$FAILED) {
            s12 = peg$parse__();
            s13 = peg$parseRPAREN();
            if (s13 !== peg$FAILED) {
              s14 = peg$parse__();
              s15 = peg$parseinsert_value_clause();
              if (s15 !== peg$FAILED) {
                s16 = peg$parse__();
                s17 = peg$parseon_duplicate_update_stmt();
                if (s17 === peg$FAILED) {
                  s17 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f4(s1, s5, s7, s11, s15, s17);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseinsert_no_columns_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 7;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsereplace_insert();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_IGNORE();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseKW_INTO();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsetable_name();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parseinsert_partition();
        if (s9 === peg$FAILED) {
          s9 = null;
        }
        s10 = peg$parse__();
        s11 = peg$parseinsert_value_clause();
        if (s11 !== peg$FAILED) {
          s12 = peg$parse__();
          s13 = peg$parseon_duplicate_update_stmt();
          if (s13 === peg$FAILED) {
            s13 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f5(s1, s3, s5, s7, s9, s11, s13);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseinsert_into_set() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 8;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsereplace_insert();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_INTO();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsetable_name();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseinsert_partition();
        if (s7 === peg$FAILED) {
          s7 = null;
        }
        s8 = peg$parse__();
        s9 = peg$parseKW_SET();
        if (s9 !== peg$FAILED) {
          s10 = peg$parse__();
          s11 = peg$parseset_list();
          if (s11 !== peg$FAILED) {
            s12 = peg$parse__();
            s13 = peg$parseon_duplicate_update_stmt();
            if (s13 === peg$FAILED) {
              s13 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f6(s1, s5, s7, s11, s13);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecmd_stmt() {
    var s0;
    var key = peg$currPos * 463 + 9;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseanalyze_stmt();
    if (s0 === peg$FAILED) {
      s0 = peg$parseattach_stmt();
      if (s0 === peg$FAILED) {
        s0 = peg$parsedrop_stmt();
        if (s0 === peg$FAILED) {
          s0 = peg$parsecreate_stmt();
          if (s0 === peg$FAILED) {
            s0 = peg$parsetruncate_stmt();
            if (s0 === peg$FAILED) {
              s0 = peg$parserename_stmt();
              if (s0 === peg$FAILED) {
                s0 = peg$parsecall_stmt();
                if (s0 === peg$FAILED) {
                  s0 = peg$parseuse_stmt();
                  if (s0 === peg$FAILED) {
                    s0 = peg$parsealter_table_stmt();
                    if (s0 === peg$FAILED) {
                      s0 = peg$parseset_stmt();
                      if (s0 === peg$FAILED) {
                        s0 = peg$parselock_stmt();
                        if (s0 === peg$FAILED) {
                          s0 = peg$parseunlock_stmt();
                          if (s0 === peg$FAILED) {
                            s0 = peg$parseshow_stmt();
                            if (s0 === peg$FAILED) {
                              s0 = peg$parsedesc_stmt();
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_stmts() {
    var s0, s1;
    var key = peg$currPos * 463 + 10;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = [];
    s1 = peg$parseproc_stmt();
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parseproc_stmt();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_stmt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 11;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    peg$savedPos = peg$currPos;
    s1 = peg$f7();
    if (s1) {
      s1 = void 0;
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseassign_stmt();
      if (s3 === peg$FAILED) {
        s3 = peg$parsereturn_stmt();
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f8(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseassign_stmt_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 12;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseassign_stmt();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseassign_stmt();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseassign_stmt();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f9(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseassign_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 13;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsevar_decl();
    if (s1 === peg$FAILED) {
      s1 = peg$parsewithout_prefix_var_decl();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGN();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_ASSIGIN_EQUAL();
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseproc_expr();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f10(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsereturn_stmt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 14;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_RETURN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseproc_expr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f11(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_expr() {
    var s0;
    var key = peg$currPos * 463 + 15;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseselect_stmt();
    if (s0 === peg$FAILED) {
      s0 = peg$parseproc_join();
      if (s0 === peg$FAILED) {
        s0 = peg$parseproc_additive_expr();
        if (s0 === peg$FAILED) {
          s0 = peg$parseproc_array();
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_additive_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 16;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseproc_multiplicative_expr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseadditive_operator();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseproc_multiplicative_expr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseadditive_operator();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseproc_multiplicative_expr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f12(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_multiplicative_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 17;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseproc_primary();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parsemultiplicative_operator();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseproc_primary();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parsemultiplicative_operator();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseproc_primary();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f13(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_join() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 18;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsevar_decl();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsejoin_op();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsevar_decl();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseon_clause();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f14(s1, s3, s5, s7);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_primary() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 19;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseliteral();
    if (s0 === peg$FAILED) {
      s0 = peg$parsevar_decl();
      if (s0 === peg$FAILED) {
        s0 = peg$parseproc_func_call();
        if (s0 === peg$FAILED) {
          s0 = peg$parseparam();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseLPAREN();
            if (s1 !== peg$FAILED) {
              s2 = peg$parse__();
              s3 = peg$parseproc_additive_expr();
              if (s3 !== peg$FAILED) {
                s4 = peg$parse__();
                s5 = peg$parseRPAREN();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f15(s3);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_func_call() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 20;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseproc_func_name();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseproc_primary_list();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseRPAREN();
        if (s7 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f16(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseproc_func_name();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f17(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_primary_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 21;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseproc_primary();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseproc_primary();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseproc_primary();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f18(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_array() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 22;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseLBRAKE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseproc_primary_list();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseRBRAKE();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f19(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseset_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 23;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseset_item();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseset_item();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseset_item();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f20(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseset_item() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 24;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseident();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parseDOT();
      if (s4 !== peg$FAILED) {
        s2 = [s2, s3, s4];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$parsecolumn_without_kw();
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      if (input.charCodeAt(peg$currPos) === 61) {
        s5 = peg$c0;
        peg$currPos++;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e0);
        }
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseadditive_expr();
        if (s7 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f21(s1, s3, s7);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      s2 = peg$parseident();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseDOT();
        if (s4 !== peg$FAILED) {
          s2 = [s2, s3, s4];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parse__();
      s3 = peg$parsecolumn_without_kw();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 61) {
          s5 = peg$c0;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e0);
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseKW_VALUES();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseLPAREN();
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parsecolumn_ref();
              if (s11 !== peg$FAILED) {
                s12 = peg$parse__();
                s13 = peg$parseRPAREN();
                if (s13 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f22(s1, s3, s11);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsereplace_insert() {
    var s0, s1;
    var key = peg$currPos * 463 + 25;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_INSERT();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f23();
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_REPLACE();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f24();
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseinsert_partition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 26;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_PARTITION();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseident_name();
        if (s5 !== peg$FAILED) {
          s6 = [];
          s7 = peg$currPos;
          s8 = peg$parse__();
          s9 = peg$parseCOMMA();
          if (s9 !== peg$FAILED) {
            s10 = peg$parse__();
            s11 = peg$parseident_name();
            if (s11 !== peg$FAILED) {
              s8 = [s8, s9, s10, s11];
              s7 = s8;
            } else {
              peg$currPos = s7;
              s7 = peg$FAILED;
            }
          } else {
            peg$currPos = s7;
            s7 = peg$FAILED;
          }
          while (s7 !== peg$FAILED) {
            s6.push(s7);
            s7 = peg$currPos;
            s8 = peg$parse__();
            s9 = peg$parseCOMMA();
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parseident_name();
              if (s11 !== peg$FAILED) {
                s8 = [s8, s9, s10, s11];
                s7 = s8;
              } else {
                peg$currPos = s7;
                s7 = peg$FAILED;
              }
            } else {
              peg$currPos = s7;
              s7 = peg$FAILED;
            }
          }
          s7 = peg$parse__();
          s8 = peg$parseRPAREN();
          if (s8 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f25(s5, s6);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_PARTITION();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parsevalue_item();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f26(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseinsert_value_clause() {
    var s0;
    var key = peg$currPos * 463 + 27;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsevalue_clause();
    if (s0 === peg$FAILED) {
      s0 = peg$parseselect_stmt_nake();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseon_duplicate_update_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 28;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ON();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 9);
      if (s3.toLowerCase() === peg$c1) {
        peg$currPos += 9;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e1);
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_KEY();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseKW_UPDATE();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseset_list();
            if (s9 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f27(s9);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseanalyze_stmt() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 29;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ANALYZE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_name();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        peg$savedPos = s0;
        s0 = peg$f28(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseattach_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    var key = peg$currPos * 463 + 30;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ATTACH();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_DATABASE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseKW_AS();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseident();
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              peg$savedPos = s0;
              s0 = peg$f29(s1, s3, s5, s7, s9);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedrop_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
    var key = peg$currPos * 463 + 31;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DROP();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TABLE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsetable_ref_list();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f30(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_DROP();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseKW_INDEX();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parsecolumn_ref();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseKW_ON();
            if (s7 !== peg$FAILED) {
              s8 = peg$parse__();
              s9 = peg$parsetable_name();
              if (s9 !== peg$FAILED) {
                s10 = peg$parse__();
                s11 = peg$parsedrop_index_opt();
                if (s11 === peg$FAILED) {
                  s11 = null;
                }
                s12 = peg$parse__();
                peg$savedPos = s0;
                s0 = peg$f31(s1, s3, s5, s9, s11);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_stmt() {
    var s0;
    var key = peg$currPos * 463 + 32;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecreate_table_stmt();
    if (s0 === peg$FAILED) {
      s0 = peg$parsecreate_db_stmt();
      if (s0 === peg$FAILED) {
        s0 = peg$parsecreate_view_stmt();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetruncate_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 33;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_TRUNCATE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TABLE();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsetable_ref_list();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f32(s1, s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parserename_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 34;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_RENAME();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TABLE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsetable_to_list();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f33(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecall_stmt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 35;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CALL();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseproc_func_call();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f34(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseuse_stmt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 36;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_USE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseident();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f35(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseset_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 37;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_SET();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_GLOBAL();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_SESSION();
        if (s3 === peg$FAILED) {
          s3 = peg$parseKW_LOCAL();
          if (s3 === peg$FAILED) {
            s3 = peg$parseKW_PERSIST();
            if (s3 === peg$FAILED) {
              s3 = peg$parseKW_PERSIST_ONLY();
            }
          }
        }
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseassign_stmt_list();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f36(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselock_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 38;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_LOCK();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TABLES();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parselock_table_list();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f37(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunlock_stmt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 39;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_UNLOCK();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TABLES();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f38();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseshow_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 40;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_SHOW();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 6);
      if (s3.toLowerCase() === peg$c2) {
        peg$currPos += 6;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e2);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 6);
        if (s3.toLowerCase() === peg$c3) {
          peg$currPos += 6;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e3);
          }
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = input.substr(peg$currPos, 4);
        if (s5.toLowerCase() === peg$c4) {
          peg$currPos += 4;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e4);
          }
        }
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f39(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_SHOW();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = input.substr(peg$currPos, 6);
        if (s3.toLowerCase() === peg$c5) {
          peg$currPos += 6;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = input.substr(peg$currPos, 6);
          if (s5.toLowerCase() === peg$c6) {
            peg$currPos += 6;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e6);
            }
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parsein_op_right();
            if (s7 === peg$FAILED) {
              s7 = null;
            }
            s8 = peg$parse__();
            s9 = peg$parsefrom_clause();
            if (s9 === peg$FAILED) {
              s9 = null;
            }
            s10 = peg$parse__();
            s11 = peg$parselimit_clause();
            if (s11 === peg$FAILED) {
              s11 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f40(s7, s9, s11);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseKW_SHOW();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$currPos;
          s4 = input.substr(peg$currPos, 9);
          if (s4.toLowerCase() === peg$c7) {
            peg$currPos += 9;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e7);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse__();
            s6 = input.substr(peg$currPos, 3);
            if (s6.toLowerCase() === peg$c8) {
              peg$currPos += 3;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e8);
              }
            }
            if (s6 !== peg$FAILED) {
              s4 = [s4, s5, s6];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = input.substr(peg$currPos, 9);
            if (s3.toLowerCase() === peg$c9) {
              peg$currPos += 9;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e9);
              }
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parselike_op_right();
            if (s5 === peg$FAILED) {
              s5 = peg$parsewhere_clause();
            }
            if (s5 === peg$FAILED) {
              s5 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f41(s3, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$parseshow_grant_stmt();
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedesc_stmt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 41;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DESC();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_DESCRIBE();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseident();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f42(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsevar_decl() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 42;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_VAR_PRE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsewithout_prefix_var_decl();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f43(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewithout_prefix_var_decl() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 43;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_name();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsemem_chain();
      peg$savedPos = s0;
      s0 = peg$f44(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseliteral_numeric();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f45(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsevalue_item() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 44;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseLPAREN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseexpr_list();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseRPAREN();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f46(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsevalue_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 45;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_VALUES();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsevalue_list();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f47(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedrop_index_opt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 46;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseALTER_ALGORITHM();
    if (s1 === peg$FAILED) {
      s1 = peg$parseALTER_LOCK();
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseALTER_ALGORITHM();
      if (s5 === peg$FAILED) {
        s5 = peg$parseALTER_LOCK();
      }
      if (s5 !== peg$FAILED) {
        s4 = [s4, s5];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseALTER_ALGORITHM();
        if (s5 === peg$FAILED) {
          s5 = peg$parseALTER_LOCK();
        }
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f48(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseif_not_exists_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 47;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c10) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e10);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_NOT();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_EXISTS();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f49();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_table_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19;
    var key = peg$currPos * 463 + 48;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CREATE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$currPos;
      s4 = peg$parseKW_OR();
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__();
        s6 = peg$parseKW_REPLACE();
        if (s6 !== peg$FAILED) {
          s4 = [s4, s5, s6];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseKW_TEMP();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_TEMPORARY();
      }
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parseKW_TABLE();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parseif_not_exists_stmt();
        if (s9 === peg$FAILED) {
          s9 = null;
        }
        s10 = peg$parse__();
        s11 = peg$parsetable_name();
        if (s11 !== peg$FAILED) {
          s12 = peg$parse__();
          s13 = peg$parsecreate_table_definition();
          if (s13 === peg$FAILED) {
            s13 = null;
          }
          s14 = peg$parse__();
          s15 = peg$parsetable_options();
          if (s15 === peg$FAILED) {
            s15 = null;
          }
          s16 = peg$parse__();
          s17 = peg$parseKW_AS();
          if (s17 === peg$FAILED) {
            s17 = null;
          }
          s18 = peg$parse__();
          s19 = peg$parseunion_stmt();
          if (s19 === peg$FAILED) {
            s19 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f50(s1, s3, s5, s9, s11, s13, s15, s17, s19);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_CREATE();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseKW_TEMPORARY();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        s4 = peg$parse__();
        s5 = peg$parseKW_TABLE();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseif_not_exists_stmt();
          if (s7 === peg$FAILED) {
            s7 = null;
          }
          s8 = peg$parse__();
          s9 = peg$parsetable_ref_list();
          if (s9 !== peg$FAILED) {
            s10 = peg$parse__();
            s11 = peg$parsecreate_like_table();
            if (s11 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f51(s1, s3, s7, s9, s11);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_db_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 49;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CREATE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_DATABASE();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_SCHEMA();
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseif_not_exists_stmt();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseproc_func_name();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parsecreate_db_definition();
          if (s9 === peg$FAILED) {
            s9 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f52(s1, s3, s5, s7, s9);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseview_with() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 50;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_WITH();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 8);
      if (s3.toLowerCase() === peg$c11) {
        peg$currPos += 8;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e11);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 5);
        if (s3.toLowerCase() === peg$c12) {
          peg$currPos += 5;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e12);
          }
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = input.substr(peg$currPos, 5);
        if (s5.toLowerCase() === peg$c13) {
          peg$currPos += 5;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e13);
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          if (input.substr(peg$currPos, 6) === peg$c14) {
            s7 = peg$c14;
            peg$currPos += 6;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e14);
            }
          }
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f53(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_WITH();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = input.substr(peg$currPos, 5);
        if (s3.toLowerCase() === peg$c13) {
          peg$currPos += 5;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e13);
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          if (input.substr(peg$currPos, 6) === peg$c14) {
            s5 = peg$c14;
            peg$currPos += 6;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e14);
            }
          }
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f54();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewith_view_option() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 51;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 12);
    if (s1.toLowerCase() === peg$c15) {
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e15);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = input.substr(peg$currPos, 8);
        if (s5.toLowerCase() === peg$c11) {
          peg$currPos += 8;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e11);
          }
        }
        if (s5 === peg$FAILED) {
          s5 = input.substr(peg$currPos, 5);
          if (s5.toLowerCase() === peg$c12) {
            peg$currPos += 5;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e12);
            }
          }
        }
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f55(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = input.substr(peg$currPos, 16);
      if (s1.toLowerCase() === peg$c16) {
        peg$currPos += 16;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e16);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 16);
        if (s1.toLowerCase() === peg$c17) {
          peg$currPos += 16;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e17);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseKW_ASSIGIN_EQUAL();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseliteral_bool();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f56(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewith_view_options() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 52;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsewith_view_option();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsewith_view_option();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsewith_view_option();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f57(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_view_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21, s22;
    var key = peg$currPos * 463 + 53;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CREATE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$currPos;
      s4 = peg$parseKW_OR();
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__();
        s6 = peg$parseKW_REPLACE();
        if (s6 !== peg$FAILED) {
          s4 = [s4, s5, s6];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseKW_TEMP();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_TEMPORARY();
      }
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parseKW_RECURSIVE();
      if (s7 === peg$FAILED) {
        s7 = null;
      }
      s8 = peg$parse__();
      s9 = peg$parseKW_VIEW();
      if (s9 !== peg$FAILED) {
        s10 = peg$parse__();
        s11 = peg$parsetable_name();
        if (s11 !== peg$FAILED) {
          s12 = peg$parse__();
          s13 = peg$currPos;
          s14 = peg$parseLPAREN();
          if (s14 !== peg$FAILED) {
            s15 = peg$parse__();
            s16 = peg$parsecolumn_list();
            if (s16 !== peg$FAILED) {
              s17 = peg$parse__();
              s18 = peg$parseRPAREN();
              if (s18 !== peg$FAILED) {
                s14 = [s14, s15, s16, s17, s18];
                s13 = s14;
              } else {
                peg$currPos = s13;
                s13 = peg$FAILED;
              }
            } else {
              peg$currPos = s13;
              s13 = peg$FAILED;
            }
          } else {
            peg$currPos = s13;
            s13 = peg$FAILED;
          }
          if (s13 === peg$FAILED) {
            s13 = null;
          }
          s14 = peg$parse__();
          s15 = peg$currPos;
          s16 = peg$parseKW_WITH();
          if (s16 !== peg$FAILED) {
            s17 = peg$parse__();
            s18 = peg$parseLPAREN();
            if (s18 !== peg$FAILED) {
              s19 = peg$parse__();
              s20 = peg$parsewith_view_options();
              if (s20 !== peg$FAILED) {
                s21 = peg$parse__();
                s22 = peg$parseRPAREN();
                if (s22 !== peg$FAILED) {
                  s16 = [s16, s17, s18, s19, s20, s21, s22];
                  s15 = s16;
                } else {
                  peg$currPos = s15;
                  s15 = peg$FAILED;
                }
              } else {
                peg$currPos = s15;
                s15 = peg$FAILED;
              }
            } else {
              peg$currPos = s15;
              s15 = peg$FAILED;
            }
          } else {
            peg$currPos = s15;
            s15 = peg$FAILED;
          }
          if (s15 === peg$FAILED) {
            s15 = null;
          }
          s16 = peg$parse__();
          s17 = peg$parseKW_AS();
          if (s17 !== peg$FAILED) {
            s18 = peg$parse__();
            s19 = peg$parseselect_stmt();
            if (s19 !== peg$FAILED) {
              s20 = peg$parse__();
              s21 = peg$parseview_with();
              if (s21 === peg$FAILED) {
                s21 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f58(s1, s3, s5, s7, s11, s13, s15, s19, s21);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsealter_table_stmt() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 54;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ALTER();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TABLE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsetable_ref_list();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsealter_action_list();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f59(s5, s7);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselock_table_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 55;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parselock_table();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parselock_table();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parselock_table();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f60(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseshow_grant_stmt() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 56;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_SHOW();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 6);
      if (s3.toLowerCase() === peg$c18) {
        peg$currPos += 6;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e18);
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseshow_grant_for();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f61(s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsemem_chain() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 57;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 46) {
      s3 = peg$c19;
      peg$currPos++;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e19);
      }
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parseident_name();
      if (s4 !== peg$FAILED) {
        s3 = [s3, s4];
        s2 = s3;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    while (s2 !== peg$FAILED) {
      s1.push(s2);
      s2 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 46) {
        s3 = peg$c19;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e19);
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parseident_name();
        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    }
    peg$savedPos = s0;
    s1 = peg$f62(s1);
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsevalue_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 58;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsevalue_item();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsevalue_item();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsevalue_item();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f63(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseALTER_ALGORITHM() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 59;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c20) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e20);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = input.substr(peg$currPos, 7);
      if (s5.toLowerCase() === peg$c21) {
        peg$currPos += 7;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e21);
        }
      }
      if (s5 === peg$FAILED) {
        s5 = input.substr(peg$currPos, 7);
        if (s5.toLowerCase() === peg$c22) {
          peg$currPos += 7;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e22);
          }
        }
        if (s5 === peg$FAILED) {
          s5 = input.substr(peg$currPos, 7);
          if (s5.toLowerCase() === peg$c23) {
            peg$currPos += 7;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e23);
            }
          }
          if (s5 === peg$FAILED) {
            s5 = input.substr(peg$currPos, 4);
            if (s5.toLowerCase() === peg$c24) {
              peg$currPos += 4;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e24);
              }
            }
          }
        }
      }
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f64(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseALTER_LOCK() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 60;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c25) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e25);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = input.substr(peg$currPos, 7);
      if (s5.toLowerCase() === peg$c21) {
        peg$currPos += 7;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e21);
        }
      }
      if (s5 === peg$FAILED) {
        s5 = input.substr(peg$currPos, 4);
        if (s5.toLowerCase() === peg$c26) {
          peg$currPos += 4;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e26);
          }
        }
        if (s5 === peg$FAILED) {
          s5 = input.substr(peg$currPos, 6);
          if (s5.toLowerCase() === peg$c27) {
            peg$currPos += 6;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e27);
            }
          }
          if (s5 === peg$FAILED) {
            s5 = input.substr(peg$currPos, 9);
            if (s5.toLowerCase() === peg$c28) {
              peg$currPos += 9;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e28);
              }
            }
          }
        }
      }
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f65(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_table_definition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 61;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseLPAREN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecreate_definition();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = peg$parse__();
        s7 = peg$parseCOMMA();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parsecreate_definition();
          if (s9 !== peg$FAILED) {
            s6 = [s6, s7, s8, s9];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = peg$parse__();
          s7 = peg$parseCOMMA();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parsecreate_definition();
            if (s9 !== peg$FAILED) {
              s6 = [s6, s7, s8, s9];
              s5 = s6;
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        s5 = peg$parse__();
        s6 = peg$parseRPAREN();
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f66(s3, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_definition() {
    var s0;
    var key = peg$currPos * 463 + 62;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecreate_column_definition();
    if (s0 === peg$FAILED) {
      s0 = peg$parsecreate_index_definition();
      if (s0 === peg$FAILED) {
        s0 = peg$parsecreate_fulltext_spatial_index_definition();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_definition_opt() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 63;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseliteral_not_null();
    if (s1 === peg$FAILED) {
      s1 = peg$parseliteral_null();
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f67(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsedefault_expr();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f68(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 14);
        if (s1.toLowerCase() === peg$c29) {
          peg$currPos += 14;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e29);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f69(s1);
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = input.substr(peg$currPos, 6);
          if (s1.toLowerCase() === peg$c30) {
            peg$currPos += 6;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e30);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = input.substr(peg$currPos, 3);
            if (s3.toLowerCase() === peg$c31) {
              peg$currPos += 3;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e31);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f70(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = input.substr(peg$currPos, 7);
            if (s1.toLowerCase() === peg$c32) {
              peg$currPos += 7;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e32);
              }
            }
            if (s1 === peg$FAILED) {
              s1 = null;
            }
            s2 = peg$parse__();
            s3 = input.substr(peg$currPos, 3);
            if (s3.toLowerCase() === peg$c31) {
              peg$currPos += 3;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e31);
              }
            }
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f71(s1);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parsekeyword_comment();
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f72(s1);
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parsecollate_expr();
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$f73(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parsecolumn_format();
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f74(s1);
                  }
                  s0 = s1;
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    s1 = peg$parsestorage();
                    if (s1 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$f75(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      s1 = peg$parsereference_definition();
                      if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$f76(s1);
                      }
                      s0 = s1;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_definition_opt_list() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 64;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn_definition_opt();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = [];
      s4 = peg$currPos;
      s5 = peg$parse__();
      s6 = peg$parsecolumn_definition_opt();
      if (s6 !== peg$FAILED) {
        s5 = [s5, s6];
        s4 = s5;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$currPos;
        s5 = peg$parse__();
        s6 = peg$parsecolumn_definition_opt();
        if (s6 !== peg$FAILED) {
          s5 = [s5, s6];
          s4 = s5;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f77(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_column_definition() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 65;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn_ref();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsedata_type();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsecolumn_definition_opt_list();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f78(s1, s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_options() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 66;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsetable_option();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsetable_option();
      if (s7 !== peg$FAILED) {
        s4 = [s4, s5, s6, s7];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parsetable_option();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f79(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_like_table() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 67;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecreate_like_table_simple();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseLPAREN();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parsecreate_like_table();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseRPAREN();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f80(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_db_definition() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 68;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecreate_option_character_set();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parsecreate_option_character_set();
      if (s5 !== peg$FAILED) {
        s4 = [s4, s5];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parsecreate_option_character_set();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f81(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsealter_action_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 69;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsealter_action();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsealter_action();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsealter_action();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f82(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselock_table() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 70;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsetable_base();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parselock_type();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f83(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseshow_grant_for() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;
    var key = peg$currPos * 463 + 71;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c33) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e33);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseident();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$currPos;
        s6 = peg$parseKW_VAR__PRE_AT();
        if (s6 !== peg$FAILED) {
          s7 = peg$parse__();
          s8 = peg$parseident();
          if (s8 !== peg$FAILED) {
            s6 = [s6, s7, s8];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseshow_grant_for_using();
        if (s7 === peg$FAILED) {
          s7 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f84(s3, s5, s7);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_constraint_definition() {
    var s0;
    var key = peg$currPos * 463 + 72;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecreate_constraint_primary();
    if (s0 === peg$FAILED) {
      s0 = peg$parsecreate_constraint_unique();
      if (s0 === peg$FAILED) {
        s0 = peg$parsecreate_constraint_foreign();
        if (s0 === peg$FAILED) {
          s0 = peg$parsecreate_constraint_check();
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_index_definition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    var key = peg$currPos * 463 + 73;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_INDEX();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_KEY();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecolumn();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseindex_type();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsecte_column_definition();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parseindex_options();
        if (s9 === peg$FAILED) {
          s9 = null;
        }
        s10 = peg$parse__();
        peg$savedPos = s0;
        s0 = peg$f85(s1, s3, s5, s7, s9);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_fulltext_spatial_index_definition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    var key = peg$currPos * 463 + 74;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_FULLTEXT();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_SPATIAL();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_INDEX();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_KEY();
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsecolumn();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsecte_column_definition();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parseindex_options();
        if (s9 === peg$FAILED) {
          s9 = null;
        }
        s10 = peg$parse__();
        peg$savedPos = s0;
        s0 = peg$f86(s1, s3, s5, s7, s9);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedefault_expr() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 75;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DEFAULT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseexpr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f87(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsekeyword_comment() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 76;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_COMMENT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseliteral_string();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f88(s1, s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecollate_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 77;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_COLLATE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseident_name();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_ASSIGIN_EQUAL();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseident();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f89(s3, s5, s7);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_COLLATE();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseKW_ASSIGIN_EQUAL();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        s4 = peg$parse__();
        s5 = peg$parseident();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f90(s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_format() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 78;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 13);
    if (s1.toLowerCase() === peg$c34) {
      peg$currPos += 13;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e34);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 5);
      if (s3.toLowerCase() === peg$c35) {
        peg$currPos += 5;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e35);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 7);
        if (s3.toLowerCase() === peg$c36) {
          peg$currPos += 7;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e36);
          }
        }
        if (s3 === peg$FAILED) {
          s3 = input.substr(peg$currPos, 7);
          if (s3.toLowerCase() === peg$c21) {
            peg$currPos += 7;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e21);
            }
          }
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f91(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestorage() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 79;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c37) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e37);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 4);
      if (s3.toLowerCase() === peg$c38) {
        peg$currPos += 4;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e38);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 6);
        if (s3.toLowerCase() === peg$c39) {
          peg$currPos += 6;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e39);
          }
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f92(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsereference_definition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 80;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_REFERENCES();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_ref_list();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsecte_column_definition();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = input.substr(peg$currPos, 10);
          if (s7.toLowerCase() === peg$c40) {
            peg$currPos += 10;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e40);
            }
          }
          if (s7 === peg$FAILED) {
            s7 = input.substr(peg$currPos, 13);
            if (s7.toLowerCase() === peg$c41) {
              peg$currPos += 13;
            } else {
              s7 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e41);
              }
            }
            if (s7 === peg$FAILED) {
              s7 = input.substr(peg$currPos, 12);
              if (s7.toLowerCase() === peg$c42) {
                peg$currPos += 12;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e42);
                }
              }
            }
          }
          if (s7 === peg$FAILED) {
            s7 = null;
          }
          s8 = peg$parse__();
          s9 = peg$parseon_reference();
          if (s9 === peg$FAILED) {
            s9 = null;
          }
          s10 = peg$parse__();
          s11 = peg$parseon_reference();
          if (s11 === peg$FAILED) {
            s11 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f93(s1, s3, s5, s7, s9, s11);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseon_reference();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f94(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_option_list_item() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 81;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 20);
    if (s1.toLowerCase() === peg$c43) {
      peg$currPos += 20;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e43);
      }
    }
    if (s1 === peg$FAILED) {
      s1 = input.substr(peg$currPos, 25);
      if (s1.toLowerCase() === peg$c44) {
        peg$currPos += 25;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e44);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 24);
        if (s1.toLowerCase() === peg$c45) {
          peg$currPos += 24;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e45);
          }
        }
        if (s1 === peg$FAILED) {
          s1 = input.substr(peg$currPos, 12);
          if (s1.toLowerCase() === peg$c46) {
            peg$currPos += 12;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e46);
            }
          }
          if (s1 === peg$FAILED) {
            s1 = input.substr(peg$currPos, 13);
            if (s1.toLowerCase() === peg$c47) {
              peg$currPos += 13;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e47);
              }
            }
            if (s1 === peg$FAILED) {
              s1 = input.substr(peg$currPos, 11);
              if (s1.toLowerCase() === peg$c48) {
                peg$currPos += 11;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e48);
                }
              }
              if (s1 === peg$FAILED) {
                s1 = input.substr(peg$currPos, 6);
                if (s1.toLowerCase() === peg$c49) {
                  peg$currPos += 6;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e49);
                  }
                }
                if (s1 === peg$FAILED) {
                  s1 = input.substr(peg$currPos, 21);
                  if (s1.toLowerCase() === peg$c50) {
                    peg$currPos += 21;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e50);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseexpr();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f95(s1, s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_option_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 82;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsetable_option_list_item();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsetable_option_list_item();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsetable_option_list_item();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f96(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_option() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;
    var key = peg$currPos * 463 + 83;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 14);
    if (s1.toLowerCase() === peg$c29) {
      peg$currPos += 14;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e29);
      }
    }
    if (s1 === peg$FAILED) {
      s1 = input.substr(peg$currPos, 14);
      if (s1.toLowerCase() === peg$c51) {
        peg$currPos += 14;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e51);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 14);
        if (s1.toLowerCase() === peg$c52) {
          peg$currPos += 14;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e52);
          }
        }
        if (s1 === peg$FAILED) {
          s1 = input.substr(peg$currPos, 8);
          if (s1.toLowerCase() === peg$c53) {
            peg$currPos += 8;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e53);
            }
          }
          if (s1 === peg$FAILED) {
            s1 = input.substr(peg$currPos, 8);
            if (s1.toLowerCase() === peg$c54) {
              peg$currPos += 8;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e54);
              }
            }
            if (s1 === peg$FAILED) {
              s1 = input.substr(peg$currPos, 18);
              if (s1.toLowerCase() === peg$c55) {
                peg$currPos += 18;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e55);
                }
              }
            }
          }
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseliteral_numeric();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f97(s1, s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsecreate_option_character_set();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseKW_COMMENT();
        if (s1 === peg$FAILED) {
          s1 = input.substr(peg$currPos, 10);
          if (s1.toLowerCase() === peg$c56) {
            peg$currPos += 10;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e56);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseKW_ASSIGIN_EQUAL();
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          s4 = peg$parse__();
          s5 = peg$parseliteral_string();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f98(s1, s3, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = input.substr(peg$currPos, 11);
          if (s1.toLowerCase() === peg$c57) {
            peg$currPos += 11;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e57);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = peg$parseKW_ASSIGIN_EQUAL();
            if (s3 === peg$FAILED) {
              s3 = null;
            }
            s4 = peg$parse__();
            s5 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 39) {
              s6 = peg$c58;
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e58);
              }
            }
            if (s6 !== peg$FAILED) {
              s7 = input.substr(peg$currPos, 4);
              if (s7.toLowerCase() === peg$c59) {
                peg$currPos += 4;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e59);
                }
              }
              if (s7 === peg$FAILED) {
                s7 = input.substr(peg$currPos, 3);
                if (s7.toLowerCase() === peg$c60) {
                  peg$currPos += 3;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e60);
                  }
                }
                if (s7 === peg$FAILED) {
                  s7 = input.substr(peg$currPos, 4);
                  if (s7.toLowerCase() === peg$c26) {
                    peg$currPos += 4;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e26);
                    }
                  }
                }
              }
              if (s7 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 39) {
                  s8 = peg$c58;
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e58);
                  }
                }
                if (s8 !== peg$FAILED) {
                  s6 = [s6, s7, s8];
                  s5 = s6;
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f99(s1, s3, s5);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = input.substr(peg$currPos, 6);
            if (s1.toLowerCase() === peg$c61) {
              peg$currPos += 6;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e61);
              }
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parse__();
              s3 = peg$parseKW_ASSIGIN_EQUAL();
              if (s3 === peg$FAILED) {
                s3 = null;
              }
              s4 = peg$parse__();
              s5 = peg$parseident_name();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f100(s1, s3, s5);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseKW_PARTITION();
              if (s1 !== peg$FAILED) {
                s2 = peg$parse__();
                s3 = peg$parseKW_BY();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parse__();
                  s5 = peg$parseexpr();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f101(s5);
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = input.substr(peg$currPos, 7);
                if (s1.toLowerCase() === peg$c62) {
                  peg$currPos += 7;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e62);
                  }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$parse__();
                  s3 = input.substr(peg$currPos, 2);
                  if (s3.toLowerCase() === peg$c63) {
                    peg$currPos += 2;
                  } else {
                    s3 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e63);
                    }
                  }
                  if (s3 !== peg$FAILED) {
                    s4 = peg$parse__();
                    s5 = peg$parsecolumn_list();
                    if (s5 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s0 = peg$f102(s5);
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = input.substr(peg$currPos, 7);
                  if (s1.toLowerCase() === peg$c64) {
                    peg$currPos += 7;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e64);
                    }
                  }
                  if (s1 !== peg$FAILED) {
                    s2 = peg$parse__();
                    s3 = peg$parseLPAREN();
                    if (s3 !== peg$FAILED) {
                      s4 = peg$parse__();
                      s5 = peg$parsetable_option_list();
                      if (s5 !== peg$FAILED) {
                        s6 = peg$parse__();
                        s7 = peg$parseRPAREN();
                        if (s7 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s0 = peg$f103(s5);
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_like_table_simple() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 84;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_LIKE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_ref_list();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f104(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_option_character_set() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 85;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DEFAULT();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$parsecreate_option_character_set_kw();
    if (s3 === peg$FAILED) {
      s3 = input.substr(peg$currPos, 7);
      if (s3.toLowerCase() === peg$c65) {
        peg$currPos += 7;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e65);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 7);
        if (s3.toLowerCase() === peg$c66) {
          peg$currPos += 7;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e66);
          }
        }
      }
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      s5 = peg$parseKW_ASSIGIN_EQUAL();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parseident_without_kw_type();
      if (s7 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f105(s1, s3, s5, s7);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsealter_action() {
    var s0;
    var key = peg$currPos * 463 + 86;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseALTER_ADD_COLUMN();
    if (s0 === peg$FAILED) {
      s0 = peg$parseALTER_DROP_COLUMN();
      if (s0 === peg$FAILED) {
        s0 = peg$parseALTER_RENAME_TABLE();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselock_type() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 87;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c67) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e67);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 5);
      if (s3.toLowerCase() === peg$c12) {
        peg$currPos += 5;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e12);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f106(s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = input.substr(peg$currPos, 12);
      if (s1.toLowerCase() === peg$c68) {
        peg$currPos += 12;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e68);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 5);
      if (s3.toLowerCase() === peg$c69) {
        peg$currPos += 5;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e69);
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f107(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseshow_grant_for_using() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 88;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_USING();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseshow_grant_for_using_list();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f108(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseshow_grant_for_using_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 89;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseident();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseident();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f109(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_constraint_primary() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 90;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseconstraint_name();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$currPos;
    s4 = input.substr(peg$currPos, 7);
    if (s4.toLowerCase() === peg$c32) {
      peg$currPos += 7;
    } else {
      s4 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e32);
      }
    }
    if (s4 !== peg$FAILED) {
      s5 = peg$parse__();
      s6 = input.substr(peg$currPos, 3);
      if (s6.toLowerCase() === peg$c31) {
        peg$currPos += 3;
      } else {
        s6 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e31);
        }
      }
      if (s6 !== peg$FAILED) {
        s4 = [s4, s5, s6];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
    } else {
      peg$currPos = s3;
      s3 = peg$FAILED;
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      s5 = peg$parseindex_type();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsecte_column_definition();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parseindex_options();
        if (s9 === peg$FAILED) {
          s9 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f110(s1, s3, s5, s7, s9);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_constraint_unique() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 91;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseconstraint_name();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$parseKW_UNIQUE();
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      s5 = peg$parseKW_INDEX();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_KEY();
      }
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsecolumn();
      if (s7 === peg$FAILED) {
        s7 = null;
      }
      s8 = peg$parse__();
      s9 = peg$parseindex_type();
      if (s9 === peg$FAILED) {
        s9 = null;
      }
      s10 = peg$parse__();
      s11 = peg$parsecte_column_definition();
      if (s11 !== peg$FAILED) {
        s12 = peg$parse__();
        s13 = peg$parseindex_options();
        if (s13 === peg$FAILED) {
          s13 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f111(s1, s3, s5, s7, s9, s11, s13);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_constraint_foreign() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 92;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseconstraint_name();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = input.substr(peg$currPos, 11);
    if (s3.toLowerCase() === peg$c70) {
      peg$currPos += 11;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e70);
      }
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      s5 = peg$parsecolumn();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parsecte_column_definition();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parsereference_definition();
        if (s9 === peg$FAILED) {
          s9 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f112(s1, s3, s5, s7, s9);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_constraint_check() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 93;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseconstraint_name();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = input.substr(peg$currPos, 5);
    if (s3.toLowerCase() === peg$c13) {
      peg$currPos += 5;
    } else {
      s3 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e13);
      }
    }
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      s5 = peg$currPos;
      s6 = input.substr(peg$currPos, 3);
      if (s6.toLowerCase() === peg$c71) {
        peg$currPos += 3;
      } else {
        s6 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e71);
        }
      }
      if (s6 !== peg$FAILED) {
        s7 = peg$parse__();
        s8 = input.substr(peg$currPos, 3);
        if (s8.toLowerCase() === peg$c33) {
          peg$currPos += 3;
        } else {
          s8 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e33);
          }
        }
        if (s8 !== peg$FAILED) {
          s9 = peg$parse__();
          s10 = input.substr(peg$currPos, 11);
          if (s10.toLowerCase() === peg$c72) {
            peg$currPos += 11;
          } else {
            s10 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e72);
            }
          }
          if (s10 !== peg$FAILED) {
            s11 = peg$parse__();
            s6 = [s6, s7, s8, s9, s10, s11];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
      } else {
        peg$currPos = s5;
        s5 = peg$FAILED;
      }
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parseLPAREN();
      if (s6 !== peg$FAILED) {
        s7 = peg$parse__();
        s8 = peg$parseexpr();
        if (s8 !== peg$FAILED) {
          s9 = peg$parse__();
          s10 = peg$parseRPAREN();
          if (s10 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f113(s1, s3, s5, s8);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseindex_type() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 94;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_USING();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 5);
      if (s3.toLowerCase() === peg$c73) {
        peg$currPos += 5;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e73);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 4);
        if (s3.toLowerCase() === peg$c74) {
          peg$currPos += 4;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e74);
          }
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f114(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecte_column_definition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 95;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseLPAREN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecolumn();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = peg$parse__();
        s7 = peg$parseCOMMA();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parsecolumn();
          if (s9 !== peg$FAILED) {
            s6 = [s6, s7, s8, s9];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = peg$parse__();
          s7 = peg$parseCOMMA();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parsecolumn();
            if (s9 !== peg$FAILED) {
              s6 = [s6, s7, s8, s9];
              s5 = s6;
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        s5 = peg$parse__();
        s6 = peg$parseRPAREN();
        if (s6 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f115(s3, s4);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseindex_options() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 96;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseindex_option();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseindex_option();
      if (s5 !== peg$FAILED) {
        s4 = [s4, s5];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseindex_option();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f116(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseindex_option() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 97;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_KEY_BLOCK_SIZE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ASSIGIN_EQUAL();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseliteral_numeric();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f117(s1, s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseindex_type();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 4);
        if (s1.toLowerCase() === peg$c75) {
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e75);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = input.substr(peg$currPos, 6);
          if (s3.toLowerCase() === peg$c76) {
            peg$currPos += 6;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e76);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseident_name();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f118(s5);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = input.substr(peg$currPos, 7);
          if (s1.toLowerCase() === peg$c77) {
            peg$currPos += 7;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e77);
            }
          }
          if (s1 === peg$FAILED) {
            s1 = input.substr(peg$currPos, 9);
            if (s1.toLowerCase() === peg$c78) {
              peg$currPos += 9;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e78);
              }
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f119(s1);
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$parsekeyword_comment();
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseon_reference() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 98;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ON();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_DELETE();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_UPDATE();
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsereference_option();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f120(s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecreate_option_character_set_kw() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 99;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c7) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e7);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 3);
      if (s3.toLowerCase() === peg$c8) {
        peg$currPos += 3;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e8);
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f121();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseALTER_ADD_COLUMN() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 100;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ADD();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_COLUMN();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsecreate_column_definition();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f122(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseALTER_DROP_COLUMN() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 101;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DROP();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_COLUMN();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parsecolumn_ref();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f123(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseALTER_RENAME_TABLE() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 102;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_RENAME();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TO();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_AS();
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseident();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f124(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseconstraint_name() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 103;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CONSTRAINT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseident();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f125(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsereference_option() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 104;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CURRENT_TIMESTAMP();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr_list();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseRPAREN();
        if (s7 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f126(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = input.substr(peg$currPos, 8);
      if (s1.toLowerCase() === peg$c79) {
        peg$currPos += 8;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e79);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 7);
        if (s1.toLowerCase() === peg$c80) {
          peg$currPos += 7;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e80);
          }
        }
        if (s1 === peg$FAILED) {
          s1 = input.substr(peg$currPos, 8);
          if (s1.toLowerCase() === peg$c81) {
            peg$currPos += 8;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e81);
            }
          }
          if (s1 === peg$FAILED) {
            s1 = input.substr(peg$currPos, 9);
            if (s1.toLowerCase() === peg$c82) {
              peg$currPos += 9;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e82);
              }
            }
            if (s1 === peg$FAILED) {
              s1 = input.substr(peg$currPos, 11);
              if (s1.toLowerCase() === peg$c83) {
                peg$currPos += 11;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e83);
                }
              }
              if (s1 === peg$FAILED) {
                s1 = peg$parseKW_CURRENT_TIMESTAMP();
              }
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f127(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UPDATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 105;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c84) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e84);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CREATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 106;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c85) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e85);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DELETE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 107;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c86) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e86);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INSERT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 108;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c87) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e87);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ASSIGN() {
    var s0;
    var key = peg$currPos * 463 + 109;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.substr(peg$currPos, 2) === peg$c88) {
      s0 = peg$c88;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e88);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ASSIGIN_EQUAL() {
    var s0;
    var key = peg$currPos * 463 + 110;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 61) {
      s0 = peg$c0;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e0);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_RETURN() {
    var s0;
    var key = peg$currPos * 463 + 111;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.substr(peg$currPos, 6);
    if (s0.toLowerCase() === peg$c89) {
      peg$currPos += 6;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e89);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_REPLACE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 112;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c90) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e90);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ANALYZE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 113;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c91) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e91);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ATTACH() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 114;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c92) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e92);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DATABASE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 115;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c93) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e93);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_RENAME() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 116;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c94) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e94);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SHOW() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 117;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c95) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e95);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DESCRIBE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 118;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c96) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e96);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VAR__PRE_AT() {
    var s0;
    var key = peg$currPos * 463 + 119;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 64) {
      s0 = peg$c97;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e97);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VAR__PRE_AT_AT() {
    var s0;
    var key = peg$currPos * 463 + 120;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.substr(peg$currPos, 2) === peg$c98) {
      s0 = peg$c98;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e98);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VAR_PRE_DOLLAR() {
    var s0;
    var key = peg$currPos * 463 + 121;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 36) {
      s0 = peg$c99;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e99);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VAR_PRE() {
    var s0;
    var key = peg$currPos * 463 + 122;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseKW_VAR__PRE_AT_AT();
    if (s0 === peg$FAILED) {
      s0 = input.charAt(peg$currPos);
      if (peg$r0.test(s0)) {
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e100);
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TEMPORARY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 123;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c100) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e101);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TEMP() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 124;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c101) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e102);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SCHEMA() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 125;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c102) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e103);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ALTER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 126;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c103) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e104);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SPATIAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 127;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c104) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e105);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_KEY_BLOCK_SIZE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 128;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 14);
    if (s1.toLowerCase() === peg$c52) {
      peg$currPos += 14;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e52);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsequery_statement() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 129;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsequery_expr();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c105;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e106);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseselect_stmt();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 41) {
            s6 = peg$c106;
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e107);
            }
          }
          if (s6 !== peg$FAILED) {
            s2 = [s2, s3, s4, s5, s6];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f128(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsequery_expr() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 130;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseunion_stmt();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseorder_by_clause();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parselimit_clause();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      peg$savedPos = s0;
      s0 = peg$f129(s1, s3, s5);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseset_op() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 131;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_UNION();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_ALL();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_DISTINCT();
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f130(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = input.substr(peg$currPos, 9);
      if (s1.toLowerCase() === peg$c107) {
        peg$currPos += 9;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e108);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 6);
        if (s1.toLowerCase() === peg$c108) {
          peg$currPos += 6;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e109);
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseKW_DISTINCT();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f131(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunion_stmt() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 132;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseunion_stmt_nake();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c105;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e106);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseunion_stmt_nake();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 41) {
            s6 = peg$c106;
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e107);
            }
          }
          if (s6 !== peg$FAILED) {
            s2 = [s2, s3, s4, s5, s6];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f132(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunion_stmt_nake() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 133;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseselect_stmt();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseset_op();
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      s6 = peg$parse__();
      s7 = peg$parseselect_stmt();
      if (s7 !== peg$FAILED) {
        s4 = [s4, s5, s6, s7];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseset_op();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseselect_stmt();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      s3 = peg$parse__();
      s4 = peg$parseorder_by_clause();
      if (s4 === peg$FAILED) {
        s4 = null;
      }
      s5 = peg$parse__();
      s6 = peg$parselimit_clause();
      if (s6 === peg$FAILED) {
        s6 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f133(s1, s2, s4, s6);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseselect_stmt() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 134;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseselect_stmt_nake();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c105;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e106);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseselect_stmt();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          if (input.charCodeAt(peg$currPos) === 41) {
            s6 = peg$c106;
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e107);
            }
          }
          if (s6 !== peg$FAILED) {
            s2 = [s2, s3, s4, s5, s6];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f134(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewith_clause() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 135;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_WITH();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecte_definition();
      if (s3 !== peg$FAILED) {
        s4 = [];
        s5 = peg$currPos;
        s6 = peg$parse__();
        s7 = peg$parseCOMMA();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parsecte_definition();
          if (s9 !== peg$FAILED) {
            s6 = [s6, s7, s8, s9];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        while (s5 !== peg$FAILED) {
          s4.push(s5);
          s5 = peg$currPos;
          s6 = peg$parse__();
          s7 = peg$parseCOMMA();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parsecte_definition();
            if (s9 !== peg$FAILED) {
              s6 = [s6, s7, s8, s9];
              s5 = s6;
            } else {
              peg$currPos = s5;
              s5 = peg$FAILED;
            }
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f135(s3, s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecte_definition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 136;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseliteral_string();
    if (s1 === peg$FAILED) {
      s1 = peg$parseident_name();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_AS();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseLPAREN();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseunion_stmt();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseRPAREN();
            if (s9 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f136(s1, s7);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseselect_stmt_nake() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21, s22, s23, s24, s25, s26, s27, s28;
    var key = peg$currPos * 463 + 137;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parse__();
    s2 = peg$parsewith_clause();
    if (s2 === peg$FAILED) {
      s2 = null;
    }
    s3 = peg$parse__();
    s4 = peg$parseKW_SELECT();
    if (s4 !== peg$FAILED) {
      s5 = peg$parse___();
      if (s5 !== peg$FAILED) {
        s6 = peg$parsestruct_value();
        if (s6 === peg$FAILED) {
          s6 = null;
        }
        s7 = peg$parse__();
        s8 = peg$parseKW_ALL();
        if (s8 === peg$FAILED) {
          s8 = peg$parseKW_DISTINCT();
        }
        if (s8 === peg$FAILED) {
          s8 = null;
        }
        s9 = peg$parse__();
        s10 = peg$parsecolumn_clause();
        if (s10 !== peg$FAILED) {
          s11 = peg$parse__();
          s12 = peg$parsefrom_clause();
          if (s12 === peg$FAILED) {
            s12 = null;
          }
          s13 = peg$parse__();
          s14 = peg$parsefor_sys_time_as_of();
          if (s14 === peg$FAILED) {
            s14 = null;
          }
          s15 = peg$parse__();
          s16 = peg$parsewhere_clause();
          if (s16 === peg$FAILED) {
            s16 = null;
          }
          s17 = peg$parse__();
          s18 = peg$parsegroup_by_clause();
          if (s18 === peg$FAILED) {
            s18 = null;
          }
          s19 = peg$parse__();
          s20 = peg$parsehaving_clause();
          if (s20 === peg$FAILED) {
            s20 = null;
          }
          s21 = peg$parse__();
          s22 = peg$parsequalify_clause();
          if (s22 === peg$FAILED) {
            s22 = null;
          }
          s23 = peg$parse__();
          s24 = peg$parseorder_by_clause();
          if (s24 === peg$FAILED) {
            s24 = null;
          }
          s25 = peg$parse__();
          s26 = peg$parselimit_clause();
          if (s26 === peg$FAILED) {
            s26 = null;
          }
          s27 = peg$parse__();
          s28 = peg$parsewindow_clause();
          if (s28 === peg$FAILED) {
            s28 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f137(s2, s6, s8, s10, s12, s14, s16, s18, s20, s22, s24, s26, s28);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsefor_sys_time_as_of() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 138;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c33) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e33);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 11);
      if (s3.toLowerCase() === peg$c109) {
        peg$currPos += 11;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e110);
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = input.substr(peg$currPos, 2);
        if (s5.toLowerCase() === peg$c110) {
          peg$currPos += 2;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e111);
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = input.substr(peg$currPos, 2);
          if (s7.toLowerCase() === peg$c111) {
            peg$currPos += 2;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e112);
            }
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseexpr();
            if (s9 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f138(s9);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestruct_value() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 139;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_AS();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_STRUCT();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_VALUE();
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f139(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexpr_alias() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 140;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsebinary_column_expr();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsealias_clause();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f140(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 141;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumns_list();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseCOMMA();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f141(s1);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumns_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 142;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn_list_item();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsecolumn_list_item();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsecolumn_list_item();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f142(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_offset_expr_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 143;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$parseLBRAKE();
    if (s3 !== peg$FAILED) {
      s4 = peg$parse__();
      s5 = peg$parseliteral_numeric();
      if (s5 === peg$FAILED) {
        s5 = peg$parseliteral_string();
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseRBRAKE();
        if (s7 !== peg$FAILED) {
          s3 = [s3, s4, s5, s6, s7];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$parseLBRAKE();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseliteral_numeric();
          if (s5 === peg$FAILED) {
            s5 = peg$parseliteral_string();
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseRBRAKE();
            if (s7 !== peg$FAILED) {
              s3 = [s3, s4, s5, s6, s7];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f143(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parseLBRAKE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_OFFSET();
        if (s5 === peg$FAILED) {
          s5 = peg$parseKW_ORDINAL();
          if (s5 === peg$FAILED) {
            s5 = peg$parseKW_SAFE_OFFSET();
            if (s5 === peg$FAILED) {
              s5 = peg$parseKW_SAFE_ORDINAL();
            }
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseLPAREN();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseliteral_numeric();
            if (s9 === peg$FAILED) {
              s9 = peg$parseliteral_string();
            }
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parseRPAREN();
              if (s11 !== peg$FAILED) {
                s12 = peg$parse__();
                s13 = peg$parseRBRAKE();
                if (s13 !== peg$FAILED) {
                  s3 = [s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13];
                  s2 = s3;
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parseLBRAKE();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseKW_OFFSET();
            if (s5 === peg$FAILED) {
              s5 = peg$parseKW_ORDINAL();
              if (s5 === peg$FAILED) {
                s5 = peg$parseKW_SAFE_OFFSET();
                if (s5 === peg$FAILED) {
                  s5 = peg$parseKW_SAFE_ORDINAL();
                }
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parseLPAREN();
              if (s7 !== peg$FAILED) {
                s8 = peg$parse__();
                s9 = peg$parseliteral_numeric();
                if (s9 === peg$FAILED) {
                  s9 = peg$parseliteral_string();
                }
                if (s9 !== peg$FAILED) {
                  s10 = peg$parse__();
                  s11 = peg$parseRPAREN();
                  if (s11 !== peg$FAILED) {
                    s12 = peg$parse__();
                    s13 = peg$parseRBRAKE();
                    if (s13 !== peg$FAILED) {
                      s3 = [s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13];
                      s2 = s3;
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f144(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_offset_expr() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 144;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpr();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecolumn_offset_expr_list();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f145(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_list_item() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    var key = peg$currPos * 463 + 145;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parsecolumn_without_kw();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parseDOT();
      if (s4 !== peg$FAILED) {
        s2 = [s2, s3, s4];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parseSTAR();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = input.substr(peg$currPos, 6);
      if (s4.toLowerCase() === peg$c108) {
        peg$currPos += 6;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e109);
        }
      }
      if (s4 === peg$FAILED) {
        s4 = input.substr(peg$currPos, 7);
        if (s4.toLowerCase() === peg$c90) {
          peg$currPos += 7;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e90);
          }
        }
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__();
        s6 = peg$parseLPAREN();
        if (s6 !== peg$FAILED) {
          s7 = peg$parse__();
          s8 = peg$parsecolumns_list();
          if (s8 !== peg$FAILED) {
            s9 = peg$parse__();
            s10 = peg$parseRPAREN();
            if (s10 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f146(s1, s4, s8);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_ALL();
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$parseSTAR();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          peg$silentFails++;
          s4 = peg$parseident_start();
          peg$silentFails--;
          if (s4 === peg$FAILED) {
            s3 = void 0;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            s2 = [s2, s3];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
        if (s1 === peg$FAILED) {
          s1 = peg$parseSTAR();
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f147(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsecolumn_without_kw();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseDOT();
          if (s3 !== peg$FAILED) {
            s4 = peg$currPos;
            s5 = peg$parsecolumn_offset_expr();
            if (s5 === peg$FAILED) {
              s5 = peg$parsecolumn_without_kw();
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parseDOT();
              if (s7 !== peg$FAILED) {
                s5 = [s5, s6, s7];
                s4 = s5;
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
            if (s4 === peg$FAILED) {
              s4 = null;
            }
            s5 = peg$parse__();
            s6 = peg$parseSTAR();
            if (s6 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f148(s1, s4);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsecolumn_offset_expr();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = peg$currPos;
            s4 = peg$parseDOT();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse__();
              s6 = peg$parsecolumn_without_kw();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
            if (s3 === peg$FAILED) {
              s3 = null;
            }
            s4 = peg$parse__();
            s5 = peg$parsealias_clause();
            if (s5 === peg$FAILED) {
              s5 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f149(s1, s3, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$parseexpr_alias();
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsealias_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 146;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_AS();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsealias_ident();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f150(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_AS();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parse__();
      s3 = peg$parsecolumn();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f151(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsefrom_unnest_item() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 147;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c112) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e113);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseRPAREN();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parsealias_clause();
          if (s9 === peg$FAILED) {
            s9 = null;
          }
          s10 = peg$parse__();
          s11 = peg$parsewith_offset();
          if (s11 === peg$FAILED) {
            s11 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f152(s5, s9, s11);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsefrom_clause() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 148;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_FROM();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_ref_list();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsepivot_operator();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f153(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsepivot_operator() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
    var key = peg$currPos * 463 + 149;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_PIVOT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseaggr_func_list();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = input.substr(peg$currPos, 3);
          if (s7.toLowerCase() === peg$c33) {
            peg$currPos += 3;
          } else {
            s7 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e33);
            }
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parsecolumn_ref();
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parsein_op_right();
              if (s11 !== peg$FAILED) {
                s12 = peg$parse__();
                s13 = peg$parseRPAREN();
                if (s13 !== peg$FAILED) {
                  s14 = peg$parse__();
                  s15 = peg$parsealias_clause();
                  if (s15 === peg$FAILED) {
                    s15 = null;
                  }
                  peg$savedPos = s0;
                  s0 = peg$f154(s5, s9, s11, s15);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewith_offset() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 150;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_WITH();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_OFFSET();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsealias_clause();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f155(s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_to_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 151;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsetable_to_item();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsetable_to_item();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsetable_to_item();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f156(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_to_item() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 152;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsetable_name();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_TO();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsetable_name();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f157(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_ref_list() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 153;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsetable_base();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parsetable_ref();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parsetable_ref();
      }
      peg$savedPos = s0;
      s0 = peg$f158(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_ref() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 154;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parse__();
    s2 = peg$parseCOMMA();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parsetable_base();
      if (s4 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f159(s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parse__();
      s2 = peg$parsetable_join();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f160(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_join() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15;
    var key = peg$currPos * 463 + 155;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsejoin_op();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsetable_base();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_USING();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseLPAREN();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseident_name();
            if (s9 !== peg$FAILED) {
              s10 = [];
              s11 = peg$currPos;
              s12 = peg$parse__();
              s13 = peg$parseCOMMA();
              if (s13 !== peg$FAILED) {
                s14 = peg$parse__();
                s15 = peg$parseident_name();
                if (s15 !== peg$FAILED) {
                  s12 = [s12, s13, s14, s15];
                  s11 = s12;
                } else {
                  peg$currPos = s11;
                  s11 = peg$FAILED;
                }
              } else {
                peg$currPos = s11;
                s11 = peg$FAILED;
              }
              while (s11 !== peg$FAILED) {
                s10.push(s11);
                s11 = peg$currPos;
                s12 = peg$parse__();
                s13 = peg$parseCOMMA();
                if (s13 !== peg$FAILED) {
                  s14 = peg$parse__();
                  s15 = peg$parseident_name();
                  if (s15 !== peg$FAILED) {
                    s12 = [s12, s13, s14, s15];
                    s11 = s12;
                  } else {
                    peg$currPos = s11;
                    s11 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s11;
                  s11 = peg$FAILED;
                }
              }
              s11 = peg$parse__();
              s12 = peg$parseRPAREN();
              if (s12 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f161(s1, s3, s9, s10);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsejoin_op();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parsetable_base();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseon_clause();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f162(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsejoin_op();
        if (s1 === peg$FAILED) {
          s1 = peg$parseset_op();
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseLPAREN();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseunion_stmt();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parseRPAREN();
              if (s7 !== peg$FAILED) {
                s8 = peg$parse__();
                s9 = peg$parsealias_clause();
                if (s9 === peg$FAILED) {
                  s9 = null;
                }
                s10 = peg$parse__();
                s11 = peg$parseon_clause();
                if (s11 === peg$FAILED) {
                  s11 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f163(s1, s5, s9, s11);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsehint() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    var key = peg$currPos * 463 + 156;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r1.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e114);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = input.charAt(peg$currPos);
      if (peg$r2.test(s2)) {
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e115);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseident_name();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          s6 = input.charAt(peg$currPos);
          if (peg$r3.test(s6)) {
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e116);
            }
          }
          if (s6 !== peg$FAILED) {
            s7 = peg$parse__();
            s8 = peg$parseident_name();
            if (s8 !== peg$FAILED) {
              s9 = peg$parse__();
              s10 = input.charAt(peg$currPos);
              if (peg$r4.test(s10)) {
                peg$currPos++;
              } else {
                s10 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e117);
                }
              }
              if (s10 !== peg$FAILED) {
                s1 = [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetablesample() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 157;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 11);
    if (s1.toLowerCase() === peg$c113) {
      peg$currPos += 11;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e118);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 9);
      if (s3.toLowerCase() === peg$c114) {
        peg$currPos += 9;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e119);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 9);
        if (s3.toLowerCase() === peg$c115) {
          peg$currPos += 9;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e120);
          }
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        if (input.charCodeAt(peg$currPos) === 40) {
          s5 = peg$c105;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e106);
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsenumber();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = input.substr(peg$currPos, 7);
            if (s9.toLowerCase() === peg$c116) {
              peg$currPos += 7;
            } else {
              s9 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e121);
              }
            }
            if (s9 === peg$FAILED) {
              s9 = input.substr(peg$currPos, 4);
              if (s9.toLowerCase() === peg$c117) {
                peg$currPos += 4;
              } else {
                s9 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e122);
                }
              }
            }
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              if (input.charCodeAt(peg$currPos) === 41) {
                s11 = peg$c106;
                peg$currPos++;
              } else {
                s11 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e107);
                }
              }
              if (s11 !== peg$FAILED) {
                s1 = [s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_base() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 158;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsefrom_unnest_item();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsetable_name();
      if (s1 !== peg$FAILED) {
        s2 = peg$parsehint();
        if (s2 === peg$FAILED) {
          s2 = null;
        }
        s3 = peg$parse__();
        s4 = peg$parsetablesample();
        if (s4 === peg$FAILED) {
          s4 = null;
        }
        s5 = peg$parse__();
        s6 = peg$parsealias_clause();
        if (s6 === peg$FAILED) {
          s6 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f164(s1, s2, s4, s6);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseLPAREN();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseunion_stmt();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseRPAREN();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parsetablesample();
              if (s7 === peg$FAILED) {
                s7 = null;
              }
              s8 = peg$parse__();
              s9 = peg$parsealias_clause();
              if (s9 === peg$FAILED) {
                s9 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f165(s3, s7, s9);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsejoin_op() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 159;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_LEFT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_OUTER();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseKW_JOIN();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f166();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_RIGHT();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseKW_OUTER();
        if (s3 === peg$FAILED) {
          s3 = null;
        }
        s4 = peg$parse__();
        s5 = peg$parseKW_JOIN();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f167();
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseKW_FULL();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseKW_OUTER();
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          s4 = peg$parse__();
          s5 = peg$parseKW_JOIN();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f168();
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseKW_CROSS();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = peg$parseKW_JOIN();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f169(s1);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseKW_INNER();
            if (s1 === peg$FAILED) {
              s1 = null;
            }
            s2 = peg$parse__();
            s3 = peg$parseKW_JOIN();
            if (s3 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f170(s1);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetable_name() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 160;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_without_kw();
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      s3 = peg$parse__();
      s4 = peg$parseDOT();
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__();
        s6 = peg$parseident_without_kw();
        if (s6 !== peg$FAILED) {
          s3 = [s3, s4, s5, s6];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseDOT();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseident_without_kw();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f171(s1, s2, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseident_without_kw();
      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parse__();
        s4 = peg$parseDOT();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          s6 = peg$parseident_without_kw();
          if (s6 !== peg$FAILED) {
            s3 = [s3, s4, s5, s6];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f172(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseor_and_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 161;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseKW_AND();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_OR();
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseexpr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseKW_AND();
        if (s5 === peg$FAILED) {
          s5 = peg$parseKW_OR();
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseexpr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f173(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseon_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 162;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ON();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseor_and_where_expr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f174(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewhere_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 163;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_WHERE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseor_and_where_expr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f175(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsegroup_by_clause() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 164;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_GROUP();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_BY();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr_list();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f176(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsehaving_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 165;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_HAVING();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseor_and_where_expr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f177(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsequalify_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 166;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_QUALIFY();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseexpr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f178(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_clause() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 167;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_WINDOW();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsenamed_window_expr_list();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f179(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsenamed_window_expr_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 168;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsenamed_window_expr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsenamed_window_expr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsenamed_window_expr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f180(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsenamed_window_expr() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 169;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_name();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_AS();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseas_window_specification();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f181(s1, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseas_window_specification() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 170;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_name();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f182(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseLPAREN();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parsewindow_specification();
        s4 = peg$parse__();
        s5 = peg$parseRPAREN();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f183(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_specification() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 171;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident();
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$parsepartition_by_clause();
    if (s3 === peg$FAILED) {
      s3 = null;
    }
    s4 = peg$parse__();
    s5 = peg$parseorder_by_clause();
    if (s5 === peg$FAILED) {
      s5 = null;
    }
    s6 = peg$parse__();
    s7 = peg$parsewindow_frame_clause();
    if (s7 === peg$FAILED) {
      s7 = null;
    }
    peg$savedPos = s0;
    s0 = peg$f184(s1, s3, s5, s7);
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_frame_clause() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12;
    var key = peg$currPos * 463 + 172;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c118) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e123);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_BETWEEN();
      if (s3 !== peg$FAILED) {
        s4 = input.substr(peg$currPos, 9);
        if (s4.toLowerCase() === peg$c119) {
          peg$currPos += 9;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e124);
          }
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          s6 = input.substr(peg$currPos, 9);
          if (s6.toLowerCase() === peg$c120) {
            peg$currPos += 9;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e125);
            }
          }
          if (s6 !== peg$FAILED) {
            s7 = peg$parse__();
            s8 = peg$parseKW_AND();
            if (s8 !== peg$FAILED) {
              s9 = peg$parse__();
              s10 = input.substr(peg$currPos, 7);
              if (s10.toLowerCase() === peg$c121) {
                peg$currPos += 7;
              } else {
                s10 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e126);
                }
              }
              if (s10 !== peg$FAILED) {
                s11 = peg$parse__();
                if (input.substr(peg$currPos, 3) === peg$c122) {
                  s12 = peg$c122;
                  peg$currPos += 3;
                } else {
                  s12 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e127);
                  }
                }
                if (s12 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f185();
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_ROWS();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parsewindow_frame_following();
        if (s3 === peg$FAILED) {
          s3 = peg$parsewindow_frame_preceding();
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f186(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseKW_ROWS();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseKW_BETWEEN();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parsewindow_frame_preceding();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parseKW_AND();
              if (s7 !== peg$FAILED) {
                s8 = peg$parse__();
                s9 = peg$parsewindow_frame_following();
                if (s9 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f187(s5, s9);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_frame_following() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 173;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsewindow_frame_value();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 9);
      if (s3.toLowerCase() === peg$c123) {
        peg$currPos += 9;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e128);
        }
      }
      if (s3 === peg$FAILED) {
        s3 = input.substr(peg$currPos, 9);
        if (s3.toLowerCase() === peg$c120) {
          peg$currPos += 9;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e125);
          }
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f188(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsewindow_frame_current_row();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_frame_preceding() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 174;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsewindow_frame_value();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 9);
      if (s3.toLowerCase() === peg$c120) {
        peg$currPos += 9;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e125);
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f189(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsewindow_frame_current_row();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_frame_current_row() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 175;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c121) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e126);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 3);
      if (s3.toLowerCase() === peg$c124) {
        peg$currPos += 3;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e129);
        }
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f190();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewindow_frame_value() {
    var s0, s1;
    var key = peg$currPos * 463 + 176;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c119) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e124);
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f191(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$parseliteral_numeric();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsepartition_by_clause() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 177;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_PARTITION();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_BY();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsecolumn_clause();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f192(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseorder_by_clause() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 178;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ORDER();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_BY();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseorder_by_list();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f193(s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseorder_by_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 179;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseorder_by_element();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseorder_by_element();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseorder_by_element();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f194(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseorder_by_element() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 180;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpr();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$currPos;
      s4 = input.substr(peg$currPos, 7);
      if (s4.toLowerCase() === peg$c66) {
        peg$currPos += 7;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e66);
        }
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parse__();
        s6 = peg$parseliteral_string();
        if (s6 !== peg$FAILED) {
          s4 = [s4, s5, s6];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseKW_DESC();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_ASC();
      }
      if (s5 === peg$FAILED) {
        s5 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f195(s1, s3, s5);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsenumber_or_param() {
    var s0;
    var key = peg$currPos * 463 + 181;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseliteral_numeric();
    if (s0 === peg$FAILED) {
      s0 = peg$parseparam();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselimit_clause() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8;
    var key = peg$currPos * 463 + 182;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_LIMIT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsenumber_or_param();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$currPos;
        s6 = peg$parseCOMMA();
        if (s6 === peg$FAILED) {
          s6 = peg$parseKW_OFFSET();
        }
        if (s6 !== peg$FAILED) {
          s7 = peg$parse__();
          s8 = peg$parsenumber_or_param();
          if (s8 !== peg$FAILED) {
            s6 = [s6, s7, s8];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f196(s3, s5);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexpr_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 183;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseexpr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseexpr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f197(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parse_expr() {
    var s0;
    var key = peg$currPos * 463 + 184;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsestruct_expr();
    if (s0 === peg$FAILED) {
      s0 = peg$parsejson_expr();
      if (s0 === peg$FAILED) {
        s0 = peg$parseor_expr();
        if (s0 === peg$FAILED) {
          s0 = peg$parseunary_expr();
          if (s0 === peg$FAILED) {
            s0 = peg$parsearray_expr();
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexpr() {
    var s0;
    var key = peg$currPos * 463 + 185;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parse_expr();
    if (s0 === peg$FAILED) {
      s0 = peg$parseunion_stmt();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseparentheses_list_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 186;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseparentheses_expr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseparentheses_expr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseparentheses_expr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f198(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseparentheses_expr() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 187;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseLPAREN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecolumn_clause();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseRPAREN();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f199(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsearray_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 188;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseLBRAKE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecolumn_clause();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = peg$parse__();
      s5 = peg$parseRBRAKE();
      if (s5 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f200(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsearray_type();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_ARRAY();
      }
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parseLBRAKE();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseliteral_list();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          s6 = peg$parseRBRAKE();
          if (s6 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f201(s1, s4);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsearray_type();
        if (s1 === peg$FAILED) {
          s1 = peg$parseKW_ARRAY();
        }
        if (s1 === peg$FAILED) {
          s1 = null;
        }
        s2 = peg$parse__();
        s3 = peg$parseLBRAKE();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseparentheses_list_expr();
          if (s5 === peg$FAILED) {
            s5 = peg$parseexpr();
          }
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseRBRAKE();
            if (s7 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f202(s1, s3, s5, s7);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsearray_type();
          if (s1 === peg$FAILED) {
            s1 = peg$parseKW_ARRAY();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = peg$parseLPAREN();
            if (s3 !== peg$FAILED) {
              s4 = peg$parse__();
              s5 = peg$parseparentheses_list_expr();
              if (s5 === peg$FAILED) {
                s5 = peg$parseexpr();
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse__();
                s7 = peg$parseRPAREN();
                if (s7 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f203(s1, s3, s5, s7);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsejson_expr() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 189;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_JSON();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseliteral_list();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f204(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestruct_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 190;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsestruct_type();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_STRUCT();
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsecolumn_clause();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f205(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunary_expr() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 191;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseadditive_operator();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseprimary();
      if (s5 !== peg$FAILED) {
        s4 = [s4, s5];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse__();
          s5 = peg$parseprimary();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f206(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsebinary_column_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 192;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseKW_AND();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_OR();
        if (s5 === peg$FAILED) {
          s5 = peg$parseLOGIC_OPERATOR();
        }
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseexpr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseKW_AND();
        if (s5 === peg$FAILED) {
          s5 = peg$parseKW_OR();
          if (s5 === peg$FAILED) {
            s5 = peg$parseLOGIC_OPERATOR();
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseexpr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f207(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseor_and_where_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 193;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseKW_AND();
      if (s5 === peg$FAILED) {
        s5 = peg$parseKW_OR();
        if (s5 === peg$FAILED) {
          s5 = peg$parseCOMMA();
        }
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseexpr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseKW_AND();
        if (s5 === peg$FAILED) {
          s5 = peg$parseKW_OR();
          if (s5 === peg$FAILED) {
            s5 = peg$parseCOMMA();
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseexpr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f208(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseor_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 194;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseand_expr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse___();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseKW_OR();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseand_expr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse___();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseKW_OR();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseand_expr();
            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f209(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseand_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 195;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsenot_expr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse___();
      if (s4 !== peg$FAILED) {
        s5 = peg$parseKW_AND();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsenot_expr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse___();
        if (s4 !== peg$FAILED) {
          s5 = peg$parseKW_AND();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parsenot_expr();
            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f210(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsenot_expr() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 196;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecomparison_expr();
    if (s0 === peg$FAILED) {
      s0 = peg$parseexists_expr();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseKW_NOT();
        if (s1 === peg$FAILED) {
          s1 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 33) {
            s2 = peg$c125;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e130);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$currPos;
            peg$silentFails++;
            if (input.charCodeAt(peg$currPos) === 61) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e0);
              }
            }
            peg$silentFails--;
            if (s4 === peg$FAILED) {
              s3 = void 0;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
            if (s3 !== peg$FAILED) {
              s2 = [s2, s3];
              s1 = s2;
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parsenot_expr();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f211(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecomparison_expr() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 197;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseadditive_expr();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecomparison_op_right();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f212(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseliteral_string();
      if (s0 === peg$FAILED) {
        s0 = peg$parsecolumn_ref();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexists_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 198;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexists_op();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseunion_stmt();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f213(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexists_op() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 199;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseKW_NOT();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parseKW_EXISTS();
      if (s4 !== peg$FAILED) {
        s2 = [s2, s3, s4];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f214(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_EXISTS();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecomparison_op_right() {
    var s0;
    var key = peg$currPos * 463 + 200;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsearithmetic_op_right();
    if (s0 === peg$FAILED) {
      s0 = peg$parsein_op_right();
      if (s0 === peg$FAILED) {
        s0 = peg$parsebetween_op_right();
        if (s0 === peg$FAILED) {
          s0 = peg$parseis_op_right();
          if (s0 === peg$FAILED) {
            s0 = peg$parselike_op_right();
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsearithmetic_op_right() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 201;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$currPos;
    s3 = peg$parse__();
    s4 = peg$parsearithmetic_comparison_operator();
    if (s4 !== peg$FAILED) {
      s5 = peg$parse__();
      s6 = peg$parseadditive_expr();
      if (s6 !== peg$FAILED) {
        s3 = [s3, s4, s5, s6];
        s2 = s3;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
    } else {
      peg$currPos = s2;
      s2 = peg$FAILED;
    }
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$currPos;
        s3 = peg$parse__();
        s4 = peg$parsearithmetic_comparison_operator();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse__();
          s6 = peg$parseadditive_expr();
          if (s6 !== peg$FAILED) {
            s3 = [s3, s4, s5, s6];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f215(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsearithmetic_comparison_operator() {
    var s0;
    var key = peg$currPos * 463 + 202;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.substr(peg$currPos, 2) === peg$c126) {
      s0 = peg$c126;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e131);
      }
    }
    if (s0 === peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 62) {
        s0 = peg$c127;
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e132);
        }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 2) === peg$c128) {
          s0 = peg$c128;
          peg$currPos += 2;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e133);
          }
        }
        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 2) === peg$c129) {
            s0 = peg$c129;
            peg$currPos += 2;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e134);
            }
          }
          if (s0 === peg$FAILED) {
            s0 = input.charAt(peg$currPos);
            if (peg$r5.test(s0)) {
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e135);
              }
            }
            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 2) === peg$c130) {
                s0 = peg$c130;
                peg$currPos += 2;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e136);
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseis_op_right() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 203;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_IS();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseadditive_expr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f216(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$currPos;
      s2 = peg$parseKW_IS();
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$parseKW_NOT();
        if (s4 !== peg$FAILED) {
          s2 = [s2, s3, s4];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseadditive_expr();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f217(s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsebetween_op_right() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 204;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsebetween_or_not_between_op();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseadditive_expr();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_AND();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseadditive_expr();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f218(s1, s3, s7);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsebetween_or_not_between_op() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 205;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseKW_NOT();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parseKW_BETWEEN();
      if (s4 !== peg$FAILED) {
        s2 = [s2, s3, s4];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f219(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_BETWEEN();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselike_op() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 206;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseKW_NOT();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parseKW_LIKE();
      if (s4 !== peg$FAILED) {
        s2 = [s2, s3, s4];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f220(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_LIKE();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsein_op() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 207;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseKW_NOT();
    if (s2 !== peg$FAILED) {
      s3 = peg$parse__();
      s4 = peg$parseKW_IN();
      if (s4 !== peg$FAILED) {
        s2 = [s2, s3, s4];
        s1 = s2;
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f221(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_IN();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parselike_op_right() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 208;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parselike_op();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseliteral();
      if (s3 === peg$FAILED) {
        s3 = peg$parsecomparison_expr();
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f222(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsein_op_right() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 209;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsein_op();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr_list();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f223(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsein_op();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseliteral_string();
        if (s3 === peg$FAILED) {
          s3 = peg$parsefrom_unnest_item();
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f224(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseadditive_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 210;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsemultiplicative_expr();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseadditive_operator();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsemultiplicative_expr();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseadditive_operator();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsemultiplicative_expr();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f225(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseadditive_operator() {
    var s0;
    var key = peg$currPos * 463 + 211;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r6.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e137);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsemultiplicative_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 212;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseunary_expr_or_primary();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parsemultiplicative_operator();
      if (s5 === peg$FAILED) {
        s5 = peg$parseLOGIC_OPERATOR();
      }
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseunary_expr_or_primary();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parsemultiplicative_operator();
        if (s5 === peg$FAILED) {
          s5 = peg$parseLOGIC_OPERATOR();
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseunary_expr_or_primary();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f226(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsemultiplicative_operator() {
    var s0;
    var key = peg$currPos * 463 + 213;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r7.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e138);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseprimary() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 214;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsearray_expr();
    if (s0 === peg$FAILED) {
      s0 = peg$parseaggr_func();
      if (s0 === peg$FAILED) {
        s0 = peg$parsefunc_call();
        if (s0 === peg$FAILED) {
          s0 = peg$parsestruct_expr();
          if (s0 === peg$FAILED) {
            s0 = peg$parsejson_expr();
            if (s0 === peg$FAILED) {
              s0 = peg$parsecast_expr();
              if (s0 === peg$FAILED) {
                s0 = peg$parseliteral();
                if (s0 === peg$FAILED) {
                  s0 = peg$parsecase_expr();
                  if (s0 === peg$FAILED) {
                    s0 = peg$parseinterval_expr();
                    if (s0 === peg$FAILED) {
                      s0 = peg$parsecolumn_ref();
                      if (s0 === peg$FAILED) {
                        s0 = peg$parseparam();
                        if (s0 === peg$FAILED) {
                          s0 = peg$currPos;
                          s1 = peg$parseLPAREN();
                          if (s1 !== peg$FAILED) {
                            s2 = peg$parse__();
                            s3 = peg$parseor_and_where_expr();
                            if (s3 !== peg$FAILED) {
                              s4 = peg$parse__();
                              s5 = peg$parseRPAREN();
                              if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f227(s3);
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunary_expr_or_primary() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 215;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseprimary();
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseunary_operator();
      if (s1 !== peg$FAILED) {
        s2 = peg$currPos;
        s3 = peg$parse__();
        s4 = peg$parseunary_expr_or_primary();
        if (s4 !== peg$FAILED) {
          s3 = [s3, s4];
          s2 = s3;
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f228(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunary_operator() {
    var s0;
    var key = peg$currPos * 463 + 216;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r8.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e139);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseinterval_expr() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 217;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_INTERVAL();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseexpr();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseinterval_unit();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f229(s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecase_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 218;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_CASE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsecase_when_then_list();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsecase_else();
        if (s5 === peg$FAILED) {
          s5 = null;
        }
        s6 = peg$parse__();
        s7 = peg$parseKW_END();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parseKW_CASE();
          if (s9 === peg$FAILED) {
            s9 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f230(s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_CASE();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseexpr();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parsecase_when_then_list();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parsecase_else();
            if (s7 === peg$FAILED) {
              s7 = null;
            }
            s8 = peg$parse__();
            s9 = peg$parseKW_END();
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parseKW_CASE();
              if (s11 === peg$FAILED) {
                s11 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f231(s3, s5, s7);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecase_when_then_list() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 219;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecase_when_then();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = [];
      s4 = peg$currPos;
      s5 = peg$parse__();
      s6 = peg$parsecase_when_then();
      if (s6 !== peg$FAILED) {
        s5 = [s5, s6];
        s4 = s5;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      while (s4 !== peg$FAILED) {
        s3.push(s4);
        s4 = peg$currPos;
        s5 = peg$parse__();
        s6 = peg$parsecase_when_then();
        if (s6 !== peg$FAILED) {
          s5 = [s5, s6];
          s4 = s5;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f232(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecase_when_then() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 220;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_WHEN();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseor_and_where_expr();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_THEN();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseexpr();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f233(s3, s7);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecase_else() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 221;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ELSE();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseexpr();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f234(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_ref() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
    var key = peg$currPos * 463 + 222;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn_without_kw();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseDOT();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsecolumn_without_kw();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          s4 = peg$parse__();
          s5 = peg$parseDOT();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parsecolumn_without_kw();
            if (s7 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parse__();
        s4 = peg$currPos;
        s5 = peg$parsecolumn_offset_expr_list();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$currPos;
          s8 = peg$parseDOT();
          if (s8 !== peg$FAILED) {
            s9 = peg$parse__();
            s10 = peg$parsecolumn_without_kw();
            if (s10 !== peg$FAILED) {
              s8 = [s8, s9, s10];
              s7 = s8;
            } else {
              peg$currPos = s7;
              s7 = peg$FAILED;
            }
          } else {
            peg$currPos = s7;
            s7 = peg$FAILED;
          }
          if (s7 === peg$FAILED) {
            s7 = null;
          }
          s5 = [s5, s6, s7];
          s4 = s5;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 === peg$FAILED) {
          s4 = null;
        }
        peg$savedPos = s0;
        s0 = peg$f235(s1, s2, s4);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsecolumn();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f236(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 223;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsecolumn();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsecolumn();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f237(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident_without_kw_type() {
    var s0, s1;
    var key = peg$currPos * 463 + 224;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_name();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f238(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted_ident_type();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident_type() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 225;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_name();
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$f239(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f240(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted_ident_type();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 226;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_name();
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$f241(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f242(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsequoted_ident();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f243(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsealias_ident() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 227;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn_name();
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$f244(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f245(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsequoted_ident_type();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f246(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsequoted_ident_type() {
    var s0;
    var key = peg$currPos * 463 + 228;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsedouble_quoted_ident();
    if (s0 === peg$FAILED) {
      s0 = peg$parsesingle_quoted_ident();
      if (s0 === peg$FAILED) {
        s0 = peg$parsebackticks_quoted_ident();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsequoted_ident() {
    var s0, s1;
    var key = peg$currPos * 463 + 229;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsedouble_quoted_ident();
    if (s1 === peg$FAILED) {
      s1 = peg$parsesingle_quoted_ident();
      if (s1 === peg$FAILED) {
        s1 = peg$parsebackticks_quoted_ident();
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f247(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedouble_quoted_ident() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 230;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 34) {
      s1 = peg$c131;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e140);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r9.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e141);
        }
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = input.charAt(peg$currPos);
          if (peg$r9.test(s3)) {
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e141);
            }
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 34) {
          s3 = peg$c131;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e140);
          }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f248(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsesingle_quoted_ident() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 231;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 39) {
      s1 = peg$c58;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e58);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r10.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e142);
        }
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = input.charAt(peg$currPos);
          if (peg$r10.test(s3)) {
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e142);
            }
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 39) {
          s3 = peg$c58;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e58);
          }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f249(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsebackticks_quoted_ident() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 232;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 96) {
      s1 = peg$c132;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e143);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r11.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e144);
        }
      }
      if (s3 !== peg$FAILED) {
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = input.charAt(peg$currPos);
          if (peg$r11.test(s3)) {
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e144);
            }
          }
        }
      } else {
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        if (input.charCodeAt(peg$currPos) === 96) {
          s3 = peg$c132;
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e143);
          }
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f250(s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_without_kw() {
    var s0;
    var key = peg$currPos * 463 + 233;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecolumn_name();
    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted_ident();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident_without_kw() {
    var s0;
    var key = peg$currPos * 463 + 234;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseident_name();
    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted_ident();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 235;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecolumn_name();
    if (s1 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s2 = peg$f251(s1);
      if (s2) {
        s2 = peg$FAILED;
      } else {
        s2 = void 0;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f252(s1);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parsequoted_ident();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_name() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 236;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_start();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parsecolumn_part();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parsecolumn_part();
      }
      peg$savedPos = s0;
      s0 = peg$f253(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident_name() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 237;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_start();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$parseident_part();
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$parseident_part();
      }
      peg$savedPos = s0;
      s0 = peg$f254(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident_start() {
    var s0;
    var key = peg$currPos * 463 + 238;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r12.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e145);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseident_part() {
    var s0;
    var key = peg$currPos * 463 + 239;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r13.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e146);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecolumn_part() {
    var s0;
    var key = peg$currPos * 463 + 240;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r14.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e147);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseparam() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 241;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r15.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e148);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parseident_name();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f255(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseaggr_func_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 242;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseaggr_func();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parsealias_clause();
      if (s3 === peg$FAILED) {
        s3 = null;
      }
      s4 = [];
      s5 = peg$currPos;
      s6 = peg$parse__();
      s7 = peg$parseCOMMA();
      if (s7 !== peg$FAILED) {
        s8 = peg$parse__();
        s9 = peg$parseaggr_func();
        if (s9 !== peg$FAILED) {
          s10 = peg$parse__();
          s11 = peg$parsealias_clause();
          if (s11 === peg$FAILED) {
            s11 = null;
          }
          s6 = [s6, s7, s8, s9, s10, s11];
          s5 = s6;
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
      } else {
        peg$currPos = s5;
        s5 = peg$FAILED;
      }
      while (s5 !== peg$FAILED) {
        s4.push(s5);
        s5 = peg$currPos;
        s6 = peg$parse__();
        s7 = peg$parseCOMMA();
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parseaggr_func();
          if (s9 !== peg$FAILED) {
            s10 = peg$parse__();
            s11 = peg$parsealias_clause();
            if (s11 === peg$FAILED) {
              s11 = null;
            }
            s6 = [s6, s7, s8, s9, s10, s11];
            s5 = s6;
          } else {
            peg$currPos = s5;
            s5 = peg$FAILED;
          }
        } else {
          peg$currPos = s5;
          s5 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f256(s1, s3, s4);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseaggr_func() {
    var s0;
    var key = peg$currPos * 463 + 243;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseaggr_fun_count();
    if (s0 === peg$FAILED) {
      s0 = peg$parseaggr_fun_smma();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseaggr_fun_smma() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 244;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_SUM_MAX_MIN_AVG();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseadditive_expr();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseover_partition();
            if (s9 === peg$FAILED) {
              s9 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f257(s1, s5, s9);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SUM_MAX_MIN_AVG() {
    var s0;
    var key = peg$currPos * 463 + 245;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseKW_SUM();
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_MAX();
      if (s0 === peg$FAILED) {
        s0 = peg$parseKW_MIN();
        if (s0 === peg$FAILED) {
          s0 = peg$parseKW_AVG();
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseon_update_current_timestamp() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 246;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ON();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = input.substr(peg$currPos, 6);
      if (s3.toLowerCase() === peg$c84) {
        peg$currPos += 6;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e84);
        }
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseKW_CURRENT_TIMESTAMP();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseLPAREN();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseexpr_list();
            if (s9 === peg$FAILED) {
              s9 = null;
            }
            s10 = peg$parse__();
            s11 = peg$parseRPAREN();
            if (s11 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f258(s5, s9);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_ON();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = input.substr(peg$currPos, 6);
        if (s3.toLowerCase() === peg$c84) {
          peg$currPos += 6;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e84);
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseKW_CURRENT_TIMESTAMP();
          if (s5 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f259(s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseover_partition() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 247;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_OVER();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseas_window_specification();
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f260(s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_OVER();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseLPAREN();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parsepartition_by_clause();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseorder_by_clause();
            if (s7 === peg$FAILED) {
              s7 = null;
            }
            s8 = peg$parse__();
            s9 = peg$parseRPAREN();
            if (s9 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f261(s5, s7);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parseon_update_current_timestamp();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseaggr_fun_count() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 248;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_COUNT();
    if (s1 === peg$FAILED) {
      s1 = input.substr(peg$currPos, 10);
      if (s1.toLowerCase() === peg$c133) {
        peg$currPos += 10;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e149);
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsecount_arg();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseover_partition();
            if (s9 === peg$FAILED) {
              s9 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f262(s1, s5, s9);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecount_arg() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 249;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsestar_expr();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f263(s1);
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_DISTINCT();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            s8 = [];
            s9 = peg$currPos;
            s10 = peg$parse__();
            s11 = peg$parseKW_AND();
            if (s11 === peg$FAILED) {
              s11 = peg$parseKW_OR();
            }
            if (s11 !== peg$FAILED) {
              s12 = peg$parse__();
              s13 = peg$parseexpr();
              if (s13 !== peg$FAILED) {
                s10 = [s10, s11, s12, s13];
                s9 = s10;
              } else {
                peg$currPos = s9;
                s9 = peg$FAILED;
              }
            } else {
              peg$currPos = s9;
              s9 = peg$FAILED;
            }
            while (s9 !== peg$FAILED) {
              s8.push(s9);
              s9 = peg$currPos;
              s10 = peg$parse__();
              s11 = peg$parseKW_AND();
              if (s11 === peg$FAILED) {
                s11 = peg$parseKW_OR();
              }
              if (s11 !== peg$FAILED) {
                s12 = peg$parse__();
                s13 = peg$parseexpr();
                if (s13 !== peg$FAILED) {
                  s10 = [s10, s11, s12, s13];
                  s9 = s10;
                } else {
                  peg$currPos = s9;
                  s9 = peg$FAILED;
                }
              } else {
                peg$currPos = s9;
                s9 = peg$FAILED;
              }
            }
            s9 = peg$parse__();
            s10 = peg$parseorder_by_clause();
            if (s10 === peg$FAILED) {
              s10 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f264(s1, s5, s8, s10);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseKW_DISTINCT();
        if (s1 === peg$FAILED) {
          s1 = null;
        }
        s2 = peg$parse__();
        s3 = peg$parseor_and_expr();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseorder_by_clause();
          if (s5 === peg$FAILED) {
            s5 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f265(s1, s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestar_expr() {
    var s0, s1;
    var key = peg$currPos * 463 + 250;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 42) {
      s1 = peg$c134;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e150);
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f266();
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsefunc_call() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 251;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseextract_func();
    if (s0 === peg$FAILED) {
      s0 = peg$parseany_value_func();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsescalar_func();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseLPAREN();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseexpr_list();
            if (s5 === peg$FAILED) {
              s5 = null;
            }
            s6 = peg$parse__();
            s7 = peg$parseRPAREN();
            if (s7 !== peg$FAILED) {
              s8 = peg$parse__();
              s9 = peg$parseover_partition();
              if (s9 === peg$FAILED) {
                s9 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f267(s1, s5, s9);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsescalar_time_func();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = peg$parseon_update_current_timestamp();
            if (s3 === peg$FAILED) {
              s3 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f268(s1, s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseproc_func_name();
            if (s1 !== peg$FAILED) {
              s2 = peg$parse__();
              s3 = peg$parseLPAREN();
              if (s3 !== peg$FAILED) {
                s4 = peg$parse__();
                s5 = peg$parseor_and_where_expr();
                if (s5 === peg$FAILED) {
                  s5 = null;
                }
                s6 = peg$parse__();
                s7 = peg$parseRPAREN();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse__();
                  s9 = peg$parseover_partition();
                  if (s9 === peg$FAILED) {
                    s9 = null;
                  }
                  peg$savedPos = s0;
                  s0 = peg$f269(s1, s5, s9);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseproc_func_name() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 252;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseident_without_kw_type();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseDOT();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseident_without_kw_type();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseDOT();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseident_without_kw_type();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f270(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsescalar_time_func() {
    var s0;
    var key = peg$currPos * 463 + 253;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseKW_CURRENT_DATE();
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_CURRENT_TIME();
      if (s0 === peg$FAILED) {
        s0 = peg$parseKW_CURRENT_TIMESTAMP();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsescalar_func() {
    var s0;
    var key = peg$currPos * 463 + 254;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsescalar_time_func();
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_SESSION_USER();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseany_value_having() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 255;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_HAVING();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseKW_MAX();
      if (s3 === peg$FAILED) {
        s3 = peg$parseKW_MIN();
      }
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseor_and_where_expr();
        if (s5 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f271(s3, s5);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseany_value_func() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
    var key = peg$currPos * 463 + 256;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c135) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e151);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseor_and_where_expr();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseany_value_having();
          if (s7 === peg$FAILED) {
            s7 = null;
          }
          s8 = peg$parse__();
          s9 = peg$parseRPAREN();
          if (s9 !== peg$FAILED) {
            s10 = peg$parse__();
            s11 = peg$parseover_partition();
            if (s11 === peg$FAILED) {
              s11 = null;
            }
            peg$savedPos = s0;
            s0 = peg$f272(s5, s7, s11);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseextract_filed() {
    var s0, s1;
    var key = peg$currPos * 463 + 257;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 10);
    if (s1.toLowerCase() === peg$c136) {
      peg$currPos += 10;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e152);
      }
    }
    if (s1 === peg$FAILED) {
      s1 = input.substr(peg$currPos, 8);
      if (s1.toLowerCase() === peg$c137) {
        peg$currPos += 8;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e153);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = input.substr(peg$currPos, 10);
        if (s1.toLowerCase() === peg$c138) {
          peg$currPos += 10;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e154);
          }
        }
        if (s1 === peg$FAILED) {
          s1 = input.substr(peg$currPos, 10);
          if (s1.toLowerCase() === peg$c139) {
            peg$currPos += 10;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e155);
            }
          }
          if (s1 === peg$FAILED) {
            s1 = input.substr(peg$currPos, 15);
            if (s1.toLowerCase() === peg$c140) {
              peg$currPos += 15;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e156);
              }
            }
            if (s1 === peg$FAILED) {
              s1 = input.substr(peg$currPos, 11);
              if (s1.toLowerCase() === peg$c141) {
                peg$currPos += 11;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e157);
                }
              }
              if (s1 === peg$FAILED) {
                s1 = input.substr(peg$currPos, 11);
                if (s1.toLowerCase() === peg$c142) {
                  peg$currPos += 11;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e158);
                  }
                }
                if (s1 === peg$FAILED) {
                  s1 = input.substr(peg$currPos, 16);
                  if (s1.toLowerCase() === peg$c143) {
                    peg$currPos += 16;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e159);
                    }
                  }
                  if (s1 === peg$FAILED) {
                    s1 = input.substr(peg$currPos, 13);
                    if (s1.toLowerCase() === peg$c144) {
                      peg$currPos += 13;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$e160);
                      }
                    }
                    if (s1 === peg$FAILED) {
                      s1 = input.substr(peg$currPos, 18);
                      if (s1.toLowerCase() === peg$c145) {
                        peg$currPos += 18;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$e161);
                        }
                      }
                      if (s1 === peg$FAILED) {
                        s1 = input.substr(peg$currPos, 18);
                        if (s1.toLowerCase() === peg$c146) {
                          peg$currPos += 18;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$e162);
                          }
                        }
                        if (s1 === peg$FAILED) {
                          s1 = input.substr(peg$currPos, 13);
                          if (s1.toLowerCase() === peg$c147) {
                            peg$currPos += 13;
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$e163);
                            }
                          }
                          if (s1 === peg$FAILED) {
                            s1 = input.substr(peg$currPos, 15);
                            if (s1.toLowerCase() === peg$c148) {
                              peg$currPos += 15;
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$e164);
                              }
                            }
                            if (s1 === peg$FAILED) {
                              s1 = input.substr(peg$currPos, 7);
                              if (s1.toLowerCase() === peg$c149) {
                                peg$currPos += 7;
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$e165);
                                }
                              }
                              if (s1 === peg$FAILED) {
                                s1 = input.substr(peg$currPos, 9);
                                if (s1.toLowerCase() === peg$c150) {
                                  peg$currPos += 9;
                                } else {
                                  s1 = peg$FAILED;
                                  if (peg$silentFails === 0) {
                                    peg$fail(peg$e166);
                                  }
                                }
                                if (s1 === peg$FAILED) {
                                  s1 = input.substr(peg$currPos, 3);
                                  if (s1.toLowerCase() === peg$c151) {
                                    peg$currPos += 3;
                                  } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) {
                                      peg$fail(peg$e167);
                                    }
                                  }
                                  if (s1 === peg$FAILED) {
                                    s1 = input.substr(peg$currPos, 4);
                                    if (s1.toLowerCase() === peg$c152) {
                                      peg$currPos += 4;
                                    } else {
                                      s1 = peg$FAILED;
                                      if (peg$silentFails === 0) {
                                        peg$fail(peg$e168);
                                      }
                                    }
                                    if (s1 === peg$FAILED) {
                                      s1 = input.substr(peg$currPos, 6);
                                      if (s1.toLowerCase() === peg$c153) {
                                        peg$currPos += 6;
                                      } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) {
                                          peg$fail(peg$e169);
                                        }
                                      }
                                      if (s1 === peg$FAILED) {
                                        s1 = input.substr(peg$currPos, 3);
                                        if (s1.toLowerCase() === peg$c154) {
                                          peg$currPos += 3;
                                        } else {
                                          s1 = peg$FAILED;
                                          if (peg$silentFails === 0) {
                                            peg$fail(peg$e170);
                                          }
                                        }
                                        if (s1 === peg$FAILED) {
                                          s1 = input.substr(peg$currPos, 3);
                                          if (s1.toLowerCase() === peg$c155) {
                                            peg$currPos += 3;
                                          } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) {
                                              peg$fail(peg$e171);
                                            }
                                          }
                                          if (s1 === peg$FAILED) {
                                            s1 = input.substr(peg$currPos, 5);
                                            if (s1.toLowerCase() === peg$c156) {
                                              peg$currPos += 5;
                                            } else {
                                              s1 = peg$FAILED;
                                              if (peg$silentFails === 0) {
                                                peg$fail(peg$e172);
                                              }
                                            }
                                            if (s1 === peg$FAILED) {
                                              s1 = input.substr(peg$currPos, 4);
                                              if (s1.toLowerCase() === peg$c157) {
                                                peg$currPos += 4;
                                              } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) {
                                                  peg$fail(peg$e173);
                                                }
                                              }
                                              if (s1 === peg$FAILED) {
                                                s1 = input.substr(peg$currPos, 6);
                                                if (s1.toLowerCase() === peg$c158) {
                                                  peg$currPos += 6;
                                                } else {
                                                  s1 = peg$FAILED;
                                                  if (peg$silentFails === 0) {
                                                    peg$fail(peg$e174);
                                                  }
                                                }
                                                if (s1 === peg$FAILED) {
                                                  s1 = input.substr(peg$currPos, 7);
                                                  if (s1.toLowerCase() === peg$c159) {
                                                    peg$currPos += 7;
                                                  } else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) {
                                                      peg$fail(peg$e175);
                                                    }
                                                  }
                                                  if (s1 === peg$FAILED) {
                                                    s1 = input.substr(peg$currPos, 7);
                                                    if (s1.toLowerCase() === peg$c160) {
                                                      peg$currPos += 7;
                                                    } else {
                                                      s1 = peg$FAILED;
                                                      if (peg$silentFails === 0) {
                                                        peg$fail(peg$e176);
                                                      }
                                                    }
                                                    if (s1 === peg$FAILED) {
                                                      s1 = input.substr(peg$currPos, 12);
                                                      if (s1.toLowerCase() === peg$c161) {
                                                        peg$currPos += 12;
                                                      } else {
                                                        s1 = peg$FAILED;
                                                        if (peg$silentFails === 0) {
                                                          peg$fail(peg$e177);
                                                        }
                                                      }
                                                      if (s1 === peg$FAILED) {
                                                        s1 = input.substr(peg$currPos, 10);
                                                        if (s1.toLowerCase() === peg$c162) {
                                                          peg$currPos += 10;
                                                        } else {
                                                          s1 = peg$FAILED;
                                                          if (peg$silentFails === 0) {
                                                            peg$fail(peg$e178);
                                                          }
                                                        }
                                                        if (s1 === peg$FAILED) {
                                                          s1 = input.substr(peg$currPos, 12);
                                                          if (s1.toLowerCase() === peg$c163) {
                                                            peg$currPos += 12;
                                                          } else {
                                                            s1 = peg$FAILED;
                                                            if (peg$silentFails === 0) {
                                                              peg$fail(peg$e179);
                                                            }
                                                          }
                                                          if (s1 === peg$FAILED) {
                                                            s1 = input.substr(peg$currPos, 6);
                                                            if (s1.toLowerCase() === peg$c164) {
                                                              peg$currPos += 6;
                                                            } else {
                                                              s1 = peg$FAILED;
                                                              if (peg$silentFails === 0) {
                                                                peg$fail(peg$e180);
                                                              }
                                                            }
                                                            if (s1 === peg$FAILED) {
                                                              s1 = input.substr(peg$currPos, 5);
                                                              if (s1.toLowerCase() === peg$c165) {
                                                                peg$currPos += 5;
                                                              } else {
                                                                s1 = peg$FAILED;
                                                                if (peg$silentFails === 0) {
                                                                  peg$fail(peg$e181);
                                                                }
                                                              }
                                                              if (s1 === peg$FAILED) {
                                                                s1 = input.substr(peg$currPos, 7);
                                                                if (s1.toLowerCase() === peg$c166) {
                                                                  peg$currPos += 7;
                                                                } else {
                                                                  s1 = peg$FAILED;
                                                                  if (peg$silentFails === 0) {
                                                                    peg$fail(peg$e182);
                                                                  }
                                                                }
                                                                if (s1 === peg$FAILED) {
                                                                  s1 = input.substr(peg$currPos, 6);
                                                                  if (s1.toLowerCase() === peg$c167) {
                                                                    peg$currPos += 6;
                                                                  } else {
                                                                    s1 = peg$FAILED;
                                                                    if (peg$silentFails === 0) {
                                                                      peg$fail(peg$e183);
                                                                    }
                                                                  }
                                                                  if (s1 === peg$FAILED) {
                                                                    s1 = input.substr(peg$currPos, 4);
                                                                    if (s1.toLowerCase() === peg$c168) {
                                                                      peg$currPos += 4;
                                                                    } else {
                                                                      s1 = peg$FAILED;
                                                                      if (peg$silentFails === 0) {
                                                                        peg$fail(peg$e184);
                                                                      }
                                                                    }
                                                                    if (s1 === peg$FAILED) {
                                                                      s1 = input.substr(peg$currPos, 8);
                                                                      if (s1.toLowerCase() === peg$c169) {
                                                                        peg$currPos += 8;
                                                                      } else {
                                                                        s1 = peg$FAILED;
                                                                        if (peg$silentFails === 0) {
                                                                          peg$fail(peg$e185);
                                                                        }
                                                                      }
                                                                      if (s1 === peg$FAILED) {
                                                                        s1 = input.substr(peg$currPos, 4);
                                                                        if (s1.toLowerCase() === peg$c170) {
                                                                          peg$currPos += 4;
                                                                        } else {
                                                                          s1 = peg$FAILED;
                                                                          if (peg$silentFails === 0) {
                                                                            peg$fail(peg$e186);
                                                                          }
                                                                        }
                                                                        if (s1 === peg$FAILED) {
                                                                          s1 = input.substr(peg$currPos, 4);
                                                                          if (s1.toLowerCase() === peg$c171) {
                                                                            peg$currPos += 4;
                                                                          } else {
                                                                            s1 = peg$FAILED;
                                                                            if (peg$silentFails === 0) {
                                                                              peg$fail(peg$e187);
                                                                            }
                                                                          }
                                                                        }
                                                                      }
                                                                    }
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f273(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseextract_func() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13;
    var key = peg$currPos * 463 + 258;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_EXTRACT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseextract_filed();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseKW_FROM();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseKW_TIMESTAMP();
            if (s9 === peg$FAILED) {
              s9 = peg$parseKW_INTERVAL();
              if (s9 === peg$FAILED) {
                s9 = peg$parseKW_TIME();
                if (s9 === peg$FAILED) {
                  s9 = peg$parseKW_DATE();
                }
              }
            }
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parseexpr();
              if (s11 !== peg$FAILED) {
                s12 = peg$parse__();
                s13 = peg$parseRPAREN();
                if (s13 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f274(s1, s5, s9, s11);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_EXTRACT();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseLPAREN();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseextract_filed();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseKW_FROM();
            if (s7 !== peg$FAILED) {
              s8 = peg$parse__();
              s9 = peg$parseexpr();
              if (s9 !== peg$FAILED) {
                s10 = peg$parse__();
                s11 = peg$parseRPAREN();
                if (s11 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s0 = peg$f275(s1, s5, s9);
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = input.substr(peg$currPos, 10);
        if (s1.toLowerCase() === peg$c172) {
          peg$currPos += 10;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e188);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseLPAREN();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseexpr();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parseCOMMA();
              if (s7 !== peg$FAILED) {
                s8 = peg$parse__();
                s9 = peg$parseextract_filed();
                if (s9 !== peg$FAILED) {
                  s10 = peg$parse__();
                  s11 = peg$parseRPAREN();
                  if (s11 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s0 = peg$f276(s5, s9);
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecast_keyword() {
    var s0;
    var key = peg$currPos * 463 + 259;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseKW_CAST();
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_SAFE_CAST();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecast_expr() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11, s12, s13, s14, s15, s16, s17, s18, s19, s20, s21;
    var key = peg$currPos * 463 + 260;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsecast_keyword();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parseexpr();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseKW_AS();
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parsedata_type();
            if (s9 !== peg$FAILED) {
              s10 = peg$parse__();
              s11 = peg$parseRPAREN();
              if (s11 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f277(s1, s5, s9);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parsecast_keyword();
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$parseLPAREN();
        if (s3 !== peg$FAILED) {
          s4 = peg$parse__();
          s5 = peg$parseexpr();
          if (s5 !== peg$FAILED) {
            s6 = peg$parse__();
            s7 = peg$parseKW_AS();
            if (s7 !== peg$FAILED) {
              s8 = peg$parse__();
              s9 = peg$parseKW_DECIMAL();
              if (s9 !== peg$FAILED) {
                s10 = peg$parse__();
                s11 = peg$parseLPAREN();
                if (s11 !== peg$FAILED) {
                  s12 = peg$parse__();
                  s13 = peg$parseint();
                  if (s13 !== peg$FAILED) {
                    s14 = peg$parse__();
                    s15 = peg$parseRPAREN();
                    if (s15 !== peg$FAILED) {
                      s16 = peg$parse__();
                      s17 = peg$parseRPAREN();
                      if (s17 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s0 = peg$f278(s1, s5, s13);
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsecast_keyword();
        if (s1 !== peg$FAILED) {
          s2 = peg$parse__();
          s3 = peg$parseLPAREN();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse__();
            s5 = peg$parseexpr();
            if (s5 !== peg$FAILED) {
              s6 = peg$parse__();
              s7 = peg$parseKW_AS();
              if (s7 !== peg$FAILED) {
                s8 = peg$parse__();
                s9 = peg$parseKW_DECIMAL();
                if (s9 !== peg$FAILED) {
                  s10 = peg$parse__();
                  s11 = peg$parseLPAREN();
                  if (s11 !== peg$FAILED) {
                    s12 = peg$parse__();
                    s13 = peg$parseint();
                    if (s13 !== peg$FAILED) {
                      s14 = peg$parse__();
                      s15 = peg$parseCOMMA();
                      if (s15 !== peg$FAILED) {
                        s16 = peg$parse__();
                        s17 = peg$parseint();
                        if (s17 !== peg$FAILED) {
                          s18 = peg$parse__();
                          s19 = peg$parseRPAREN();
                          if (s19 !== peg$FAILED) {
                            s20 = peg$parse__();
                            s21 = peg$parseRPAREN();
                            if (s21 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s0 = peg$f279(s1, s5, s13, s17);
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parsecast_keyword();
          if (s1 !== peg$FAILED) {
            s2 = peg$parse__();
            s3 = peg$parseLPAREN();
            if (s3 !== peg$FAILED) {
              s4 = peg$parse__();
              s5 = peg$parseexpr();
              if (s5 !== peg$FAILED) {
                s6 = peg$parse__();
                s7 = peg$parseKW_AS();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parse__();
                  s9 = peg$parsesignedness();
                  if (s9 !== peg$FAILED) {
                    s10 = peg$parse__();
                    s11 = peg$parseKW_INTEGER();
                    if (s11 === peg$FAILED) {
                      s11 = null;
                    }
                    s12 = peg$parse__();
                    s13 = peg$parseRPAREN();
                    if (s13 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s0 = peg$f280(s1, s5, s9, s11);
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsesignedness() {
    var s0;
    var key = peg$currPos * 463 + 261;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseKW_SIGNED();
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_UNSIGNED();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral() {
    var s0;
    var key = peg$currPos * 463 + 262;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseliteral_string();
    if (s0 === peg$FAILED) {
      s0 = peg$parseliteral_numeric();
      if (s0 === peg$FAILED) {
        s0 = peg$parseliteral_bool();
        if (s0 === peg$FAILED) {
          s0 = peg$parseliteral_null();
          if (s0 === peg$FAILED) {
            s0 = peg$parseliteral_datetime();
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 263;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseliteral();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parseliteral();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseliteral();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f281(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_null() {
    var s0, s1;
    var key = peg$currPos * 463 + 264;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_NULL();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f282();
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_not_null() {
    var s0, s1;
    var key = peg$currPos * 463 + 265;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_NOT_NULL();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f283();
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_bool() {
    var s0, s1;
    var key = peg$currPos * 463 + 266;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_TRUE();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f284();
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_FALSE();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f285();
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_string() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 267;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (s1.toLowerCase() === peg$c173) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e189);
      }
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 39) {
      s4 = peg$c58;
      peg$currPos++;
    } else {
      s4 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e58);
      }
    }
    if (s4 !== peg$FAILED) {
      s5 = [];
      s6 = peg$parsesingle_char();
      while (s6 !== peg$FAILED) {
        s5.push(s6);
        s6 = peg$parsesingle_char();
      }
      if (input.charCodeAt(peg$currPos) === 39) {
        s6 = peg$c58;
        peg$currPos++;
      } else {
        s6 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e58);
        }
      }
      if (s6 !== peg$FAILED) {
        s4 = [s4, s5, s6];
        s3 = s4;
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
    } else {
      peg$currPos = s3;
      s3 = peg$FAILED;
    }
    if (s3 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f286(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = input.charAt(peg$currPos);
      if (s1.toLowerCase() === peg$c173) {
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e189);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      s2 = peg$parse__();
      s3 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 34) {
        s4 = peg$c131;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e140);
        }
      }
      if (s4 !== peg$FAILED) {
        s5 = [];
        s6 = peg$parsesingle_quote_char();
        while (s6 !== peg$FAILED) {
          s5.push(s6);
          s6 = peg$parsesingle_quote_char();
        }
        if (input.charCodeAt(peg$currPos) === 34) {
          s6 = peg$c131;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e140);
          }
        }
        if (s6 !== peg$FAILED) {
          s4 = [s4, s5, s6];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f287(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_datetime() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 268;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_TIME();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_DATE();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_TIMESTAMP();
        if (s1 === peg$FAILED) {
          s1 = peg$parseKW_DATETIME();
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 39) {
        s4 = peg$c58;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e58);
        }
      }
      if (s4 !== peg$FAILED) {
        s5 = [];
        s6 = peg$parsesingle_char();
        while (s6 !== peg$FAILED) {
          s5.push(s6);
          s6 = peg$parsesingle_char();
        }
        if (input.charCodeAt(peg$currPos) === 39) {
          s6 = peg$c58;
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e58);
          }
        }
        if (s6 !== peg$FAILED) {
          s4 = [s4, s5, s6];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f288(s1, s3);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_TIME();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_DATE();
        if (s1 === peg$FAILED) {
          s1 = peg$parseKW_TIMESTAMP();
          if (s1 === peg$FAILED) {
            s1 = peg$parseKW_DATETIME();
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse__();
        s3 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 34) {
          s4 = peg$c131;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e140);
          }
        }
        if (s4 !== peg$FAILED) {
          s5 = [];
          s6 = peg$parsesingle_quote_char();
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = peg$parsesingle_quote_char();
          }
          if (input.charCodeAt(peg$currPos) === 34) {
            s6 = peg$c131;
            peg$currPos++;
          } else {
            s6 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e140);
            }
          }
          if (s6 !== peg$FAILED) {
            s4 = [s4, s5, s6];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f289(s1, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsesingle_quote_char() {
    var s0;
    var key = peg$currPos * 463 + 269;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r16.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e190);
      }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseescape_char();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsesingle_char() {
    var s0;
    var key = peg$currPos * 463 + 270;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r17.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e191);
      }
    }
    if (s0 === peg$FAILED) {
      s0 = peg$parseescape_char();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseescape_char() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 271;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c174) {
      s1 = peg$c174;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e192);
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f290();
    }
    s0 = s1;
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      if (input.substr(peg$currPos, 2) === peg$c175) {
        s1 = peg$c175;
        peg$currPos += 2;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e193);
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f291();
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c176) {
          s1 = peg$c176;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e194);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f292();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c177) {
            s1 = peg$c177;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e195);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f293();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c178) {
              s1 = peg$c178;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e196);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$f294();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c179) {
                s1 = peg$c179;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e197);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$f295();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c180) {
                  s1 = peg$c180;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e198);
                  }
                }
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$f296();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  if (input.substr(peg$currPos, 2) === peg$c181) {
                    s1 = peg$c181;
                    peg$currPos += 2;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e199);
                    }
                  }
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$f297();
                  }
                  s0 = s1;
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c182) {
                      s1 = peg$c182;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$e200);
                      }
                    }
                    if (s1 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$f298();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      if (input.substr(peg$currPos, 2) === peg$c183) {
                        s1 = peg$c183;
                        peg$currPos += 2;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$e201);
                        }
                      }
                      if (s1 !== peg$FAILED) {
                        s2 = peg$parsehexDigit();
                        if (s2 !== peg$FAILED) {
                          s3 = peg$parsehexDigit();
                          if (s3 !== peg$FAILED) {
                            s4 = peg$parsehexDigit();
                            if (s4 !== peg$FAILED) {
                              s5 = peg$parsehexDigit();
                              if (s5 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s0 = peg$f299(s2, s3, s4, s5);
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                      if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 92) {
                          s1 = peg$c184;
                          peg$currPos++;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$e202);
                          }
                        }
                        if (s1 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s1 = peg$f300();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                          s0 = peg$currPos;
                          if (input.substr(peg$currPos, 2) === peg$c185) {
                            s1 = peg$c185;
                            peg$currPos += 2;
                          } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) {
                              peg$fail(peg$e203);
                            }
                          }
                          if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$f301();
                          }
                          s0 = s1;
                          if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c186) {
                              s1 = peg$c186;
                              peg$currPos += 2;
                            } else {
                              s1 = peg$FAILED;
                              if (peg$silentFails === 0) {
                                peg$fail(peg$e204);
                              }
                            }
                            if (s1 !== peg$FAILED) {
                              peg$savedPos = s0;
                              s1 = peg$f302();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                              s0 = peg$currPos;
                              if (input.substr(peg$currPos, 2) === peg$c187) {
                                s1 = peg$c187;
                                peg$currPos += 2;
                              } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) {
                                  peg$fail(peg$e205);
                                }
                              }
                              if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$f303();
                              }
                              s0 = s1;
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseline_terminator() {
    var s0;
    var key = peg$currPos * 463 + 272;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r18.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e206);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseliteral_numeric() {
    var s0, s1;
    var key = peg$currPos * 463 + 273;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsenumber();
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f304(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsenumber() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 274;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseint();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsefrac();
      if (s2 !== peg$FAILED) {
        s3 = peg$parseexp();
        if (s3 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f305(s1, s2, s3);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseint();
      if (s1 !== peg$FAILED) {
        s2 = peg$parsefrac();
        if (s2 !== peg$FAILED) {
          peg$savedPos = s0;
          s0 = peg$f306(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parseint();
        if (s1 !== peg$FAILED) {
          s2 = peg$parseexp();
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f307(s1, s2);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseint();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f308(s1);
          }
          s0 = s1;
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseint() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 275;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsedigits();
    if (s0 === peg$FAILED) {
      s0 = peg$parsedigit();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = input.charAt(peg$currPos);
        if (peg$r6.test(s1)) {
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e137);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = peg$parsedigits();
          if (s2 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f309(s1, s2);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = input.charAt(peg$currPos);
          if (peg$r6.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e137);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parsedigit();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f310(s1, s2);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsefrac() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 276;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 46) {
      s1 = peg$c19;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e19);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parsedigits();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f311(s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexp() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 277;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsee();
    if (s1 !== peg$FAILED) {
      s2 = peg$parsedigits();
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f312(s1, s2);
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedigits() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 278;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = [];
    s2 = peg$parsedigit();
    if (s2 !== peg$FAILED) {
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsedigit();
      }
    } else {
      s1 = peg$FAILED;
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f313(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedigit() {
    var s0;
    var key = peg$currPos * 463 + 279;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r19.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e207);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsehexDigit() {
    var s0;
    var key = peg$currPos * 463 + 280;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r20.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e208);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsee() {
    var s0, s1, s2;
    var key = peg$currPos * 463 + 281;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r21.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e209);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = input.charAt(peg$currPos);
      if (peg$r6.test(s2)) {
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e137);
        }
      }
      if (s2 === peg$FAILED) {
        s2 = null;
      }
      peg$savedPos = s0;
      s0 = peg$f314(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_NULL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 282;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c188) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e210);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DEFAULT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 283;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c21) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e21);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_NOT_NULL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 284;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c189) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e211);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TRUE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 285;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c190) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e212);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TO() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 286;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c191) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e213);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_FALSE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 287;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c192) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e214);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DROP() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 288;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c193) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e215);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f315();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_USE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 289;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c194) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e216);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SELECT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 290;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c195) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e217);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_RECURSIVE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 291;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c196) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e218);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_IGNORE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 292;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c197) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e219);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_EXPLAIN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 293;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c198) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e220);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_PARTITION() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 294;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c199) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e221);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f316();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INTO() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 295;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c200) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e222);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_FROM() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 296;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c201) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e223);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SET() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 297;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c8) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e8);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f317();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNLOCK() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 298;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c202) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e224);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_LOCK() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 299;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c25) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e25);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_AS() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 300;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c110) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e111);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TABLE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 301;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c203) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e225);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f318();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TABLES() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 302;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c204) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e226);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f319();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_COLLATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 303;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c66) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e66);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f320();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ON() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 304;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c205) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e227);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_LEFT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 305;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c206) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e228);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_RIGHT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 306;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c207) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e229);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_FULL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 307;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c208) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e230);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INNER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 308;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c209) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e231);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CROSS() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 309;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c210) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e232);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_JOIN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 310;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c211) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e233);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_OUTER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 311;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c212) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e234);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_OVER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 312;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c213) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e235);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNION() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 313;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c214) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e236);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INTERSECT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 314;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c107) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e108);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_EXCEPT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 315;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c108) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e109);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VALUE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 316;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c215) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e237);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f321();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VALUES() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 317;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c216) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e238);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_USING() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 318;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c217) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e239);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_WHERE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 319;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c218) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e240);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_WITH() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 320;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c75) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e75);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_GROUP() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 321;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c219) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e241);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_BY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 322;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c63) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e63);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ORDER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 323;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c220) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e242);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_HAVING() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 324;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c221) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e243);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_QUALIFY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 325;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c222) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e244);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_WINDOW() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 326;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c223) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e245);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ORDINAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 327;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c224) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e246);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f322();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SAFE_ORDINAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 328;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 12);
    if (s1.toLowerCase() === peg$c225) {
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e247);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f323();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_LIMIT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 329;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c226) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e248);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_OFFSET() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 330;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c227) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e249);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f324();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SAFE_OFFSET() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 331;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 11);
    if (s1.toLowerCase() === peg$c228) {
      peg$currPos += 11;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e250);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f325();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ASC() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 332;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c229) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e251);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f326();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DESC() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 333;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c230) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e252);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f327();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ALL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 334;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c231) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e253);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f328();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DISTINCT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 335;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c232) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e254);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f329();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_BETWEEN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 336;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c233) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e255);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f330();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_IN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 337;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c234) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e256);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f331();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_IS() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 338;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c235) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e257);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f332();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_LIKE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 339;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c236) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e258);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f333();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_EXISTS() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 340;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c237) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e259);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f334();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_NOT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 341;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c71) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e71);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f335();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_AND() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 342;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c238) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e260);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f336();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_OR() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 343;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 2);
    if (s1.toLowerCase() === peg$c239) {
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e261);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f337();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_COUNT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 344;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c240) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e262);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f338();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_MAX() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 345;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c241) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e263);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f339();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_MIN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 346;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c242) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e264);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f340();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SUM() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 347;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c243) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e265);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f341();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_AVG() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 348;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c244) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e266);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f342();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_EXTRACT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 349;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c245) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e267);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f343();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CALL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 350;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c246) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e268);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f344();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CASE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 351;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c247) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e269);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_WHEN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 352;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c248) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e270);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_THEN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 353;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c249) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e271);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ELSE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 354;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c250) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e272);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_END() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 355;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c251) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e273);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        s1 = [s1, s2];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CAST() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 356;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c252) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e274);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f345();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SAFE_CAST() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 357;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c253) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e275);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f346();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ARRAY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 358;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c254) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e276);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f347();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_BYTES() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 359;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c255) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e277);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f348();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_BOOL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 360;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c256) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e278);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f349();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CHAR() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 361;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c257) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e279);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f350();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_GEOGRAPHY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 362;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c258) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e280);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f351();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VARCHAR() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 363;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c259) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e281);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f352();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_NUMERIC() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 364;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c260) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e282);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f353();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DECIMAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 365;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c261) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e283);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f354();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SIGNED() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 366;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c262) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e284);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f355();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNSIGNED() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 367;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c263) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e285);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f356();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INT_64() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 368;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c264) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e286);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f357();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ZEROFILL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 369;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c265) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e287);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f358();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INTEGER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 370;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c266) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e288);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f359();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_JSON() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 371;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c267) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e289);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f360();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SMALLINT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 372;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c268) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e290);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f361();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_STRING() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 373;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c269) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e291);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f362();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_STRUCT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 374;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c270) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e292);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f363();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TINYINT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 375;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c271) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e293);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f364();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TINYTEXT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 376;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c272) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e294);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f365();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TEXT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 377;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c273) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e295);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f366();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_MEDIUMTEXT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 378;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 10);
    if (s1.toLowerCase() === peg$c274) {
      peg$currPos += 10;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e296);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f367();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_LONGTEXT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 379;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c275) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e297);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f368();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_BIGINT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 380;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c276) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e298);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f369();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_FLOAT_64() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 381;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c277) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e299);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f370();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DOUBLE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 382;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c278) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e300);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f371();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 383;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c152) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e168);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f372();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_DATETIME() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 384;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c279) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e301);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f373();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ROWS() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 385;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c117) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e122);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f374();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TIME() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 386;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c168) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e184);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f375();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TIMESTAMP() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 387;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 9);
    if (s1.toLowerCase() === peg$c280) {
      peg$currPos += 9;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e302);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f376();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_TRUNCATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 388;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c281) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e303);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f377();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_USER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 389;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c282) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e304);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f378();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CURRENT_DATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 390;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 12);
    if (s1.toLowerCase() === peg$c283) {
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e305);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f379();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ADD_DATE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 391;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c284) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e306);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f380();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INTERVAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 392;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c285) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e307);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f381();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_YEAR() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 393;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c171) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e187);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f382();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_ISOYEAR() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 394;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c160) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e176);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f383();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_MONTH() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 395;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c165) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e181);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f384();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_DAY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 396;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c151) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e167);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f385();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_HOUR() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 397;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c157) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e173);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f386();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_MINUTE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 398;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c164) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e180);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f387();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_SECOND() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 399;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c167) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e183);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f388();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIT_WEEK() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 400;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c170) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e186);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f389();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CURRENT_TIME() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 401;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 12);
    if (s1.toLowerCase() === peg$c286) {
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e308);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f390();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CURRENT_TIMESTAMP() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 402;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 17);
    if (s1.toLowerCase() === peg$c287) {
      peg$currPos += 17;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e309);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f391();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SESSION_USER() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 403;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 12);
    if (s1.toLowerCase() === peg$c288) {
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e310);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f392();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_GLOBAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 404;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c289) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e311);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f393();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_SESSION() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 405;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c290) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e312);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f394();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_LOCAL() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 406;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c12) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e12);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f395();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_PIVOT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 407;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c291) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e313);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f396();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_PERSIST() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 408;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c292) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e314);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f397();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_PERSIST_ONLY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 409;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 12);
    if (s1.toLowerCase() === peg$c293) {
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e315);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f398();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_VIEW() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 410;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 4);
    if (s1.toLowerCase() === peg$c294) {
      peg$currPos += 4;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e316);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f399();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_ADD() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 411;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c295) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e317);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f400();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_COLUMN() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 412;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c296) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e318);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f401();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_INDEX() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 413;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 5);
    if (s1.toLowerCase() === peg$c297) {
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e319);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f402();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_KEY() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 414;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 3);
    if (s1.toLowerCase() === peg$c31) {
      peg$currPos += 3;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e31);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f403();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_FULLTEXT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 415;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 8);
    if (s1.toLowerCase() === peg$c298) {
      peg$currPos += 8;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e320);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f404();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_UNIQUE() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 416;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 6);
    if (s1.toLowerCase() === peg$c30) {
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e30);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f405();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_COMMENT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 417;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 7);
    if (s1.toLowerCase() === peg$c299) {
      peg$currPos += 7;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e321);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f406();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_CONSTRAINT() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 418;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 10);
    if (s1.toLowerCase() === peg$c300) {
      peg$currPos += 10;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e322);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f407();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseKW_REFERENCES() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 419;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.substr(peg$currPos, 10);
    if (s1.toLowerCase() === peg$c301) {
      peg$currPos += 10;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e323);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$currPos;
      peg$silentFails++;
      s3 = peg$parseident_start();
      peg$silentFails--;
      if (s3 === peg$FAILED) {
        s2 = void 0;
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        peg$savedPos = s0;
        s0 = peg$f408();
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseDOT() {
    var s0;
    var key = peg$currPos * 463 + 420;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 46) {
      s0 = peg$c19;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e19);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseCOMMA() {
    var s0;
    var key = peg$currPos * 463 + 421;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 44) {
      s0 = peg$c302;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e324);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseSTAR() {
    var s0;
    var key = peg$currPos * 463 + 422;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 42) {
      s0 = peg$c134;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e150);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseLPAREN() {
    var s0;
    var key = peg$currPos * 463 + 423;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 40) {
      s0 = peg$c105;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e106);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseRPAREN() {
    var s0;
    var key = peg$currPos * 463 + 424;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 41) {
      s0 = peg$c106;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e107);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseLANGLE() {
    var s0;
    var key = peg$currPos * 463 + 425;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 60) {
      s0 = peg$c303;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e325);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseRANGLE() {
    var s0;
    var key = peg$currPos * 463 + 426;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 62) {
      s0 = peg$c127;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e132);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseLBRAKE() {
    var s0;
    var key = peg$currPos * 463 + 427;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 91) {
      s0 = peg$c304;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e326);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseRBRAKE() {
    var s0;
    var key = peg$currPos * 463 + 428;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 93) {
      s0 = peg$c305;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e327);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseSEMICOLON() {
    var s0;
    var key = peg$currPos * 463 + 429;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.charCodeAt(peg$currPos) === 59) {
      s0 = peg$c306;
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e328);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseOPERATOR_CONCATENATION() {
    var s0;
    var key = peg$currPos * 463 + 430;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.substr(peg$currPos, 2) === peg$c307) {
      s0 = peg$c307;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e329);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseOPERATOR_AND() {
    var s0;
    var key = peg$currPos * 463 + 431;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.substr(peg$currPos, 2) === peg$c308) {
      s0 = peg$c308;
      peg$currPos += 2;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e330);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseLOGIC_OPERATOR() {
    var s0;
    var key = peg$currPos * 463 + 432;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseOPERATOR_CONCATENATION();
    if (s0 === peg$FAILED) {
      s0 = peg$parseOPERATOR_AND();
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parse__() {
    var s0, s1;
    var key = peg$currPos * 463 + 433;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = [];
    s1 = peg$parsewhitespace();
    if (s1 === peg$FAILED) {
      s1 = peg$parsecomment();
    }
    while (s1 !== peg$FAILED) {
      s0.push(s1);
      s1 = peg$parsewhitespace();
      if (s1 === peg$FAILED) {
        s1 = peg$parsecomment();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parse___() {
    var s0, s1;
    var key = peg$currPos * 463 + 434;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = [];
    s1 = peg$parsewhitespace();
    if (s1 === peg$FAILED) {
      s1 = peg$parsecomment();
    }
    if (s1 !== peg$FAILED) {
      while (s1 !== peg$FAILED) {
        s0.push(s1);
        s1 = peg$parsewhitespace();
        if (s1 === peg$FAILED) {
          s1 = peg$parsecomment();
        }
      }
    } else {
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecomment() {
    var s0;
    var key = peg$currPos * 463 + 435;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseblock_comment();
    if (s0 === peg$FAILED) {
      s0 = peg$parseline_comment();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepound_sign_comment();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseblock_comment() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 436;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c309) {
      s1 = peg$c309;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e331);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$currPos;
      peg$silentFails++;
      if (input.substr(peg$currPos, 2) === peg$c310) {
        s5 = peg$c310;
        peg$currPos += 2;
      } else {
        s5 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e332);
        }
      }
      peg$silentFails--;
      if (s5 === peg$FAILED) {
        s4 = void 0;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parsechar();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        if (input.substr(peg$currPos, 2) === peg$c310) {
          s5 = peg$c310;
          peg$currPos += 2;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e332);
          }
        }
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parsechar();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      if (input.substr(peg$currPos, 2) === peg$c310) {
        s3 = peg$c310;
        peg$currPos += 2;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e332);
        }
      }
      if (s3 !== peg$FAILED) {
        s1 = [s1, s2, s3];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseline_comment() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 437;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 2) === peg$c311) {
      s1 = peg$c311;
      peg$currPos += 2;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e333);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$currPos;
      peg$silentFails++;
      s5 = peg$parseEOL();
      peg$silentFails--;
      if (s5 === peg$FAILED) {
        s4 = void 0;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parsechar();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        s5 = peg$parseEOL();
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parsechar();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      s1 = [s1, s2];
      s0 = s1;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsepound_sign_comment() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 438;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 35) {
      s1 = peg$c312;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e334);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$currPos;
      peg$silentFails++;
      s5 = peg$parseEOL();
      peg$silentFails--;
      if (s5 === peg$FAILED) {
        s4 = void 0;
      } else {
        peg$currPos = s4;
        s4 = peg$FAILED;
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parsechar();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$currPos;
        peg$silentFails++;
        s5 = peg$parseEOL();
        peg$silentFails--;
        if (s5 === peg$FAILED) {
          s4 = void 0;
        } else {
          peg$currPos = s4;
          s4 = peg$FAILED;
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parsechar();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      s1 = [s1, s2];
      s0 = s1;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsechar() {
    var s0;
    var key = peg$currPos * 463 + 439;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.length > peg$currPos) {
      s0 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e335);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseinterval_unit() {
    var s0;
    var key = peg$currPos * 463 + 440;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseKW_UNIT_YEAR();
    if (s0 === peg$FAILED) {
      s0 = peg$parseKW_UNIT_ISOYEAR();
      if (s0 === peg$FAILED) {
        s0 = peg$parseKW_UNIT_MONTH();
        if (s0 === peg$FAILED) {
          s0 = peg$parseKW_UNIT_DAY();
          if (s0 === peg$FAILED) {
            s0 = peg$parseKW_UNIT_HOUR();
            if (s0 === peg$FAILED) {
              s0 = peg$parseKW_UNIT_MINUTE();
              if (s0 === peg$FAILED) {
                s0 = peg$parseKW_UNIT_SECOND();
                if (s0 === peg$FAILED) {
                  s0 = peg$parseKW_UNIT_WEEK();
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsewhitespace() {
    var s0;
    var key = peg$currPos * 463 + 441;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = input.charAt(peg$currPos);
    if (peg$r22.test(s0)) {
      peg$currPos++;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e336);
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseEOL() {
    var s0, s1;
    var key = peg$currPos * 463 + 442;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parseEOF();
    if (s0 === peg$FAILED) {
      s0 = [];
      s1 = input.charAt(peg$currPos);
      if (peg$r18.test(s1)) {
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e206);
        }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          s1 = input.charAt(peg$currPos);
          if (peg$r18.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e206);
            }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseEOF() {
    var s0, s1;
    var key = peg$currPos * 463 + 443;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    peg$silentFails++;
    if (input.length > peg$currPos) {
      s1 = input.charAt(peg$currPos);
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e335);
      }
    }
    peg$silentFails--;
    if (s1 === peg$FAILED) {
      s0 = void 0;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedata_type_list() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 444;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parsedata_type_alias();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseCOMMA();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = peg$parsedata_type_alias();
        if (s7 !== peg$FAILED) {
          s4 = [s4, s5, s6, s7];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseCOMMA();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parsedata_type_alias();
          if (s7 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f409(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedata_type_alias() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 445;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseident_name();
    if (s2 !== peg$FAILED) {
      peg$savedPos = peg$currPos;
      s3 = peg$f410(s2);
      if (s3) {
        s3 = peg$FAILED;
      } else {
        s3 = void 0;
      }
      if (s3 !== peg$FAILED) {
        peg$savedPos = s1;
        s1 = peg$f411(s2);
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = null;
    }
    s2 = peg$parse__();
    s3 = peg$parsedata_type();
    if (s3 !== peg$FAILED) {
      peg$savedPos = s0;
      s0 = peg$f412(s1, s3);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedata_type() {
    var s0;
    var key = peg$currPos * 463 + 446;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsestruct_type();
    if (s0 === peg$FAILED) {
      s0 = peg$parsearray_type();
      if (s0 === peg$FAILED) {
        s0 = peg$parsecharacter_string_type();
        if (s0 === peg$FAILED) {
          s0 = peg$parsenumeric_type();
          if (s0 === peg$FAILED) {
            s0 = peg$parsedatetime_type();
            if (s0 === peg$FAILED) {
              s0 = peg$parsebool_byte_geography_type();
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsecharacter_string_type() {
    var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
    var key = peg$currPos * 463 + 447;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_STRING();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      s4 = peg$parse__();
      s5 = peg$parseLPAREN();
      if (s5 !== peg$FAILED) {
        s6 = peg$parse__();
        s7 = [];
        s8 = input.charAt(peg$currPos);
        if (peg$r19.test(s8)) {
          peg$currPos++;
        } else {
          s8 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e207);
          }
        }
        if (s8 !== peg$FAILED) {
          while (s8 !== peg$FAILED) {
            s7.push(s8);
            s8 = input.charAt(peg$currPos);
            if (peg$r19.test(s8)) {
              peg$currPos++;
            } else {
              s8 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e207);
              }
            }
          }
        } else {
          s7 = peg$FAILED;
        }
        if (s7 !== peg$FAILED) {
          s8 = peg$parse__();
          s9 = peg$parseRPAREN();
          if (s9 !== peg$FAILED) {
            s4 = [s4, s5, s6, s7, s8, s9];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        s4 = peg$parse__();
        s5 = peg$parseLPAREN();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = [];
          s8 = input.charAt(peg$currPos);
          if (peg$r19.test(s8)) {
            peg$currPos++;
          } else {
            s8 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e207);
            }
          }
          if (s8 !== peg$FAILED) {
            while (s8 !== peg$FAILED) {
              s7.push(s8);
              s8 = input.charAt(peg$currPos);
              if (peg$r19.test(s8)) {
                peg$currPos++;
              } else {
                s8 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e207);
                }
              }
            }
          } else {
            s7 = peg$FAILED;
          }
          if (s7 !== peg$FAILED) {
            s8 = peg$parse__();
            s9 = peg$parseRPAREN();
            if (s9 !== peg$FAILED) {
              s4 = [s4, s5, s6, s7, s8, s9];
              s3 = s4;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      peg$savedPos = s0;
      s0 = peg$f413(s1, s2);
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsenumeric_type() {
    var s0, s1;
    var key = peg$currPos * 463 + 448;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_NUMERIC();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_INT_64();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_FLOAT_64();
        if (s1 === peg$FAILED) {
          s1 = peg$parseKW_INTEGER();
        }
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f414(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsedatetime_type() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 449;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_DATE();
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_DATETIME();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_TIME();
        if (s1 === peg$FAILED) {
          s1 = peg$parseKW_TIMESTAMP();
        }
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = [];
        s6 = input.charAt(peg$currPos);
        if (peg$r19.test(s6)) {
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e207);
          }
        }
        if (s6 !== peg$FAILED) {
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = input.charAt(peg$currPos);
            if (peg$r19.test(s6)) {
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e207);
              }
            }
          }
        } else {
          s5 = peg$FAILED;
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f415(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    if (s0 === peg$FAILED) {
      s0 = peg$currPos;
      s1 = peg$parseKW_DATE();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_DATETIME();
        if (s1 === peg$FAILED) {
          s1 = peg$parseKW_TIME();
          if (s1 === peg$FAILED) {
            s1 = peg$parseKW_TIMESTAMP();
          }
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$f416(s1);
      }
      s0 = s1;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsebool_byte_geography_type() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 450;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$currPos;
    s2 = peg$parseKW_BYTES();
    if (s2 !== peg$FAILED) {
      s3 = peg$parseLPAREN();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = [];
        s6 = input.charAt(peg$currPos);
        if (peg$r19.test(s6)) {
          peg$currPos++;
        } else {
          s6 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e207);
          }
        }
        if (s6 !== peg$FAILED) {
          while (s6 !== peg$FAILED) {
            s5.push(s6);
            s6 = input.charAt(peg$currPos);
            if (peg$r19.test(s6)) {
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e207);
              }
            }
          }
        } else {
          s5 = peg$FAILED;
        }
        if (s5 === peg$FAILED) {
          if (input.substr(peg$currPos, 3) === peg$c313) {
            s5 = peg$c313;
            peg$currPos += 3;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e337);
            }
          }
          if (s5 === peg$FAILED) {
            if (input.substr(peg$currPos, 3) === peg$c241) {
              s5 = peg$c241;
              peg$currPos += 3;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e338);
              }
            }
          }
        }
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRPAREN();
          if (s7 !== peg$FAILED) {
            s2 = [s2, s3, s4, s5, s6, s7];
            s1 = s2;
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
    } else {
      peg$currPos = s1;
      s1 = peg$FAILED;
    }
    if (s1 === peg$FAILED) {
      s1 = peg$parseKW_BOOL();
      if (s1 === peg$FAILED) {
        s1 = peg$parseKW_GEOGRAPHY();
      }
    }
    if (s1 !== peg$FAILED) {
      peg$savedPos = s0;
      s1 = peg$f417(s1);
    }
    s0 = s1;
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsearray_type() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 451;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_ARRAY();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLANGLE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsedata_type_list();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRANGLE();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f418(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestruct_type() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 452;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseKW_STRUCT();
    if (s1 !== peg$FAILED) {
      s2 = peg$parse__();
      s3 = peg$parseLANGLE();
      if (s3 !== peg$FAILED) {
        s4 = peg$parse__();
        s5 = peg$parsedata_type_list();
        if (s5 !== peg$FAILED) {
          s6 = peg$parse__();
          s7 = peg$parseRANGLE();
          if (s7 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f419(s1, s5);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsevalue() {
    var s0, s1;
    var key = peg$currPos * 463 + 453;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsenumber();
    if (s0 === peg$FAILED) {
      s0 = peg$parsestring();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 4) === peg$c314) {
          s1 = peg$c314;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e339);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f420();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 4) === peg$c315) {
            s1 = peg$c315;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e340);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f421();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 5) === peg$c316) {
              s1 = peg$c316;
              peg$currPos += 5;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e341);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$f422();
            }
            s0 = s1;
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseJSONExpression() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 454;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseidentifier();
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 46) {
        s2 = peg$c19;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e19);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = [];
        s4 = peg$parseidentifier();
        if (s4 === peg$FAILED) {
          s4 = peg$parsestring();
          if (s4 === peg$FAILED) {
            s4 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 91) {
              s5 = peg$c304;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e326);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parsenumber();
              if (s6 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 93) {
                  s7 = peg$c305;
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e327);
                  }
                }
                if (s7 !== peg$FAILED) {
                  s5 = [s5, s6, s7];
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
        }
        while (s4 !== peg$FAILED) {
          s3.push(s4);
          s4 = peg$parseidentifier();
          if (s4 === peg$FAILED) {
            s4 = peg$parsestring();
            if (s4 === peg$FAILED) {
              s4 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 91) {
                s5 = peg$c304;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e326);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parsenumber();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 93) {
                    s7 = peg$c305;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$e327);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    s5 = [s5, s6, s7];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            }
          }
        }
        s1 = [s1, s2, s3];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseJSONFunction() {
    var s0, s1, s2, s3, s4, s5, s6;
    var key = peg$currPos * 463 + 455;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 12) === peg$c317) {
      s1 = peg$c317;
      peg$currPos += 12;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e342);
      }
    }
    if (s1 === peg$FAILED) {
      if (input.substr(peg$currPos, 19) === peg$c318) {
        s1 = peg$c318;
        peg$currPos += 19;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e343);
        }
      }
    }
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c105;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e106);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseexpression();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c302;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e324);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parsestring();
            if (s5 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s6 = peg$c106;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e107);
                }
              }
              if (s6 !== peg$FAILED) {
                s1 = [s1, s2, s3, s4, s5, s6];
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexpression() {
    var s0;
    var key = peg$currPos * 463 + 456;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$parsecolumn_ref();
    if (s0 === peg$FAILED) {
      s0 = peg$parseJSONFunction();
      if (s0 === peg$FAILED) {
        s0 = peg$parsevalue();
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseidentifier() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 457;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = input.charAt(peg$currPos);
    if (peg$r23.test(s1)) {
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e344);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r24.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e345);
        }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r24.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e345);
          }
        }
      }
      s1 = [s1, s2];
      s0 = s1;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsestring() {
    var s0, s1, s2, s3;
    var key = peg$currPos * 463 + 458;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.charCodeAt(peg$currPos) === 39) {
      s1 = peg$c58;
      peg$currPos++;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e58);
      }
    }
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = input.charAt(peg$currPos);
      if (peg$r10.test(s3)) {
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e142);
        }
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = input.charAt(peg$currPos);
        if (peg$r10.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e142);
          }
        }
      }
      if (input.charCodeAt(peg$currPos) === 39) {
        s3 = peg$c58;
        peg$currPos++;
      } else {
        s3 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e58);
        }
      }
      if (s3 !== peg$FAILED) {
        s1 = [s1, s2, s3];
        s0 = s1;
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsearray_expression() {
    var s0, s1, s2, s3, s4, s5, s6, s7;
    var key = peg$currPos * 463 + 459;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 5) === peg$c319) {
      s1 = peg$c319;
      peg$currPos += 5;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e346);
      }
    }
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 60) {
        s2 = peg$c303;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e325);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsetype();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 62) {
            s4 = peg$c127;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e132);
            }
          }
          if (s4 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 40) {
              s5 = peg$c105;
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e106);
              }
            }
            if (s5 !== peg$FAILED) {
              s6 = peg$parseexpression_list();
              if (s6 !== peg$FAILED) {
                if (input.charCodeAt(peg$currPos) === 41) {
                  s7 = peg$c106;
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e107);
                  }
                }
                if (s7 !== peg$FAILED) {
                  s1 = [s1, s2, s3, s4, s5, s6, s7];
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseexpression_list() {
    var s0, s1, s2, s3, s4, s5;
    var key = peg$currPos * 463 + 460;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    s1 = peg$parseexpression();
    if (s1 !== peg$FAILED) {
      s2 = [];
      s3 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 44) {
        s4 = peg$c302;
        peg$currPos++;
      } else {
        s4 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e324);
        }
      }
      if (s4 !== peg$FAILED) {
        s5 = peg$parseexpression();
        if (s5 !== peg$FAILED) {
          s4 = [s4, s5];
          s3 = s4;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      } else {
        peg$currPos = s3;
        s3 = peg$FAILED;
      }
      while (s3 !== peg$FAILED) {
        s2.push(s3);
        s3 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 44) {
          s4 = peg$c302;
          peg$currPos++;
        } else {
          s4 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e324);
          }
        }
        if (s4 !== peg$FAILED) {
          s5 = peg$parseexpression();
          if (s5 !== peg$FAILED) {
            s4 = [s4, s5];
            s3 = s4;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
      }
      s1 = [s1, s2];
      s0 = s1;
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parsetype() {
    var s0;
    var key = peg$currPos * 463 + 461;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    if (input.substr(peg$currPos, 6) === peg$c320) {
      s0 = peg$c320;
      peg$currPos += 6;
    } else {
      s0 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e347);
      }
    }
    if (s0 === peg$FAILED) {
      if (input.substr(peg$currPos, 7) === peg$c321) {
        s0 = peg$c321;
        peg$currPos += 7;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e348);
        }
      }
      if (s0 === peg$FAILED) {
        if (input.substr(peg$currPos, 5) === peg$c322) {
          s0 = peg$c322;
          peg$currPos += 5;
        } else {
          s0 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e349);
          }
        }
        if (s0 === peg$FAILED) {
          if (input.substr(peg$currPos, 7) === peg$c323) {
            s0 = peg$c323;
            peg$currPos += 7;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e350);
            }
          }
          if (s0 === peg$FAILED) {
            if (input.substr(peg$currPos, 4) === peg$c324) {
              s0 = peg$c324;
              peg$currPos += 4;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e351);
              }
            }
            if (s0 === peg$FAILED) {
              if (input.substr(peg$currPos, 8) === peg$c325) {
                s0 = peg$c325;
                peg$currPos += 8;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e352);
                }
              }
              if (s0 === peg$FAILED) {
                if (input.substr(peg$currPos, 9) === peg$c326) {
                  s0 = peg$c326;
                  peg$currPos += 9;
                } else {
                  s0 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$e353);
                  }
                }
              }
            }
          }
        }
      }
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  function peg$parseunnest() {
    var s0, s1, s2, s3, s4;
    var key = peg$currPos * 463 + 462;
    var cached = peg$resultsCache[key];
    if (cached) {
      peg$currPos = cached.nextPos;
      return cached.result;
    }
    s0 = peg$currPos;
    if (input.substr(peg$currPos, 6) === peg$c327) {
      s1 = peg$c327;
      peg$currPos += 6;
    } else {
      s1 = peg$FAILED;
      if (peg$silentFails === 0) {
        peg$fail(peg$e354);
      }
    }
    if (s1 !== peg$FAILED) {
      if (input.charCodeAt(peg$currPos) === 40) {
        s2 = peg$c105;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$e106);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parseexpression();
        if (s3 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 41) {
            s4 = peg$c106;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e107);
            }
          }
          if (s4 !== peg$FAILED) {
            s1 = [s1, s2, s3, s4];
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }
    } else {
      peg$currPos = s0;
      s0 = peg$FAILED;
    }
    peg$resultsCache[key] = { nextPos: peg$currPos, result: s0 };
    return s0;
  }
  const reservedMap = {
    "ARRAY": true,
    "ALTER": true,
    "ALL": true,
    "ADD": true,
    "AND": true,
    "AS": true,
    "ASC": true,
    "BETWEEN": true,
    "BY": true,
    "CALL": true,
    "CASE": true,
    "CREATE": true,
    "CROSS": true,
    "CONTAINS": true,
    "CURRENT_DATE": true,
    "CURRENT_TIME": true,
    "CURRENT_TIMESTAMP": true,
    "CURRENT_USER": true,
    "DELETE": true,
    "DESC": true,
    "DISTINCT": true,
    "DROP": true,
    "ELSE": true,
    "END": true,
    "EXISTS": true,
    "EXPLAIN": true,
    "EXCEPT": true,
    "FALSE": true,
    "FROM": true,
    "FULL": true,
    "FOR": true,
    "GROUP": true,
    "HAVING": true,
    "IN": true,
    "INNER": true,
    "INSERT": true,
    "INTERSECT": true,
    "INTO": true,
    "IS": true,
    "JOIN": true,
    "JSON": true,
    "KEY": false,
    "LEFT": true,
    "LIKE": true,
    "LIMIT": true,
    "LOW_PRIORITY": true,
    // for lock table
    "NOT": true,
    "NULL": true,
    "ON": true,
    "OR": true,
    "ORDER": true,
    "OUTER": true,
    "PARTITION": true,
    "PIVOT": true,
    "RECURSIVE": true,
    "RENAME": true,
    "READ": true,
    // for lock table
    "RIGHT": false,
    "SELECT": true,
    "SESSION_USER": true,
    "SET": true,
    "SHOW": true,
    "SYSTEM_USER": true,
    "TABLE": true,
    "THEN": true,
    "TRUE": true,
    "TRUNCATE": true,
    // 'TYPE': true,   // reserved (MySQL)
    "UNION": true,
    "UPDATE": true,
    "USING": true,
    "VALUES": true,
    "WINDOW": true,
    "WITH": true,
    "WHEN": true,
    "WHERE": true,
    "WRITE": true,
    // for lock table
    "GLOBAL": true,
    // 'SESSION': true,
    "LOCAL": true,
    "PERSIST": true,
    "PERSIST_ONLY": true,
    "UNNEST": true
  };
  const DATA_TYPES = {
    "BOOL": true,
    "BYTE": true,
    "DATE": true,
    "DATETIME": true,
    "FLOAT64": true,
    "INT64": true,
    "NUMERIC": true,
    "STRING": true,
    "TIME": true,
    "TIMESTAMP": true,
    "ARRAY": true,
    "STRUCT": true
  };
  function getLocationObject() {
    return options.includeLocations ? { loc: location() } : {};
  }
  function createUnaryExpr(op, e) {
    return {
      type: "unary_expr",
      operator: op,
      expr: e
    };
  }
  function createBinaryExpr(op, left, right) {
    return __spreadValues({
      type: "binary_expr",
      operator: op,
      left,
      right
    }, getLocationObject());
  }
  function isBigInt(numberStr) {
    const previousMaxSafe = BigInt(Number.MAX_SAFE_INTEGER);
    const num = BigInt(numberStr);
    if (num < previousMaxSafe) return false;
    return true;
  }
  function createList(head, tail, po = 3) {
    const result = [head];
    for (let i = 0; i < tail.length; i++) {
      delete tail[i][po].tableList;
      delete tail[i][po].columnList;
      result.push(tail[i][po]);
    }
    return result;
  }
  function createBinaryExprChain(head, tail) {
    let result = head;
    for (let i = 0; i < tail.length; i++) {
      result = createBinaryExpr(tail[i][1], result, tail[i][3]);
    }
    return result;
  }
  function queryTableAlias(tableName) {
    const alias = tableAlias[tableName];
    if (alias) return alias;
    if (tableName) return tableName;
    return null;
  }
  function columnListTableAlias(columnList2) {
    const newColumnsList = /* @__PURE__ */ new Set();
    const symbolChar = "::";
    for (let column of columnList2.keys()) {
      const columnInfo = column.split(symbolChar);
      if (!columnInfo) {
        newColumnsList.add(column);
        break;
      }
      if (columnInfo && columnInfo[1]) columnInfo[1] = queryTableAlias(columnInfo[1]);
      newColumnsList.add(columnInfo.join(symbolChar));
    }
    return Array.from(newColumnsList);
  }
  function refreshColumnList(columnList2) {
    const columns = columnListTableAlias(columnList2);
    columnList2.clear();
    columns.forEach((col) => columnList2.add(col));
  }
  const cmpPrefixMap = {
    "+": true,
    "-": true,
    "*": true,
    "/": true,
    ">": true,
    "<": true,
    "!": true,
    "=": true,
    //between
    "B": true,
    "b": true,
    //for is or in
    "I": true,
    "i": true,
    //for like
    "L": true,
    "l": true,
    //for not
    "N": true,
    "n": true
  };
  let varList = [];
  const tableList = /* @__PURE__ */ new Set();
  const columnList = /* @__PURE__ */ new Set();
  const tableAlias = {};
  peg$result = peg$startRuleFunction();
  if (options.peg$library) {
    return (
      /** @type {any} */
      {
        peg$result,
        peg$currPos,
        peg$FAILED,
        peg$maxFailExpected,
        peg$maxFailPos
      }
    );
  }
  if (peg$result !== peg$FAILED && peg$currPos === input.length) {
    return peg$result;
  } else {
    if (peg$result !== peg$FAILED && peg$currPos < input.length) {
      peg$fail(peg$endExpectation());
    }
    throw peg$buildStructuredError(
      peg$maxFailExpected,
      peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null,
      peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
    );
  }
}

// src/parser/sql-to-ast.ts
function parseBigQuery(input, databaseType) {
  return peg$parse(input, {});
}
export {
  ASTMapper,
  ExpressionBuilder,
  LexicalAnalyzer,
  ParameterManager,
  QueryBuilder,
  QueryBuilderMode,
  SchemaValidator,
  SyntaxAnalyzer,
  ValidationError,
  ValidationPipeline,
  applyMaybeClause,
  checkIsFromTable,
  conditions,
  crossJoin,
  expressionHandlers,
  from,
  fullJoin,
  getPrimaryTableName,
  groupBy,
  innerJoin,
  isConditionEqual,
  isSelectNode,
  join,
  joinWhere,
  leftJoin,
  orderBy,
  parseBigQuery,
  rightJoin,
  select,
  traverseExpression,
  updateCondition,
  updateOrAddCondition,
  updateTableNameWithQualifyingDataset,
  validConditions,
  valueWrapper,
  where
};
